/**
 * opora-calc-tools.js, Registers all 38 Opora browser calculators (SOW is Opora Edge only).
 * Spec: opora_tools_master_doc.md v0.2.0
 */
(function (global) {
  'use strict';

  var S = global.OporaCalcShared;
  var D = global.OPORA_TOOLS_DATA || {};
  var reg = global.OporaCalc && global.OporaCalc.register;
  if (!reg || !S) return;

  var num = S.num;
  var fmt$ = S.fmt$;
  var fmt$Dollars = S.fmt$Dollars || fmt$;
  var fmtPct = S.fmtPct;
  var capitalizeWords = S.capitalizeWords || function (s) {
    var t = String(s == null ? '' : s).trim();
    if (!t) return '';
    return t.replace(/[A-Za-z][A-Za-z']*/g, function (word) {
      if (word.length <= 4 && word === word.toUpperCase() && /[A-Z]/.test(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  };
  var loanPayment = S.loanPayment;
  var clamp = S.clamp || function (n, lo, hi) { return Math.min(hi, Math.max(lo, n)); };

  var US_STATES = [
    { abbr: 'AL', name: 'Alabama' }, { abbr: 'AK', name: 'Alaska' }, { abbr: 'AZ', name: 'Arizona' },
    { abbr: 'AR', name: 'Arkansas' }, { abbr: 'CA', name: 'California' }, { abbr: 'CO', name: 'Colorado' },
    { abbr: 'CT', name: 'Connecticut' }, { abbr: 'DC', name: 'District of Columbia' }, { abbr: 'DE', name: 'Delaware' },
    { abbr: 'FL', name: 'Florida' }, { abbr: 'GA', name: 'Georgia' }, { abbr: 'HI', name: 'Hawaii' },
    { abbr: 'ID', name: 'Idaho' }, { abbr: 'IL', name: 'Illinois' }, { abbr: 'IN', name: 'Indiana' },
    { abbr: 'IA', name: 'Iowa' }, { abbr: 'KS', name: 'Kansas' }, { abbr: 'KY', name: 'Kentucky' },
    { abbr: 'LA', name: 'Louisiana' }, { abbr: 'ME', name: 'Maine' }, { abbr: 'MD', name: 'Maryland' },
    { abbr: 'MA', name: 'Massachusetts' }, { abbr: 'MI', name: 'Michigan' }, { abbr: 'MN', name: 'Minnesota' },
    { abbr: 'MS', name: 'Mississippi' }, { abbr: 'MO', name: 'Missouri' }, { abbr: 'MT', name: 'Montana' },
    { abbr: 'NE', name: 'Nebraska' }, { abbr: 'NV', name: 'Nevada' }, { abbr: 'NH', name: 'New Hampshire' },
    { abbr: 'NJ', name: 'New Jersey' }, { abbr: 'NM', name: 'New Mexico' }, { abbr: 'NY', name: 'New York' },
    { abbr: 'NC', name: 'North Carolina' }, { abbr: 'ND', name: 'North Dakota' }, { abbr: 'OH', name: 'Ohio' },
    { abbr: 'OK', name: 'Oklahoma' }, { abbr: 'OR', name: 'Oregon' }, { abbr: 'PA', name: 'Pennsylvania' },
    { abbr: 'PR', name: 'Puerto Rico' }, { abbr: 'RI', name: 'Rhode Island' }, { abbr: 'SC', name: 'South Carolina' },
    { abbr: 'SD', name: 'South Dakota' }, { abbr: 'TN', name: 'Tennessee' }, { abbr: 'TX', name: 'Texas' },
    { abbr: 'UT', name: 'Utah' }, { abbr: 'VT', name: 'Vermont' }, { abbr: 'VA', name: 'Virginia' },
    { abbr: 'WA', name: 'Washington' }, { abbr: 'WV', name: 'West Virginia' }, { abbr: 'WI', name: 'Wisconsin' },
    { abbr: 'WY', name: 'Wyoming' }
  ];

  function stateOpts() {
    return US_STATES.map(function (s) { return { value: s.abbr, label: s.name }; });
  }

  function wrap(r, primary) {
    if (!r) return { valid: false, errors: ['Calculation failed.'] };
    if (!r.valid) return r;
    if (!r.primary && primary !== undefined) r.primary = primary;
    return r;
  }

  function chemOpts() {
    return (D.chemistries || []).map(function (c) { return { value: c.id, label: c.name }; });
  }

  /** Shorter closed-select labels so Dilution chemistry doesn't clip mid-word. */
  function chemOptsDilution() {
    var short = {
      Quat: 'Quat (quaternary)',
      Bleach: 'Bleach (NaOCl)',
      Peroxide: 'Hydrogen peroxide',
      Acid: 'Acid cleaner',
      Alkaline: 'Alkaline degreaser',
      Neutral: 'Neutral cleaner',
      Glass: 'Glass cleaner',
      Enzyme: 'Enzyme cleaner',
      Solvent: 'Solvent',
      PAA: 'Peracetic acid (PAA)',
      Iodine: 'Iodine / iodophor',
      Phenolic: 'Phenolic',
      Ammonia: 'Ammonia',
      Alcohol: 'Alcohol',
      Stripper: 'Floor stripper',
      Descaler: 'Descaler'
    };
    var opts = (D.chemistries || []).map(function (c) {
      return { value: c.id, label: short[c.id] || c.name };
    });
    return opts.length ? opts : [
      { value: 'Quat', label: 'Quat (quaternary)' },
      { value: 'Bleach', label: 'Bleach (NaOCl)' },
      { value: 'Neutral', label: 'Neutral cleaner' }
    ];
  }

  function floorTypeOpts() {
    var short = {
      'Sealed concrete (cured >28 d)': 'Sealed concrete',
      'Unsealed/polished concrete': 'Polished / unsealed concrete',
      'Epoxy / urethane coating': 'Epoxy / urethane',
      'VCT — vinyl composition tile': 'VCT',
      'LVT / LVP (luxury vinyl)': 'LVT / LVP',
      'Ceramic / porcelain tile': 'Ceramic / porcelain',
      'Quarry tile (kitchens)': 'Quarry tile (kitchen)',
      'Natural stone — marble / limestone / travertine': 'Marble / limestone',
      'Natural stone — granite': 'Granite',
      'Terrazzo (cementitious)': 'Terrazzo',
      'Hardwood — finished': 'Hardwood — finished',
      'Hardwood — oil-finished': 'Hardwood — oil finish',
      'Rubber sport / mat flooring': 'Rubber sport / mat',
      'Carpet — commercial loop': 'Carpet (commercial)',
      'Resinous self-leveling (MMA / urethane)': 'Resinous (MMA / urethane)',
      'Anti-static / ESD flooring': 'ESD / anti-static',
      'Painted / sealed wood (gym, stage)': 'Painted wood (gym / stage)',
      'Slip-resistant safety flooring (Altro etc.)': 'Safety flooring (Altro)'
    };
    return (D.floor_types || []).map(function (f, i) {
      return { value: String(i), label: short[f.name] || f.name };
    });
  }

  /**
   * Floor Care Program Builder — single source of truth for all 18 substrates.
   * Parent floor_type (index into D.floor_types) drives finish options, chemistry,
   * pads, RPM, equipment guards, surface safety, and the 3-tier maintenance matrix.
   */
  var FLOOR_EQUIP = {
    autoscrubber: { value: 'autoscrubber', label: 'Walk-Behind Auto-Scrubber' },
    rotary175: { value: 'rotary175', label: 'Rotary Floor Machine (175 RPM)' },
    burnisher: { value: 'burnisher', label: 'High-Speed Burnisher (1500-2000 RPM)' },
    dual: { value: 'dual', label: 'Dual-Speed Rotary (175 / 300 RPM)' }
  };

  /** Indexed 0–17 to match OPORA_TOOLS_DATA.floor_types order. */
  var FLOOR_DATABASE = [
    {
      name: 'Sealed concrete',
      finishes: ['Water-based acrylic/epoxy seal', 'Solvent penetrating seal'],
      defaultFinish: 'Water-based acrylic/epoxy seal',
      dailyChem: 'pH 7-9 Neutral synthetic cleaner',
      phRange: '7-9',
      padColors: 'Red / White',
      machineRpm: '175-350 RPM (Scrub only)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'Alkali strippers soften topical seals. Avoid pooling water on saw-cut contraction joints.',
      daily: { cadence: 'Dust-mop 1-2x daily; damp-mop or auto-scrub nightly', toolPad: 'Microfiber / Red pad', procedure: 'Sweep coarse grit. Auto-scrub nightly with neutral cleaner using red pad under low down-pressure.' },
      interim: { cadence: 'Monthly to quarterly', toolPad: 'Red / Blue pad (175 RPM)', procedure: 'Top-scrub to remove embedded soils; rinse completely and apply 1 recoat of compatible concrete sealer.' },
      restorative: { cadence: 'Every 12-24 months', toolPad: 'Black / Brown pad (175 RPM)', procedure: 'Chemical strip using low-odor emulsifier; double-rinse, neutralize to pH 7, and apply 2-3 base coats of acrylic seal.' }
    },
    {
      name: 'Polished / unsealed concrete',
      finishes: ['Densified / lithium polished', 'Mechanically polished bare'],
      defaultFinish: 'Densified / lithium polished',
      dailyChem: 'pH 7-8 Colloidal silica conditioner',
      phRange: '7-8',
      padColors: 'Diamond maintenance pad (1500-3000 grit)',
      machineRpm: '175-1500+ RPM (High-speed burnish approved)',
      burnishAllowed: true,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'burnisher', 'dual'],
      surfaceSafety: 'Acids (pH < 6.0) etch exposed calcium silicate matrix. Quats leave sticky surfactant film that blunts shine.',
      daily: { cadence: 'Continuous dust-mop; auto-scrub nightly', toolPad: 'Diamond maintenance pad (3000 grit)', procedure: 'Dust-mop paths continuously. Auto-scrub with colloidal silica cleaner to strengthen concrete micro-pores.' },
      interim: { cadence: 'Bi-weekly or monthly', toolPad: 'Diamond pad (1500-3000 grit)', procedure: 'High-speed dry burnish at 1500+ RPM to restore DOI (Distinctness of Image) and surface clarity.' },
      restorative: { cadence: 'Every 2-4 years', toolPad: 'Diamond resin discs (400 -> 800 -> 1500 grit)', procedure: 'Progressive wet mechanical honing; apply lithium silicate densifier; polish to designated reflective grit.' }
    },
    {
      name: 'Epoxy / urethane',
      finishes: ['High-solids resin topcoat', 'Non-slip textured aggregate'],
      defaultFinish: 'High-solids resin topcoat',
      dailyChem: 'pH 7-9 Neutral industrial degreaser',
      phRange: '7-9',
      padColors: 'Red / White',
      machineRpm: '175-350 RPM (Scrub only)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'Aromatic solvents soften epoxy topcoats. Highly abrasive pads (black/brown) scratch resin gloss.',
      daily: { cadence: 'Sweep daily; auto-scrub nightly', toolPad: 'Microfiber / Red pad', procedure: 'Sweep particulate. Auto-scrub using neutral degreaser and red pad under medium head-pressure.' },
      interim: { cadence: 'Monthly', toolPad: 'Blue pad / Cylindrical poly brush', procedure: 'Intensive scrub with mild alkaline degreaser (pH 9) to suspend oils; flood rinse and wet-vac recover.' },
      restorative: { cadence: 'Every 3-5 years', toolPad: 'Maroon conditioning pad / Sanding screen', procedure: 'Solvent clean, abrade surface mechanically with conditioning pad, and roll a fresh clear urethane/epoxy wear-layer.' }
    },
    {
      name: 'VCT',
      finishes: ['Traditional acrylic wax finish', 'Bare stripped tile'],
      defaultFinish: 'Traditional acrylic wax finish',
      dailyChem: 'pH 7-9 Neutral floor cleaner',
      phRange: '7-9 daily / 12-13 strip',
      padColors: 'Red (daily), Black (strip), White/Aqua (burnish)',
      machineRpm: '175-350 scrub / 1500-2500 burnish',
      burnishAllowed: true,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'burnisher', 'dual'],
      surfaceSafety: 'Solvents dissolve vinyl tile. Standing water penetrates tile seams, emulsifying subfloor mastic.',
      daily: { cadence: 'Dust-mop 2-3x daily; damp-mop or auto-scrub nightly', toolPad: 'Microfiber / Red pad', procedure: 'Dust-mop traffic lanes. Auto-scrub nightly using neutral cleaner and red pad.' },
      interim: { cadence: 'Weekly burnish / Monthly top-scrub', toolPad: 'Aqua burnish pad (burnish) / Blue pad (scrub)', procedure: 'High-speed burnish at 1500-2000 RPM. Top-scrub heavily soiled paths with blue pad and recoat 1-2 coats finish.' },
      restorative: { cadence: 'Annually or as traffic requires', toolPad: 'Black stripping pad (175 RPM)', procedure: 'Apply chemical floor stripper (pH 12-13), let dwell 10 min, agitate at 175 RPM, extract, neutralize, apply 4-5 coats finish.' }
    },
    {
      name: 'LVT / LVP',
      finishes: ['Factory polyurethane wear-layer', 'Sacrificial matte coating'],
      defaultFinish: 'Factory polyurethane wear-layer',
      dailyChem: 'pH 7-8 Neutral synthetic cleaner',
      phRange: '7-8',
      padColors: 'Red / White (microfiber)',
      machineRpm: '175-350 RPM ONLY (Never burnish)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'High-speed burnishers (1500+ RPM) generate frictional heat that permanently melts and ripples the factory polyurethane wear-layer.',
      daily: { cadence: 'Dust-mop daily; damp-mop or auto-scrub nightly', toolPad: 'Microfiber / Soft red pad', procedure: 'Microfiber dust-mop thoroughly. Auto-scrub with pH-neutral cleaner and soft red pad under light down-pressure.' },
      interim: { cadence: 'Monthly to quarterly', toolPad: 'White pad (175 RPM)', procedure: 'Low-speed spray-buff with white pad and neutral maintainer. If wear appears, apply manufacturer-approved sacrificial matte coating.' },
      restorative: { cadence: 'As needed (traffic dependent)', toolPad: 'Maroon surface prep pad', procedure: 'Deep-clean with neutral cleaner and surface prep pad; reapply specialized ultra-thin LVT protective wear-coating.' }
    },
    {
      name: 'Ceramic / porcelain',
      finishes: ['Unglazed / natural porcelain', 'Glazed ceramic tile'],
      defaultFinish: 'Unglazed / natural porcelain',
      dailyChem: 'pH 7-8 Neutral cleaner (pH 9 for food areas)',
      phRange: '7-8 daily / 2-3 acid descaler',
      padColors: 'Microfiber / Cylindrical brush / White pad',
      machineRpm: '175-350 RPM (No high-speed burnishing)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'Traditional acrylic floor finish does not adhere to impervious porcelain glazes, resulting in flaking and peeling.',
      daily: { cadence: 'Sweep daily; damp-mop or auto-scrub nightly', toolPad: 'Microfiber mop / Cylindrical poly brush', procedure: 'Sweep abrasive grit. Auto-scrub using cylindrical brushes that reach recessed grout joints.' },
      interim: { cadence: 'Monthly to quarterly', toolPad: 'Nylon grout brush / White pad', procedure: 'Apply mild acidic descaler (pH 2-3) to dissolve grout haze and hard-water deposits; thoroughly flood-rinse.' },
      restorative: { cadence: 'Annually', toolPad: 'Cylindrical aggressive brush / Extraction wand', procedure: 'High-pressure enclosed extraction cleaning; reapply fluorochemical penetrating sealer to all grout lines.' }
    },
    {
      name: 'Quarry tile (kitchen)',
      finishes: ['Bare unsealed kiln-fired tile', 'Penetrating silicone sealer'],
      defaultFinish: 'Bare unsealed kiln-fired tile',
      dailyChem: 'pH 9-11 Bio-enzymatic floor cleaner',
      phRange: '9-11',
      padColors: 'Grit brush / Deck scrubbing brush',
      machineRpm: '175 RPM (Heavy rotary scrub)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['rotary175', 'autoscrubber'],
      surfaceSafety: 'Quats and waxes leave sticky residues that saponify with animal fats, producing a hazardous grease slip-layer.',
      daily: { cadence: 'Nightly after kitchen close', toolPad: 'Deck brush / Cylindrical grit brush', procedure: 'Apply bio-enzymatic cleaner; deck-brush aggressively into grout lines; squeegee dirty water directly to floor drains.' },
      interim: { cadence: 'Bi-weekly', toolPad: 'Silicon carbide grit brush (175 RPM)', procedure: 'Heavy foaming alkaline degrease at 175 RPM with grit brush; high-pressure hot water rinse and recovery.' },
      restorative: { cadence: 'Semi-annually', toolPad: 'Grit brush + Acid descaler', procedure: 'Phosphoric acid deep scrub to strip mineralized grease buildup; extract, dry, and reapply penetrating silane impregnator.' }
    },
    {
      name: 'Marble / limestone',
      finishes: ['Polished calcite (high gloss)', 'Honed (satin / matte)'],
      defaultFinish: 'Polished calcite (high gloss)',
      dailyChem: 'pH 7.0 Neutral stone detergent',
      phRange: '7.0 (Strictly neutral)',
      padColors: 'White pad / Diamond pad (1500-3000g)',
      machineRpm: '175-350 RPM (Diamond system)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['rotary175', 'autoscrubber', 'dual'],
      surfaceSafety: 'ANY acidic solution (pH < 6.5) immediately etches calcite stone, leaving dull chemical burns. Quats cause rapid re-soiling.',
      daily: { cadence: 'Dust-mop 3-4x daily; damp-mop nightly', toolPad: 'Microfiber flat-mop', procedure: 'Dust-mop with untreated microfiber continuously. Damp-mop nightly with pH 7.0 neutral stone cleaner.' },
      interim: { cadence: 'Bi-weekly or monthly', toolPad: 'Diamond pad (3000 grit) / White pad', procedure: 'Rotary polish with 3000-grit diamond pad and stone conditioning solution at 175-300 RPM.' },
      restorative: { cadence: 'Annually or as clarity drops', toolPad: 'Diamond resin discs (400 -> 800 -> 1500 -> 3000)', procedure: 'Wet mechanical diamond honing to remove traffic scratches; re-hone through 3000 grit; apply fluoropolymer impregnator.' }
    },
    {
      name: 'Granite',
      finishes: ['Polished (natural gloss)', 'Honed (matte / satin)'],
      defaultFinish: 'Polished (natural gloss)',
      dailyChem: 'pH 7.0 Neutral stone cleaner',
      phRange: '6-9',
      padColors: 'White pad',
      machineRpm: '175-350 RPM (1500+ burnish optional with diamond pad)',
      burnishAllowed: true,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'burnisher', 'dual'],
      surfaceSafety: 'High silica density resists acids better than marble, but prolonged exposure damages feldspar and dulls reflection.',
      daily: { cadence: 'Dust-mop 2-3x daily; auto-scrub or damp-mop nightly', toolPad: 'Microfiber / Soft white pad', procedure: 'Dust-mop traffic lanes. Auto-scrub nightly with pH 7.0 neutral cleaner using soft white pad.' },
      interim: { cadence: 'Monthly', toolPad: 'White pad / Diamond maintenance pad', procedure: 'Rotary polish with white pad and granite polishing paste @ 175-300 RPM to restore mirror depth.' },
      restorative: { cadence: 'Annually', toolPad: 'White pad + Solvent impregnator', procedure: 'Deep-clean with neutral cleaner; apply solvent-based fluoropolymer penetrating impregnator; verify water-bead test.' }
    },
    {
      name: 'Terrazzo',
      finishes: ['Densified / diamond polished', 'Traditional wax finish'],
      defaultFinish: 'Densified / diamond polished',
      dailyChem: 'pH 7.0 Neutral stone cleaner',
      phRange: '7.0 (Neutral)',
      padColors: 'White pad / Diamond maintenance pad',
      machineRpm: '175-1500+ RPM (High-speed burnish approved)',
      burnishAllowed: true,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'burnisher', 'dual'],
      surfaceSafety: 'Cementitious terrazzo binders dissolve under acid exposure. Harsh alkali strippers degrade matrix integrity.',
      daily: { cadence: 'Dust-mop entrance lanes; auto-scrub nightly', toolPad: 'Microfiber / Soft white pad', procedure: 'Microfiber dust-mop regularly. Auto-scrub nightly using neutral cleaner and soft white pad.' },
      interim: { cadence: 'Bi-weekly burnish', toolPad: 'Diamond pad (3000 grit) @ 1500+ RPM', procedure: 'High-speed dry burnish with 3000-grit diamond pad to maintain clarity without applying floor wax.' },
      restorative: { cadence: 'Every 2-3 years', toolPad: 'Diamond resin discs (800 -> 1500 -> 3000)', procedure: 'Step-cut honing with diamond discs to eliminate scratches; apply penetrating impregnating sealer.' }
    },
    {
      name: 'Hardwood — finished',
      finishes: ['Factory polyurethane', 'Site-applied waterborne urethane'],
      defaultFinish: 'Factory polyurethane',
      dailyChem: 'pH 6-8 Neutral wood-safe cleaner',
      phRange: '6-8',
      padColors: 'White (polish) / Red (light clean)',
      machineRpm: '175 RPM ONLY (Never high-speed burnish)',
      burnishAllowed: false,
      autoScrubberAllowed: false,
      allowedEquip: ['rotary175'],
      surfaceSafety: 'Standing water penetrates tongue-and-groove joints, causing swelling and permanent cupping. NEVER use chemical floor stripper.',
      daily: { cadence: 'Dust-mop 1-2x daily; damp flat-mop only as needed', toolPad: 'Microfiber flat-mop (well wrung)', procedure: 'Dry dust-mop with microfiber. Spot-clean traffic lanes with well-wrung microfiber tack mop and wood cleaner.' },
      interim: { cadence: 'Monthly to quarterly', toolPad: 'White pad (175 RPM)', procedure: 'Low-speed dry buff with white pad at 175 RPM to remove heel scuffs. Never wet-scrub.' },
      restorative: { cadence: 'Every 3-7 years', toolPad: 'Abrasive screen disc (120-150 grit)', procedure: 'Screen existing urethane using 120-150 grit mesh screen disc; vacuum dust completely; apply 1-2 coats commercial urethane. Never apply chemical floor stripper or flood with water.' }
    },
    {
      name: 'Hardwood — oil finish',
      finishes: ['Penetrating / hardwax natural oil', 'Raw oiled timber'],
      defaultFinish: 'Penetrating / hardwax natural oil',
      dailyChem: 'Specialized plant-oil nourishing soap',
      phRange: '6-8',
      padColors: 'White pad (dry buffing only)',
      machineRpm: '175 RPM (Low-speed buff)',
      burnishAllowed: false,
      autoScrubberAllowed: false,
      allowedEquip: ['rotary175'],
      surfaceSafety: 'Waterborne urethane cleaners cloud oil finishes. Applying acrylic wax or commercial urethane over penetrating oil causes severe finish peeling.',
      daily: { cadence: 'Daily dry dust-mop; damp-mop only as needed', toolPad: 'Microfiber flat-mop', procedure: 'Daily dry dust-mop. Damp-mop using nourishing plant-oil soap concentrate that replenishes natural oils.' },
      interim: { cadence: 'Monthly or quarterly', toolPad: 'White pad (175 RPM) + Refresher oil', procedure: 'Low-speed rotary buffing (175 RPM) with white pad while buffing liquid maintenance refresher oil into traffic lanes.' },
      restorative: { cadence: 'Every 1-3 years', toolPad: 'Green pad (prep) + White pad (oil buff)', procedure: 'Deep-clean with intensive wood cleaner; let dry completely; buff fresh hardwax maintenance oil deep into timber grain.' }
    },
    {
      name: 'Rubber sport / mat',
      finishes: ['Factory vulcanized smooth', 'Textured acoustic rubber'],
      defaultFinish: 'Factory vulcanized smooth',
      dailyChem: 'pH 7-8.5 Solvent-free rubber conditioner',
      phRange: '7-8.5',
      padColors: 'Red pad / Soft nylon cylindrical brush',
      machineRpm: '175 RPM ONLY (Never burnish)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'Petroleum solvents and citrus terpenes dissolve vulcanized rubber. High-speed pads melt rubber polymers.',
      daily: { cadence: 'Dust-mop or vacuum daily; auto-scrub nightly', toolPad: 'Microfiber / Red pad', procedure: 'Vacuum particulate. Auto-scrub with neutral rubber conditioner and red pad under light down-pressure.' },
      interim: { cadence: 'Monthly', toolPad: 'Cylindrical soft brush (175 RPM)', procedure: 'Scrub with cylindrical machine to extract body oils and sweat salts from textured profile; vacuum dry.' },
      restorative: { cadence: 'Annually', toolPad: 'Red pad + Alkaline degreaser', procedure: 'Deep-scrub with mild alkaline cleaner; rinse thoroughly; apply specialized waterborne rubber restorer.' }
    },
    {
      name: 'Carpet (commercial)',
      finishes: ['Commercial glue-down broadloom', 'Modular carpet tiles'],
      defaultFinish: 'Modular carpet tiles',
      dailyChem: 'CRI-approved polymer encapsulant',
      phRange: '6-8.5',
      padColors: 'Bonnet / Microfiber fiber pad',
      machineRpm: '175 RPM (Oscillating / rotary encaps)',
      burnishAllowed: false,
      autoScrubberAllowed: false,
      allowedEquip: ['rotary175'],
      surfaceSafety: 'Over-wetting causes pile browning, backing delamination, and subfloor microbial growth.',
      daily: { cadence: 'Daily vacuuming; spot cleaning immediately', toolPad: 'Dual-motor commercial upright vacuum', procedure: 'Vacuum high-traffic paths daily. Spot-clean fresh spills immediately with CRI-certified neutral spotter.' },
      interim: { cadence: 'Monthly or quarterly', toolPad: 'Microfiber encapsulation bonnet (175 RPM)', procedure: 'Mist CRI-approved polymer encapsulant; agitate with 175 RPM rotary machine and microfiber bonnet; vacuum crystal residue when dry.' },
      restorative: { cadence: 'Semi-annually or annually', toolPad: 'Hot water extraction wand (CRI-SOA certified)', procedure: 'Pre-spray traffic lanes with traffic pre-conditioner; agitate; hot water extract (water temp under 120 F on synthetic); place air movers.' }
    },
    {
      name: 'Resinous (MMA / urethane)',
      finishes: ['High-build MMA chemical topcoat', 'Quartz aggregate urethane slurry'],
      defaultFinish: 'High-build MMA chemical topcoat',
      dailyChem: 'pH 7-9 Heavy-duty neutral degreaser',
      phRange: '7-9',
      padColors: 'Red pad / Poly scrubbing brush',
      machineRpm: '175-350 RPM (Scrub only)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175', 'dual'],
      surfaceSafety: 'Outstanding chemical resistance; avoid continuous contact with concentrated methylene chloride or aggressive black pads.',
      daily: { cadence: 'Sweep debris; auto-scrub nightly', toolPad: 'Microfiber / Red pad', procedure: 'Sweep debris. Auto-scrub nightly with neutral industrial cleaner and red pad.' },
      interim: { cadence: 'Monthly', toolPad: 'Poly-bristle scrubbing brush (300 RPM)', procedure: 'Heavy scrub with alkaline degreaser and poly brush; vacuum recover.' },
      restorative: { cadence: 'Every 4-6 years', toolPad: 'Diamond grind / 80-grit screen', procedure: 'Mechanically grind degraded topcoat, solvent wipe, and apply fresh MMA chemical wear-layer.' }
    },
    {
      name: 'ESD / anti-static',
      finishes: ['Dissipative coated tile', 'Uncoated conductive vinyl'],
      defaultFinish: 'Dissipative coated tile',
      dailyChem: 'Anti-static ESD-specific neutral cleaner',
      phRange: '6-8 (Verify manufacturer)',
      padColors: 'White (ESD-safe) pad',
      machineRpm: '175 RPM ONLY (Never burnish)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175'],
      surfaceSafety: 'Standard wax, quat disinfectants, and polymer coatings insulate the floor, permanently destroying electrical grounding properties.',
      daily: { cadence: 'Microfiber dust-mop daily; auto-scrub nightly', toolPad: 'Microfiber / Soft white ESD pad', procedure: 'Dust-mop with static-control microfiber. Auto-scrub nightly with specialized ESD cleaner to maintain electrical continuity.' },
      interim: { cadence: 'Monthly to quarterly', toolPad: 'White ESD pad (175 RPM)', procedure: 'Top-scrub with white ESD pad; apply 1 thin coat of static-dissipative zinc-free ESD finish.' },
      restorative: { cadence: 'Annually or as resistance fails', toolPad: 'ESD-safe scrub pad + Neutral stripper', procedure: 'Chemical strip using ESD-safe neutral stripper; verify electrical resistance meets ANSI/ESD STM 7.1 standards.' }
    },
    {
      name: 'Painted wood (gym / stage)',
      finishes: ['MFMA-approved gym finish', 'High-gloss line-painted wood'],
      defaultFinish: 'MFMA-approved gym finish',
      dailyChem: 'MFMA-approved neutral cleaner',
      phRange: '6-8',
      padColors: 'White pad / Tack towel',
      machineRpm: '175 RPM (Dry buffing only)',
      burnishAllowed: false,
      autoScrubberAllowed: false,
      allowedEquip: ['rotary175'],
      surfaceSafety: 'NEVER use auto-scrubbers. Standing water trapped in expansion joints warps gym flooring and voids MFMA warranties.',
      daily: { cadence: 'Microfiber push-mop 3-4x daily; tack nightly', toolPad: 'Microfiber gym broom / Terrycloth tack towel', procedure: 'Push-mop court continuously. Tack court nightly with commercial tack towel dampened with MFMA neutral cleaner.' },
      interim: { cadence: 'Monthly', toolPad: 'White pad (175 RPM)', procedure: 'Dry buff with white pad at 175 RPM to remove sneaker scuffs and restore traction.' },
      restorative: { cadence: 'Annually (summer cycle)', toolPad: 'Maroon conditioning pad / Screen disc', procedure: 'Screen entire court with conditioning pads, clean dust, repaint game lines as needed, and apply fresh coat of MFMA urethane finish.' }
    },
    {
      name: 'Safety flooring (Altro)',
      finishes: ['Carborundum grit-embedded vinyl', 'Bare textured safety vinyl'],
      defaultFinish: 'Carborundum grit-embedded vinyl',
      dailyChem: 'pH 7-9 Alkaline / neutral safety cleaner',
      phRange: '7-9',
      padColors: 'Nylon scrubbing brush (NO PADS)',
      machineRpm: '175 RPM (Cylindrical brush only)',
      burnishAllowed: false,
      autoScrubberAllowed: true,
      allowedEquip: ['autoscrubber', 'rotary175'],
      surfaceSafety: 'Floor pads disintegrate against embedded aluminum oxide grains. Acrylic wax fills textures and destroys the slip-resistance rating.',
      daily: { cadence: 'Sweep debris daily; auto-scrub nightly', toolPad: 'Cylindrical nylon brush', procedure: 'Sweep debris. Auto-scrub with cylindrical nylon brush using safety floor cleaner; vacuum recovery.' },
      interim: { cadence: 'Monthly', toolPad: 'Counter-rotating cylindrical brushes', procedure: 'Deep scrub with counter-rotating cylindrical brushes using alkaline cleaner to lift dirt out of microscopic grain valleys.' },
      restorative: { cadence: 'Annually', toolPad: 'Aggressive green nylon brush (175 RPM)', procedure: 'Heavy agitation scrub with alkaline degreaser and green abrasive brush; vacuum rinse.' }
    }
  ];

  function floorProfile(idx) {
    var i = parseInt(idx, 10);
    if (isNaN(i) || i < 0 || i >= FLOOR_DATABASE.length) i = 8;
    return FLOOR_DATABASE[i];
  }

  function finishOptsForProfile(profile) {
    return (profile.finishes || []).map(function (label) {
      return { value: label, label: label };
    });
  }

  function clampFloorFinish(profile, finish) {
    var want = String(finish || '');
    var finishes = profile.finishes || [];
    if (finishes.indexOf(want) >= 0) return want;
    return profile.defaultFinish || finishes[0] || '';
  }

  function clampFloorEquipment(profile, equip) {
    var want = String(equip || 'rotary175');
    var allowed = profile.allowedEquip || ['rotary175'];
    if (allowed.indexOf(want) >= 0) return want;
    if (allowed.indexOf('rotary175') >= 0) return 'rotary175';
    return allowed[0] || 'rotary175';
  }

  function floorEquipmentWarning(profile, equip, shortName) {
    var want = String(equip || '');
    var label = shortName || profile.name;
    if (!profile.autoScrubberAllowed && want === 'autoscrubber') {
      return 'Auto-scrubbers are prohibited on ' + label + '. Use 175 RPM rotary or microfiber flat-mop only.';
    }
    if (!profile.burnishAllowed && want === 'burnisher') {
      return 'High-speed burnishing is prohibited on ' + label + '. Reverted to a safe 175 RPM baseline.';
    }
    var allowed = profile.allowedEquip || [];
    if (allowed.length && allowed.indexOf(want) < 0) {
      return 'Selected equipment is not approved for ' + label + '. Use an allowed machine from the list.';
    }
    return '';
  }

  function appendFloorSentence(base, extra) {
    var b = String(base || '').replace(/\s+/g, ' ').trim();
    var e = String(extra || '').replace(/\s+/g, ' ').trim();
    if (!e) return b;
    if (!b) return e;
    if (!/[.!?]$/.test(b)) b += '.';
    return b + ' ' + e;
  }

  /**
   * Build Daily / Interim / Restorative program from FLOOR_DATABASE + traffic/equipment levers.
   */
  function buildFloorProgram(idx, traffic, finish, adv) {
    adv = adv || {};
    var profile = floorProfile(idx);
    finish = clampFloorFinish(profile, finish);
    var equip = clampFloorEquipment(profile, adv.equipment);
    var zone = String(adv.zone || '');
    var cadence = String(adv.cadence || '');
    var daily = profile.daily.procedure;
    var interim = profile.interim.procedure;
    var restorative = profile.restorative.procedure;
    var freqDaily = profile.daily.cadence;
    var freqInterim = profile.interim.cadence;
    var freqRest = profile.restorative.cadence;
    var toolDaily = profile.daily.toolPad;
    var toolInterim = profile.interim.toolPad;
    var toolRest = profile.restorative.toolPad;
    var pads = profile.padColors;
    var rpm = profile.machineRpm;
    var chem = profile.dailyChem;
    var noWet = !profile.autoScrubberAllowed;

    if (traffic === 'high') {
      if (noWet) {
        daily = appendFloorSentence(daily, 'High traffic: increase dry dust-mop / tack passes on entrance lanes.');
        freqDaily = appendFloorSentence(freqDaily, 'High traffic intensifies dry passes');
      } else {
        daily = appendFloorSentence(daily, 'High traffic: dust-mop 2-3x/day; auto-scrub or damp-mop nightly.');
        interim = appendFloorSentence(interim, 'Increase interim on entrance lanes.');
        freqInterim = 'Weekly on entrance lanes';
      }
    } else if (traffic === 'med') {
      if (!noWet) daily = appendFloorSentence(daily, 'Medium traffic: dust-mop daily; scrub 3-5x/week.');
    } else {
      if (!noWet) daily = appendFloorSentence(daily, 'Low traffic: dust-mop daily; damp-mop or scrub 1-2x/week.');
    }

    if (equip === 'burnisher' && profile.burnishAllowed) {
      interim = appendFloorSentence(interim, 'Primary machine: high-speed burnisher (1500-2000 RPM) — match pad to finish rating.');
    } else if (equip === 'autoscrubber' && profile.autoScrubberAllowed) {
      daily = appendFloorSentence(daily, 'Primary machine: walk-behind auto-scrubber with soft/neutral pad.');
    } else if (equip === 'rotary175') {
      daily = appendFloorSentence(daily, 'Primary machine: 175 RPM rotary.');
    } else if (equip === 'dual' && (profile.allowedEquip || []).indexOf('dual') >= 0) {
      interim = appendFloorSentence(interim, 'Dual-speed rotary: scrub @ 175, polish @ ~300 RPM where finish allows.');
    }

    if (zone === 'entrance') {
      daily = appendFloorSentence(daily, 'Entrance/lobby focus: increase dust-mop passes and walk-off mat vacs.');
    } else if (zone === 'office' && traffic !== 'low' && profile.autoScrubberAllowed) {
      daily = appendFloorSentence(daily, 'Secondary office: can drop to lower scrub frequency if soil load stays light.');
    }
    if (cadence === 'economy') {
      interim = appendFloorSentence(interim, 'Economy cadence: stretch interim unless soil or gloss loss appears.');
    } else if (cadence === 'premium') {
      interim = appendFloorSentence(interim, 'Class A gloss: keep interim on a fixed weekly calendar for primary lanes.');
      if (traffic !== 'high') freqInterim = '1-2x / week primary lanes';
    }

    return {
      profile: profile,
      finish: finish,
      equipment: equip,
      daily: daily,
      interim: interim,
      restorative: restorative,
      rpm: rpm,
      pads: pads,
      chemistry: chem,
      phRange: profile.phRange,
      surfaceSafety: profile.surfaceSafety,
      matrix: [
        { tier: 'Daily Maintenance', frequency: freqDaily, tool: toolDaily, procedure: daily },
        { tier: 'Interim Maintenance', frequency: freqInterim, tool: toolInterim, procedure: interim },
        { tier: 'Restorative Care', frequency: freqRest, tool: toolRest, procedure: restorative }
      ]
    };
  }


  function taskTypeOpts() {
    var short = {
      'Vacuuming — upright (large open carpet)': 'Upright vacuum (open carpet)',
      'Vacuuming — backpack (detailed/tight areas)': 'Backpack vacuum (detail)',
      'Vacuuming — canister (stairs, detail)': 'Canister vacuum (stairs)',
      'Damp mopping — microfiber (hard floor)': 'Microfiber mop (hard floor)',
      'Damp mopping — string mop (hard floor)': 'String mop (hard floor)',
      'Autoscrubber — 20-inch (corridors/light furniture)': 'Autoscrubber 20-inch',
      'Autoscrubber — 26-inch (large open areas)': 'Autoscrubber 26-inch',
      'Dust mopping — 24-inch (hard floor)': 'Dust mop 24-inch',
      'Dust mopping — 36-inch (large open)': 'Dust mop 36-inch',
      'High-speed burnishing (floor finish)': 'High-speed burnish',
      'Low-speed scrubbing (175 RPM, manual pour)': 'Low-speed scrub (175 RPM)',
      'Floor stripping (VCT, manual method)': 'Floor strip (VCT manual)',
      'Floor finish application (per coat, roller/mop)': 'Floor finish (per coat)',
      'Hot-water extraction (carpet)': 'Hot-water extraction',
      'Encapsulation cleaning (carpet interim)': 'Encapsulation (carpet)',
      'General office cleaning (dust/empty/spot)': 'General office clean',
      'Window/glass cleaning — interior': 'Interior glass'
    };
    return (D.production_rates || []).filter(function (p) { return p.sq_ft_per_hour; }).map(function (p) {
      return { value: p.task_type, label: short[p.task_type] || p.task_type };
    });
  }

  function ppeTaskOpts() {
    var tasks = D.ppe_by_chemistry && D.ppe_by_chemistry.by_task;
    if (!tasks) return [];
    return Object.keys(tasks).map(function (k) { return { value: k, label: k }; });
  }

  function vocCategoryOpts() {
    return (D.voc_limits && D.voc_limits.limits_by_category || []).map(function (c) {
      return { value: c.category, label: c.category };
    });
  }

  function vocStateOpts() {
    return (D.voc_limits && D.voc_limits.jurisdictions || []).map(function (j) {
      return { value: j.state, label: j.state };
    });
  }

  function ppeTaskKeyOpts() {
    return [
      { value: 'dilution', label: 'Diluting / mixing' },
      { value: 'mopping', label: 'Daily mopping' },
      { value: 'disinfection', label: 'Disinfection / terminal' },
      { value: 'stripping', label: 'Floor stripping' },
      { value: 'scrubbing', label: 'Scrub / deep clean' },
      { value: 'restroom', label: 'Restroom cleaning' }
    ];
  }

  function regionOpts() {
    return [
      { value: 'national', label: 'National average' },
      { value: 'northeast', label: 'Northeast (+22% vs National)' },
      { value: 'southeast', label: 'Southeast (−10% vs National)' },
      { value: 'midwest', label: 'Midwest (−5% vs National)' },
      { value: 'southwest', label: 'Southwest (−8% vs National)' },
      { value: 'west', label: 'West (+28% vs National)' }
    ];
  }

  function benchmarkVerticalOpts() {
    return Object.keys(S.SEED_BENCHMARKS).map(function (k) {
      return { value: k, label: S.SEED_BENCHMARKS[k].label };
    });
  }

  // State-level rates + illustrative janitorial taxability. Local add-on is user-entered.
  // taxable:false → tool applies $0 tax (common service-exempt / no state tax).
  var STATE_TAX = {
    AL: { rate: 0.04, taxable: true, statute: 'Ala. Code §40-23-2 (4% state)' },
    AK: { rate: 0, taxable: false, statute: 'No state sales tax (local may apply)' },
    AZ: { rate: 0, taxable: false, statute: 'A.R.S. §42-5061 (services often exempt)' },
    AR: { rate: 0.065, taxable: true, statute: 'Ark. Code §26-52-301' },
    CA: { rate: 0, taxable: false, statute: 'CA Rev. & Tax. Code §6006 (services often exempt)' },
    CO: { rate: 0.029, taxable: true, statute: 'C.R.S. §39-26-104' },
    CT: { rate: 0.0635, taxable: true, statute: 'Conn. Gen. Stat. §12-407' },
    DE: { rate: 0, taxable: false, statute: 'No sales tax' },
    DC: { rate: 0.06, taxable: true, statute: 'D.C. Code §47-2001' },
    FL: { rate: 0, taxable: false, statute: 'FL §212.05 (janitorial often exempt)' },
    GA: { rate: 0, taxable: false, statute: 'O.C.G.A. §48-8-2 (services often exempt)' },
    HI: { rate: 0.04, taxable: true, statute: 'HRS §237-13 (GET)' },
    ID: { rate: 0.06, taxable: true, statute: 'Idaho Code §63-3619' },
    IL: { rate: 0.0625, taxable: true, statute: '35 ILCS 120/2' },
    IN: { rate: 0.07, taxable: true, statute: 'Ind. Code §6-2.5' },
    IA: { rate: 0.06, taxable: true, statute: 'Iowa Code §423.2' },
    KS: { rate: 0.065, taxable: true, statute: 'K.S.A. §79-3603' },
    KY: { rate: 0.06, taxable: true, statute: 'KRS §139.200' },
    LA: { rate: 0.0445, taxable: true, statute: 'La. R.S. 47:302' },
    ME: { rate: 0.055, taxable: true, statute: '36 M.R.S. §1811' },
    MD: { rate: 0.06, taxable: true, statute: 'Md. Code Tax-Gen §11-102' },
    MA: { rate: 0.0625, taxable: true, statute: 'M.G.L. c.64H' },
    MI: { rate: 0.06, taxable: true, statute: 'MCL 205.52' },
    MN: { rate: 0.06875, taxable: true, statute: 'Minn. Stat. §297A.61' },
    MS: { rate: 0.07, taxable: true, statute: 'Miss. Code §27-65-17' },
    MO: { rate: 0.04225, taxable: true, statute: 'RSMo §144.020' },
    MT: { rate: 0, taxable: false, statute: 'No sales tax' },
    NE: { rate: 0.055, taxable: true, statute: 'Neb. Rev. Stat. §77-2703' },
    NV: { rate: 0.0685, taxable: true, statute: 'NRS 372.105' },
    NH: { rate: 0, taxable: false, statute: 'No sales tax' },
    NJ: { rate: 0.06625, taxable: true, statute: 'N.J.S.A. 54:32B-3' },
    NM: { rate: 0.05125, taxable: true, statute: 'NMSA §7-9-3 (GRT)' },
    NY: { rate: 0.04, taxable: true, statute: 'NY Tax Law §1105(c)(5)' },
    NC: { rate: 0.0475, taxable: true, statute: 'N.C.G.S. §105-164.4' },
    ND: { rate: 0.05, taxable: true, statute: 'N.D.C.C. §57-39.2' },
    OH: { rate: 0.0575, taxable: true, statute: 'R.C. §5739.01' },
    OK: { rate: 0.045, taxable: true, statute: '68 O.S. §1354' },
    OR: { rate: 0, taxable: false, statute: 'No sales tax' },
    PA: { rate: 0.06, taxable: true, statute: '72 P.S. §7201(k)(7)' },
    RI: { rate: 0.07, taxable: true, statute: 'R.I. Gen. Laws §44-18-18' },
    SC: { rate: 0.06, taxable: true, statute: 'S.C. Code §12-36-910' },
    SD: { rate: 0.045, taxable: true, statute: 'SDCL §10-45' },
    TN: { rate: 0.07, taxable: true, statute: 'Tenn. Code §67-6-202' },
    TX: { rate: 0.0625, taxable: true, statute: 'TX Tax Code §151.0045' },
    UT: { rate: 0.0485, taxable: true, statute: 'Utah Code §59-12-103' },
    VT: { rate: 0.06, taxable: true, statute: '32 V.S.A. §9771' },
    VA: { rate: 0, taxable: false, statute: 'Va. Code §58.1-609.5 (services often exempt)' },
    WA: { rate: 0.065, taxable: true, statute: 'RCW 82.04.050' },
    WV: { rate: 0.06, taxable: true, statute: 'W. Va. Code §11-15-3' },
    WI: { rate: 0.05, taxable: true, statute: 'Wis. Stat. §77.52' },
    WY: { rate: 0.04, taxable: true, statute: 'Wyo. Stat. §39-15-103' },
    OTHER: { rate: 0.05, taxable: true, statute: 'Verify with state DOR' }
  };

  var LIST_N = [
    { pathogen: 'SARS-CoV-2', product: 'Oxivir Tb', epa: '70627-56', ingredient: 'AHP 0.5%', contact_min: 1, category: 'RTU disinfectant' },
    { pathogen: 'SARS-CoV-2', product: 'Virex II 256', epa: '66171-24', ingredient: 'Quat 1:256', contact_min: 3, category: 'Concentrate disinfectant' },
    { pathogen: 'SARS-CoV-2', product: 'Clorox Healthcare Bleach Wipes', epa: '1839-167', ingredient: 'NaOCl', contact_min: 1, category: 'Wipes' },
    { pathogen: 'Norovirus', product: 'Oxivir 1', epa: '70627-60', ingredient: 'AHP', contact_min: 1, category: 'RTU disinfectant' },
    { pathogen: 'Norovirus', product: 'Clorox Healthcare Fuzion', epa: '67619-30', ingredient: 'NaOCl', contact_min: 1, category: 'RTU disinfectant' },
    { pathogen: 'C. difficile', product: 'Clorox Healthcare Bleach Germicidal', epa: '67619-32', ingredient: 'NaOCl 0.55%', contact_min: 3, category: 'RTU (spore claim)' },
    { pathogen: 'C. difficile', product: 'Oxivir Plus', epa: '70627-24', ingredient: 'AHP + surfactant', contact_min: 5, category: 'RTU (spore claim)' },
    { pathogen: 'Influenza A', product: 'PURELL Surface Spray', epa: '47371-246', ingredient: 'Ethanol 70%', contact_min: 1, category: 'RTU sanitizer' },
    { pathogen: 'Influenza A', product: 'Lysol Disinfectant Spray', epa: '777-99', ingredient: 'Quat + ethanol', contact_min: 3, category: 'Aerosol' },
    { pathogen: 'MRSA', product: 'Ecolab Peroxide Multi-Surface', epa: '1677-249', ingredient: 'H2O2 1%', contact_min: 1, category: 'RTU disinfectant' }
  ];

  var SDS_STUB = [
    { product_name: 'Virex II 256', manufacturer: 'Diversey', sds_url: 'https://diversey.com', hazard: 'Eye irritant; quat sensitizer' },
    { product_name: 'Oxivir Tb', manufacturer: 'Diversey', sds_url: 'https://diversey.com', hazard: 'Oxidizer; eye irritant' },
    { product_name: 'Spartan TB-Cide Quat', manufacturer: 'Spartan Chemical', sds_url: 'https://spartan.com', hazard: 'Quat disinfectant' },
    { product_name: 'Betco Quat Stat 5', manufacturer: 'Betco', sds_url: 'https://betco.com', hazard: 'Quat disinfectant' },
    { product_name: 'Clorox Bleach 12.5%', manufacturer: 'Clorox', sds_url: 'https://clorox.com', hazard: 'Corrosive; oxidizer' },
    { product_name: 'Spartan Bowl Brite', manufacturer: 'Spartan Chemical', sds_url: 'https://spartan.com', hazard: 'Acid cleaner; corrosive' },
    { product_name: 'Betco Untouchable Strip Plus', manufacturer: 'Betco', sds_url: 'https://betco.com', hazard: 'Caustic stripper; MEA' },
    { product_name: 'Diversey Suma Strip D10', manufacturer: 'Diversey', sds_url: 'https://diversey.com', hazard: 'Caustic floor stripper' }
  ];

  /** Map catalog hazard text → executive 3-card profile (class / chemistry / PPE). */
  function resolveSdsProfile(m) {
    var h = String((m && m.hazard) || '').toLowerCase();
    var name = String((m && m.product_name) || '').toLowerCase();
    var blob = h + ' ' + name;
    if (/strip|caustic|mea/.test(blob)) {
      return {
        classLabel: 'Caustic Stripper',
        classSub: 'GHS Category 1 · Severe Hazard',
        classTone: 'bad',
        chemLabel: /mea/.test(h) ? 'MEA (Ethanolamine)' : 'NaOH / KOH / MEA',
        chemSub: 'Alkaline stripping base · pH > 12.0',
        ppeLabel: 'Level 3 Protection',
        ppeSub: 'Gauntlet gloves + splash goggles'
      };
    }
    if (/bleach|hypochlor|chlorine/.test(blob) || (/oxidizer/.test(h) && /corrosive/.test(h))) {
      return {
        classLabel: 'Corrosive / Oxidizer',
        classSub: 'GHS Oxidizer · Corrosive',
        classTone: 'bad',
        chemLabel: 'Sodium Hypochlorite (NaOCl)',
        chemSub: 'Chlorine oxidizer · never mix with acids',
        ppeLabel: 'Level 2 Protection',
        ppeSub: 'Heavy nitrile + wrap-around eye protection'
      };
    }
    if (/acid|bowl|phosphoric|hydrochlor/.test(blob)) {
      return {
        classLabel: 'Acid Descaler',
        classSub: 'Corrosive to metals & skin',
        classTone: 'bad',
        chemLabel: 'Phosphoric / Hydrochloric acid',
        chemSub: 'Restroom descaler · rinse chrome immediately',
        ppeLabel: 'Level 2 Protection',
        ppeSub: 'Splash goggles + acid-resistant gloves'
      };
    }
    if (/quat/.test(blob)) {
      return {
        classLabel: 'Quat Disinfectant',
        classSub: 'Irritant / Sensitizer',
        classTone: 'warn',
        chemLabel: 'Alkyl dimethyl benzyl NH4Cl',
        chemSub: 'Quat active · avoid cotton mop binding',
        ppeLabel: 'Level 1 Protection',
        ppeSub: 'Nitrile exam gloves + side-shield glasses'
      };
    }
    if (/peroxide|h2o2|oxivir|oxidizer/.test(blob)) {
      return {
        classLabel: 'Oxidizer / Peroxide',
        classSub: 'Eye irritant · oxidizing',
        classTone: 'warn',
        chemLabel: 'Hydrogen peroxide (AHP)',
        chemSub: 'Accelerated H2O2 disinfectant',
        ppeLabel: 'Level 1 Protection',
        ppeSub: 'Nitrile gloves + safety glasses'
      };
    }
    return {
      classLabel: 'Chemical Hazard',
      classSub: 'Confirm GHS pictograms on SDS §2',
      classTone: 'warn',
      chemLabel: 'See SDS Section 3',
      chemSub: 'Manufacturer composition',
      ppeLabel: 'Level 2 Protection',
      ppeSub: 'Nitrile gloves + safety glasses'
    };
  }

  var UNION_DATA = [
    { state: 'NY', locality: 'New York City', union: 'SEIU 32BJ', entry: 23.14, top: 28.65, supervisor: 31.20, fringe: 11.50, term: '2024–2028' },
    { state: 'PA', locality: 'Philadelphia', union: 'SEIU 32BJ', entry: 17.25, top: 21.40, supervisor: 23.10, fringe: 10.00, term: '2023–2027' },
    { state: 'DC', locality: 'Washington DC', union: 'SEIU 32BJ', entry: 19.75, top: 23.80, supervisor: 25.50, fringe: 10.50, term: '2023–2026' },
    { state: 'MA', locality: 'Boston', union: 'SEIU 32BJ', entry: 22.10, top: 26.45, supervisor: 28.00, fringe: 11.00, term: '2024–2028' },
    { state: 'CA', locality: 'Los Angeles', union: 'SEIU-USWW', entry: 19.25, top: 22.80, supervisor: 24.10, fringe: 9.50, term: '2022–2026' },
    { state: 'CA', locality: 'San Francisco Bay Area', union: 'SEIU-USWW', entry: 25.15, top: 29.45, supervisor: 31.00, fringe: 10.50, term: '2023–2027' },
    { state: 'IL', locality: 'Chicago', union: 'SEIU Local 1', entry: 18.50, top: 22.10, supervisor: 23.75, fringe: 8.50, term: '2023–2027' },
    { state: 'MI', locality: 'Detroit', union: 'SEIU Local 1', entry: 17.25, top: 21.00, supervisor: 22.50, fringe: 8.00, term: '2023–2027' },
    { state: 'OH', locality: 'Cleveland', union: 'SEIU Local 1', entry: 16.50, top: 19.80, supervisor: 21.00, fringe: 7.50, term: '2022–2026' }
  ];

  /** Curated SCA WD samples for federal / public bids — verify live WD on SAM.gov before pricing. */
  var SCA_SAMPLES = [
    { state: 'FL', locality: 'Miami-Dade County', sca_wage: 14.85, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'FL', locality: 'Orange County (Orlando)', sca_wage: 14.20, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'TX', locality: 'Harris County (Houston)', sca_wage: 13.95, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'TX', locality: 'Dallas County', sca_wage: 13.75, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'GA', locality: 'Fulton County (Atlanta)', sca_wage: 14.10, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'NC', locality: 'Mecklenburg County (Charlotte)', sca_wage: 13.60, hw_fringe: 5.36, wd_note: 'SCA sample · janitorial', as_of: '2026-01' },
    { state: 'NY', locality: 'New York City', sca_wage: 18.40, hw_fringe: 5.36, wd_note: 'SCA sample · federal overlay', as_of: '2026-01' },
    { state: 'PA', locality: 'Philadelphia', sca_wage: 16.25, hw_fringe: 5.36, wd_note: 'SCA sample · federal overlay', as_of: '2026-01' }
  ];

  /** Curated BLS-style market / living-wage floors for open-market recruiting. */
  var MARKET_SAMPLES = [
    { state: 'FL', locality: 'Miami-Dade County', p25: 13.50, median: 15.80, state_min: 13.00, living_wage: 17.25, as_of: '2025 OEWS' },
    { state: 'FL', locality: 'Orange County (Orlando)', p25: 13.25, median: 15.40, state_min: 13.00, living_wage: 16.80, as_of: '2025 OEWS' },
    { state: 'TX', locality: 'Harris County (Houston)', p25: 12.80, median: 14.90, state_min: 7.25, living_wage: 16.50, as_of: '2025 OEWS' },
    { state: 'TX', locality: 'Dallas County', p25: 12.95, median: 15.10, state_min: 7.25, living_wage: 16.75, as_of: '2025 OEWS' },
    { state: 'GA', locality: 'Fulton County (Atlanta)', p25: 13.10, median: 15.25, state_min: 7.25, living_wage: 17.00, as_of: '2025 OEWS' },
    { state: 'NC', locality: 'Mecklenburg County (Charlotte)', p25: 12.90, median: 14.85, state_min: 7.25, living_wage: 16.40, as_of: '2025 OEWS' },
    { state: 'NY', locality: 'New York City', p25: 17.50, median: 20.40, state_min: 16.50, living_wage: 22.00, as_of: '2025 OEWS' },
    { state: 'PA', locality: 'Philadelphia', p25: 14.20, median: 16.80, state_min: 7.25, living_wage: 18.50, as_of: '2025 OEWS' }
  ];

  function unionLocalitiesForState(state) {
    return UNION_DATA.filter(function (u) { return u.state === state; }).map(function (u) {
      return { value: u.locality, label: u.locality };
    });
  }

  function wageFloorRowsForMode(mode, state) {
    var m = String(mode || 'cba').toLowerCase();
    if (m === 'sca') return SCA_SAMPLES.filter(function (u) { return u.state === state; });
    if (m === 'market') return MARKET_SAMPLES.filter(function (u) { return u.state === state; });
    return UNION_DATA.filter(function (u) { return u.state === state; });
  }

  function wageFloorLocalitiesForMode(mode, state) {
    return wageFloorRowsForMode(mode, state).map(function (u) {
      return { value: u.locality, label: u.locality };
    });
  }

  function wageFloorCoveredStateOpts() {
    var seen = {};
    function mark(rows) {
      rows.forEach(function (u) {
        if (seen[u.state]) return;
        seen[u.state] = true;
      });
    }
    mark(UNION_DATA);
    mark(SCA_SAMPLES);
    mark(MARKET_SAMPLES);
    return US_STATES.filter(function (s) { return seen[s.abbr]; }).map(function (s) {
      return { value: s.abbr, label: s.name };
    });
  }

  function defaultWageFloorModeForState(state) {
    if (UNION_DATA.some(function (u) { return u.state === state; })) return 'cba';
    if (SCA_SAMPLES.some(function (u) { return u.state === state; })) return 'sca';
    if (MARKET_SAMPLES.some(function (u) { return u.state === state; })) return 'market';
    return 'cba';
  }

  function unionCoveredStateLabels() {
    var seen = {};
    var labels = [];
    UNION_DATA.forEach(function (u) {
      if (seen[u.state]) return;
      seen[u.state] = true;
      var st = US_STATES.find(function (s) { return s.abbr === u.state; });
      labels.push(st ? st.name : u.state);
    });
    return labels;
  }

  function wageFloorCoveredLabels(mode) {
    var rows = mode === 'sca' ? SCA_SAMPLES : mode === 'market' ? MARKET_SAMPLES : UNION_DATA;
    var seen = {};
    var labels = [];
    rows.forEach(function (u) {
      if (seen[u.state]) return;
      seen[u.state] = true;
      var st = US_STATES.find(function (s) { return s.abbr === u.state; });
      labels.push(st ? st.name : u.state);
    });
    return labels;
  }

  /**
   * Sales Script Picker library.
   * Beats = Open → Reframe → Proof → Ask. Facility swaps proof/ask cues.
   * Tone = Direct | Soft | Executive (static matrix, not LLM).
   */
  var SALES_FACILITY = {
    office: {
      label: 'Office / Commercial',
      proof: 'Most office callbacks come from restrooms, kitchens, and entry glass — we price those with fixture counts and documented APPA Level 2 appearance, not a vague per-sqft hope.',
      ask: 'Can we walk your floors after 5pm and mark what is in vs out of scope before anyone talks discount?'
    },
    medical: {
      label: 'Medical / Healthcare',
      proof: 'In clinical spaces the risk is documentation: terminal cleans, contact times, and who owns what between clinic hours. Cheap bids usually skip that paper trail.',
      ask: 'Can we review your infection-control expectations and map them to a written frequency matrix before we touch price?'
    },
    education: {
      label: 'Education',
      proof: 'Schools fail on restrooms, cafeterias, and after-event resets. We staff those by fixture and event calendar so night crews are not improvising.',
      ask: 'Can we align on which buildings and which event nights are in year one before we revise the number?'
    },
    retail: {
      label: 'Retail / Big-Box',
      proof: 'Retail lives or dies on entry, restrooms, and front-of-house appearance during open hours. We price day presence and night recovery separately so you are not paying night rates for day work.',
      ask: 'Can we split front-of-house vs stockroom scope on a walkthrough so the quote matches how the store actually runs?'
    },
    industrial: {
      label: 'Industrial',
      proof: 'Industrial specs fail on soil load, safety zones, and machine downtime windows — not office polish. We price production areas differently from offices and break rooms.',
      ask: 'Can we mark production vs office zones and downtime windows so the bid matches how the plant actually runs?'
    },
    hospitality: {
      label: 'Hospitality / Hotel',
      proof: 'Hotels lose reviews on restrooms, lobby glass, and turn-down consistency. We price public space vs back-of-house with inspection checkpoints guests actually notice.',
      ask: 'Can we tour public space vs BOH and lock the inspection checklist before we discuss rate?'
    },
    'multi-tenant': {
      label: 'Multi-Tenant',
      proof: 'Multi-tenant work fails when common areas, suite turns, and after-hours access are fuzzy. We separate CAM common areas from tenant suites so one complaint does not rewrite the whole contract.',
      ask: 'Can we list which suites and common areas are in the base contract versus billable extras?'
    }
  };

  var SALES_OBJECTIONS = {
    price: {
      title: 'Price too high',
      tones: {
        direct: {
          open: 'I hear the number. Before we cut it, I want to make sure we are comparing the same work.',
          reframe: 'Most “too expensive” moments are scope clarity moments — different appearance levels and missing tasks look cheaper until the callbacks start.',
          ask: 'Can we line up scope line-by-line against the other quote before anyone discounts?'
        },
        soft: {
          open: 'Totally fair to pressure-test the number — budget matters.',
          reframe: 'Often the gap is what is included night to night, not just the monthly total.',
          ask: 'Would it help if we walked the building together and marked what must stay versus what can phase later?'
        },
        executive: {
          open: 'Understood. Let’s separate price from risk.',
          reframe: 'The cheaper bid usually shifts complaint handling, turnover, and rework back onto your team. We price to keep those off your plate.',
          ask: 'Shall we compare scope, QA, and escalation paths side by side, then decide if the delta is real?'
        }
      }
    },
    incumbent: {
      title: 'Happy with current vendor',
      tones: {
        direct: {
          open: 'Good — switching for sport is a bad idea.',
          reframe: 'The useful test is whether you have a documented scope and inspection trail, or you are relying on the crew “knowing the building.”',
          ask: 'Would a no-obligation walkthrough comparison of scope and inspection reports be worth 15 minutes?'
        },
        soft: {
          open: 'That makes sense — if it is working, keep it.',
          reframe: 'Most of our best clients were fine until they saw what a written frequency matrix and inspection report look like next to tribal knowledge.',
          ask: 'Open to a quiet side-by-side on paper, with no pressure to change vendors?'
        },
        executive: {
          open: 'Loyalty to a vendor that performs is rational.',
          reframe: 'The question for leadership is continuity risk: what happens if that crew leaves, and can you prove scope delivery to stakeholders?',
          ask: 'Can we leave you a documented comparison so procurement has a benchmark when you need it?'
        }
      }
    },
    timing: {
      title: 'Bad timing',
      tones: {
        direct: {
          open: 'Fair — I will not force a decision outside your cycle.',
          reframe: 'Contracts renew on a calendar. The operators who win wait with a ready benchmark, not a cold start in the RFP week.',
          ask: 'What month does the current agreement renew, and can I send a range now so you have data when procurement opens?'
        },
        soft: {
          open: 'Totally fair — timing matters.',
          reframe: 'If I send a benchmark range now, you will have numbers when the window opens instead of rushing a walkthrough under deadline.',
          ask: 'What month does your agreement renew, and who should get the one-pager?'
        },
        executive: {
          open: 'Understood — we will respect the calendar.',
          reframe: 'Procurement moves faster when a defensible range and scope draft already exist. That is planning, not a hard sell.',
          ask: 'May I put a renewal-ready briefing on your calendar for 30 days before the decision window?'
        }
      }
    },
    scope: {
      title: 'Scope too broad',
      tones: {
        direct: {
          open: 'We can shrink year one without pretending the building needs less forever.',
          reframe: 'Phase high-traffic areas and restrooms first, then expand once baseline appearance is stable. That keeps cash predictable.',
          ask: 'Which areas must be excellent in month one, and which can wait until quarter two?'
        },
        soft: {
          open: 'Happy to right-size this — we do not need to boil the ocean on day one.',
          reframe: 'A phased rollout usually means restrooms and entries first, specialty work later, with clear add-order pricing.',
          ask: 'Want me to draft a phase-1 scope and a priced option list for the rest?'
        },
        executive: {
          open: 'We can stage investment against outcomes.',
          reframe: 'Year-one should buy the risk reduction you care about most; year-two options stay explicit so finance is not surprised.',
          ask: 'Which KPI or complaint class should phase one kill first?'
        }
      }
    },
    insurance: {
      title: 'Insurance requirements',
      tones: {
        direct: {
          open: 'We can meet the COI ask — send the limits and additional-insured language.',
          reframe: 'We carry GL $2M/$4M aggregate, auto $1M, and workers’ comp per state. Risk managers care about certificates that match the contract, not verbal assurances.',
          ask: 'Who is the risk contact, and can I have the COI to them within 24 hours?'
        },
        soft: {
          open: 'Insurance is a fair gate — we treat it as part of onboarding, not a surprise.',
          reframe: 'We keep current GL, auto, and WC certificates ready and can name your entity as additional insured when the contract requires it.',
          ask: 'Want me to email the specimen COI to your risk manager today?'
        },
        executive: {
          open: 'We will clear risk requirements before kickoff.',
          reframe: 'Limits, endorsements, and cancellation notice belong in the packet with the scope — not as a week-one scramble.',
          ask: 'Please forward the insurance exhibit; we will confirm match or gap in writing within one business day.'
        }
      }
    },
    three_bids: {
      title: 'Need three bids',
      tones: {
        direct: {
          open: 'Understood — you need a competitive set.',
          reframe: 'Three bids only help if the scope is identical. Otherwise you are comparing different jobs dressed as the same RFP.',
          ask: 'Can we lock a shared scope packet so every bidder prices the same building, then I will still compete on delivery?'
        },
        soft: {
          open: 'Happy to be one of three — that is how good buying works.',
          reframe: 'The trap is apples-to-oranges scopes. A one-page frequency matrix keeps everyone honest.',
          ask: 'May I help you draft the scope sheet the other vendors will also use?'
        },
        executive: {
          open: 'We support a formal competitive process.',
          reframe: 'Governance needs comparable bids. We will price the published scope and note any exclusions clearly.',
          ask: 'Share the bid instructions and due date; we will submit a complete, comparable package.'
        }
      }
    },
    in_house: {
      title: 'We clean in-house',
      tones: {
        direct: {
          open: 'In-house can work — especially if supervision and coverage are solid.',
          reframe: 'The hidden cost is absenteeism, training, and after-hours coverage. Outsourcing is often about reliability, not just hourly rate.',
          ask: 'Want a side-by-side of loaded in-house cost versus a contracted night crew for the same appearance level?'
        },
        soft: {
          open: 'Keeping it in-house is a real option — no argument there.',
          reframe: 'Teams usually revisit it when vacations, call-outs, or specialty floors stretch the staff.',
          ask: 'Open to a quiet cost and coverage comparison you can keep on file?'
        },
        executive: {
          open: 'Insourcing is a strategic choice, not a default.',
          reframe: 'The decision should include fully loaded labor, supervision span, and continuity risk — not wage alone.',
          ask: 'Shall we build a make-vs-buy brief your leadership can review in one sitting?'
        }
      }
    },
    decision_maker: {
      title: 'Decision-maker not here',
      tones: {
        direct: {
          open: 'No problem — I will not ask you to commit for someone else.',
          reframe: 'What helps the decision-maker is a one-page scope, range, and next step — not another vague brochure.',
          ask: 'Who owns the decision, and can I send a one-pager they can forward with your notes?'
        },
        soft: {
          open: 'Totally fine — happy to support whoever needs to weigh in.',
          reframe: 'Most deals stall when the internal handoff is thin. A short brief with numbers travels better than a long pitch.',
          ask: 'What is the best way to get a clean summary to them this week?'
        },
        executive: {
          open: 'Understood — we will equip the sponsor, not pressure the room.',
          reframe: 'Decision packets should include scope, price band, risk notes, and a clear ask for a walkthrough or pilot.',
          ask: 'Name the economic buyer and I will send a decision brief sized for a five-minute read.'
        }
      }
    },
    too_small: {
      title: 'Account feels too small / too big',
      tones: {
        direct: {
          open: 'Fit matters — wrong-sized accounts burn both sides.',
          reframe: 'If we are light for your footprint we will say so; if we are right-sized we will show crew math, not slogans.',
          ask: 'Can we confirm cleanable sqft, nights per week, and must-hit areas so we both know if this is a fit?'
        },
        soft: {
          open: 'Good instinct to check fit before anyone wastes time.',
          reframe: 'We would rather qualify honestly than stretch a crew across a building we cannot staff well.',
          ask: 'Want a quick fit check on hours and coverage before we draft a full bid?'
        },
        executive: {
          open: 'Capacity and complexity have to match.',
          reframe: 'We underwrite accounts by hours, supervision, and specialty risk — not logo hunting.',
          ask: 'Share the operating constraints and we will confirm pursue / pass with reasons in writing.'
        }
      }
    }
  };

  function salesPartsToText(parts) {
    return (parts || []).map(function (p) { return p && p.t != null ? String(p.t) : ''; }).join('');
  }

  function salesBeat(title, parts, titleHl) {
    return {
      title: title,
      titleHl: titleHl || '',
      detail: salesPartsToText(parts),
      parts: parts
    };
  }

  function formatSalesPriceBand(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    // Already a polished corridor or labeled range — keep
    if (/\$\s*[\d,]+\s*[–—\-]\s*\$\s*[\d,]+/i.test(s) && /\/\s*mo|per\s*month/i.test(s)) {
      return s.replace(/\s*[—\-]\s*/g, '–');
    }
    var cleaned = s.replace(/[$,]/g, '').trim();
    // Corridor: 2000-2500 | 2000 – 2500 | 2000 to 2500
    var range = cleaned.match(/^(\d+(?:\.\d+)?)\s*(?:[-–—]|to)\s*(\d+(?:\.\d+)?)$/i);
    if (range) {
      var lo = parseFloat(range[1]);
      var hi = parseFloat(range[2]);
      if (!isNaN(lo) && !isNaN(hi) && isFinite(lo) && isFinite(hi) && lo > 0 && hi > 0) {
        if (hi < lo) {
          var swap = lo;
          lo = hi;
          hi = swap;
        }
        return '$' + Math.round(lo).toLocaleString('en-US') + '–$' +
          Math.round(hi).toLocaleString('en-US') + '/mo';
      }
    }
    if (/\$/.test(s) || /\/\s*mo|per\s*month|range|\bto\b/i.test(s)) return s;
    var n = parseFloat(cleaned);
    if (!isNaN(n) && isFinite(n) && n > 0) {
      return '$' + Math.round(n).toLocaleString('en-US') + '/mo';
    }
    return s;
  }

  var SALES_CONTACT_REFRAME = {
    facility_mgr:
      ' Lead with SLA adherence, billing transparency, and square-foot yield — that is what property and facility managers defend to ownership.',
    store_gm:
      ' Lead with open-hours appearance, entry/restroom scores, and corporate inspection risk — that is what store and GM leads get measured on.',
    procurement:
      ' Lead with documented scope, comparable unit economics, and change-order control — that is what procurement needs to defend the award.'
  };
  var SALES_CONTACT_LABELS = {
    facility_mgr: 'Property / Facility Manager',
    store_gm: 'General Manager / Store Lead',
    procurement: 'Procurement Officer'
  };

  function buildSalesScript(inputs) {
    var objKey = inputs.objection_type || 'price';
    var obj = SALES_OBJECTIONS[objKey] || SALES_OBJECTIONS.price;
    var toneKey = inputs.tone || 'direct';
    if (!obj.tones[toneKey]) toneKey = 'direct';
    var beats = obj.tones[toneKey];
    var facKey = inputs.facility_type || 'office';
    var fac = SALES_FACILITY[facKey] || SALES_FACILITY.office;
    var company = capitalizeWords(inputs.company_name);
    var priceBand = formatSalesPriceBand(inputs.price_band);
    var renewal = capitalizeWords(inputs.renewal_month);
    var contactKey = String(inputs.contact_role || 'facility_mgr');
    if (!SALES_CONTACT_REFRAME[contactKey]) contactKey = 'facility_mgr';
    var contactLabel = SALES_CONTACT_LABELS[contactKey] || SALES_CONTACT_LABELS.facility_mgr;

    var openParts;
    var askParts;

    // Timing objection: OPEN/ASK must not contradict when renewal month is already known
    if (objKey === 'timing') {
      if (renewal) {
        openParts = [
          { t: 'Totally fair — timing matters. Since your contract renews in ' },
          { t: renewal, hl: true },
          { t: ', this is the window to compare written scope against current delivery — not just familiarity.' }
        ];
        askParts = [
          { t: 'With ' },
          { t: renewal, hl: true },
          { t: ' on the calendar, facilities teams typically review specs 60 days out. Who on your team should receive our one-page ' },
          { t: fac.label, hl: true },
          { t: ' scope breakdown before then?' }
        ];
      } else {
        openParts = [{ t: 'Totally fair — timing matters when evaluating facility vendors.' }];
        askParts = [{
          t: 'What month does your current janitorial agreement come up for review, and who should receive the one-pager?'
        }];
      }
    } else if (company && objKey === 'incumbent') {
      openParts = [
        { t: 'Good — switching away from a vendor that is working for ' },
        { t: company, hl: true },
        { t: ' is a bad idea unless the gap is clear.' }
      ];
    } else if (company && objKey === 'price') {
      openParts = [
        { t: company, hl: true },
        { t: ' hears this a lot. ' },
        { t: beats.open }
      ];
    } else {
      openParts = [{ t: beats.open }];
    }

    // Non-timing: renewal can still bind into OPEN when provided
    if (objKey !== 'timing' && renewal) {
      openParts = openParts.concat([
        { t: ' Since your contract renews in ' },
        { t: renewal, hl: true },
        { t: ', this is the window to compare written scope — not just familiarity.' }
      ]);
    }

    var reframeParts = [{ t: beats.reframe }];
    if (priceBand) {
      reframeParts.push(
        { t: ' Before evaluating ' },
        { t: priceBand, hl: true },
        { t: ' in a vacuum, put the frequency matrix and inspection standard next to it.' }
      );
    }
    // Decision-maker persona calibrates the commercial lever in REFRAME
    if (SALES_CONTACT_REFRAME[contactKey]) {
      reframeParts.push({ t: SALES_CONTACT_REFRAME[contactKey] });
    }

    var proofParts = [
      { t: 'For ' },
      { t: fac.label, hl: true },
      { t: ': ' },
      { t: fac.proof }
    ];

    if (objKey !== 'timing') {
      var askBase;
      if (objKey === 'insurance' || objKey === 'three_bids' || objKey === 'decision_maker') {
        askBase = beats.ask;
      } else {
        askBase = fac.ask || beats.ask;
      }
      if (objKey !== 'insurance' && objKey !== 'three_bids' && objKey !== 'decision_maker') {
        askParts = [
          { t: askBase.replace(/\?$/, '') },
          { t: ' — for this ' },
          { t: fac.label, hl: true },
          { t: '?' }
        ];
      } else {
        askParts = [{ t: askBase }];
      }
    }

    var open = salesPartsToText(openParts);
    var reframe = salesPartsToText(reframeParts);
    var proof = salesPartsToText(proofParts);
    var ask = salesPartsToText(askParts);

    var toneLabel = { direct: 'Direct', soft: 'Soft', executive: 'Executive' }[toneKey] || 'Direct';
    return {
      title: obj.title,
      toneLabel: toneLabel,
      facilityLabel: fac.label,
      company: company,
      contactLabel: contactLabel,
      priceBand: priceBand,
      renewal: renewal,
      beats: [
        salesBeat('Open', openParts),
        salesBeat('Reframe', reframeParts),
        salesBeat('Proof', proofParts, fac.label),
        salesBeat('Ask', askParts)
      ],
      copyText: ['OPEN: ' + open, 'REFRAME: ' + reframe, 'PROOF: ' + proof, 'ASK: ' + ask].join('\n\n')
    };
  }

  var ROBOTS = [
    { name: 'Tennant T7AMR', price: 82500, rate: 18000, maint: 0.15 },
    { name: 'Avidbots Neo 2', price: 90000, rate: 16000, maint: 0.14 },
    { name: 'Kärcher KIRA B50', price: 57500, rate: 12000, maint: 0.12 },
    { name: 'ICE Cobotics i-SYNERGY', price: 52500, rate: 10000, maint: 0.13 }
  ];

  var FRANCHISES = [
    { name: 'JAN-PRO', fee: 3985, royalty: 0.09, ad: 0.01, item19_low: 38000, item19_high: 120000 },
    { name: 'Coverall', fee: 8600, royalty: 0.05, ad: 0.01, item19_low: 19000, item19_high: 85000 },
    { name: 'Stratus', fee: 3450, royalty: 0.05, ad: 0.01, item19_low: 25000, item19_high: 110000 }
  ];

  var TAX_DEDUCTIONS = {
    sole_prop: [
      { name: '§179 equipment expensing', irc: 'IRC §179', limit: '$2,560,000 (2026)', rule: 'Write off autoscrubbers, vans, and extractors against active Schedule C income.' },
      { name: 'Standard mileage', irc: 'IRS Pub 463', limit: '72.5¢/mi (H1 2026); 76¢/mi (H2 2026)', rule: 'Log job-site miles; do not mix personal commuting with account runs.' },
      { name: 'Home office (simplified)', irc: 'IRC §280A', limit: '$1,500 max', rule: 'Exclusive, regular office space for bidding, payroll, and account admin only.' },
      { name: 'QBI deduction (20%)', irc: 'IRC §199A', limit: 'NAICS 561720 eligible', rule: 'Pass-through QBI may apply; confirm specified-service and wage tests with CPA.' },
      { name: 'Self-employment tax deduction', irc: 'IRC §164(f)', limit: '50% of SE tax', rule: 'Deduct employer-equivalent SE tax on Form 1040; does not cut Schedule C profit.' }
    ],
    llc: [
      { name: '§179 equipment expensing', irc: 'IRC §179', limit: '$2,560,000 (2026)', rule: 'Expense floor equipment and route vehicles limited to active business income.' },
      { name: 'Employer FICA on W-2 wages', irc: 'IRC §3111', limit: '7.65% employer share', rule: 'Employer share on W-2 cleaners is ordinary; keep payroll reports with the return.' },
      { name: 'QBI deduction (20%)', irc: 'IRC §199A', limit: 'Pass-through eligible', rule: 'Multi-member LLC: track W-2 wages and UBIA for QBI phase-outs.' },
      { name: 'Retirement, SEP-IRA', irc: 'IRC §408(k)', limit: 'Up to $72,000 (2026)', rule: 'SEP contributions follow net self-employment earnings; fund before filing deadline.' },
      { name: 'Supplies & chemicals (ordinary)', irc: 'IRC §162', limit: 'Fully deductible', rule: 'Chem, pads, and liners for client sites are ordinary; keep invoices by account.' }
    ],
    s_corp: [
      { name: 'Reasonable officer salary (W-2)', irc: 'IRC §162', limit: 'Required for S-Corp', rule: 'Pay owner a defensible W-2 before taking distributions or IRS reclassifies.' },
      { name: '§179 / bonus depreciation', irc: 'IRC §168(k)', limit: '100% bonus (acq. after Jan 19, 2025)', rule: 'Pass-through equipment losses flow on K-1; align acquisition dates with bonus rules.' },
      { name: 'Health insurance (2%+ shareholder)', irc: 'IRC §1372', limit: 'Deductible on W-2', rule: 'Report premiums in Box 1 W-2 (FICA-exempt) and deduct on Form 1040.' },
      { name: 'Retirement, Solo 401(k)', irc: 'IRC §401(k)', limit: 'Up to $72,000 total (2026)', rule: 'Stack employee deferral plus employer profit sharing within the annual cap.' },
      { name: 'Workers comp premiums', irc: 'IRC §162', limit: 'Ordinary business expense', rule: 'WC premiums for W-2 crews are ordinary; keep mod worksheets with the binder.' }
    ],
    c_corp: [
      { name: 'Corporate equipment depreciation', irc: 'MACRS 5-yr', limit: 'Cleaning equipment schedule', rule: 'Depreciate scrubbers and vans on the corporate return; track placed-in-service dates.' },
      { name: 'Employer payroll taxes', irc: 'IRC §3111', limit: 'FICA + FUTA', rule: 'Employer FICA/FUTA on W-2 labor is deductible corporate expense.' },
      { name: 'Business insurance', irc: 'IRC §162', limit: 'GL, WC, auto', rule: 'GL, WC, and auto premiums for operations are ordinary corporate deductions.' },
      { name: 'Professional fees', irc: 'IRC §162', limit: 'Legal, accounting', rule: 'CPA, counsel, and bid-compliance fees tied to the business are deductible.' },
      { name: 'Franchise / licensing fees', irc: 'IRC §162', limit: 'If ordinary to business', rule: 'Franchise royalties and required licensing fees must be ordinary and necessary.' }
    ]
  };

  var FREQ_WORKDAYS = { nightly_5x: 5, '3x_weekly': 3, '2x_weekly': 2, '1x_weekly': 1 };

  function simplifiedBid(inputs) {
    var workdays = FREQ_WORKDAYS[inputs.frequency] || num(inputs.workdays, 5) || 5;
    var regionKey = inputs.region;
    if (inputs.state && S.regionFromState) regionKey = S.regionFromState(inputs.state);
    var regionMult = (S.BID_REGIONAL && S.BID_REGIONAL[regionKey]) || 1;
    var prod = S.productionCalc({
      total_sqft: inputs.total_sqft,
      appa_level: inputs.appa_level || '2',
      workdays: workdays,
      pct_carpet: inputs.pct_carpet,
      pct_hard_floor: inputs.pct_hard_floor,
      pct_restroom: inputs.pct_restroom,
      pct_office: inputs.pct_office,
      pct_common: inputs.pct_common,
      fixtures: inputs.fixtures,
      shift_timing: inputs.shift_timing,
      soil_density: inputs.soil_density
    });
    if (!prod.valid) return prod;
    var labor = (S.resolveLoadedLaborRate
      ? S.resolveLoadedLaborRate(inputs)
      : num(inputs.labor_burden, S.LOADED_LABOR_DEFAULT || 24));
    var margin = num(inputs.margin_pct, S.TARGET_MARGIN_DEFAULT || 35);
    var sqft = num(inputs.total_sqft, prod.total_sqft);
    var cleaning = sqft * num(inputs.cleaning_supply_psf, 0.06) * regionMult;
    var consumableCost = sqft * num(inputs.consumable_psf, 0.02) * regionMult;
    var consumableBill = consumableCost * (1 + num(inputs.consumable_markup_pct, 8) / 100);
    var supply = cleaning + consumableCost;
    var equip = num(inputs.equipment_annual, 0);
    var travelAnnual = num(inputs.travel_allowance_mo, 0) * 12;
    var porterAnnual = num(inputs.day_porter_hrs_week, 0) * 52 * labor * regionMult;
    var oh = num(inputs.overhead_pct, 12) / 100;
    var laborCost = (prod.annual_hours * labor * regionMult) + porterAnnual;
    var opsDirect = laborCost + cleaning + equip + travelAnnual;
    var ohCost = opsDirect * oh;
    var opsCost = opsDirect + ohCost;
    var total = opsCost + consumableCost;
    var bid = (opsCost / (1 - margin / 100)) + consumableBill;
    var vertical = inputs.facility_type || 'office';
    return {
      valid: true,
      primary: fmt$(bid),
      annual_hours: prod.annual_hours,
      annual_labor_cost: laborCost,
      annual_supply_cost: supply,
      annual_cleaning_cost: cleaning,
      annual_consumable_cost: consumableCost,
      consumable_bill: consumableBill,
      annual_equipment: equip,
      overhead_cost: ohCost,
      total_cost: total,
      bid_target: bid,
      bid_low: (opsCost / (1 - Math.max(0.01, (margin - 8) / 100))) + consumableBill,
      bid_high: (opsCost / (1 - Math.min(0.99, (margin + 8) / 100))) + consumableBill,
      monthly_invoice: bid / 12,
      cost_per_sqft_yr: bid / prod.total_sqft,
      total_sqft: prod.total_sqft,
      loaded_labor_rate: labor,
      rows: [
        { label: 'Facility type', value: vertical },
        { label: 'Service days/week', value: String(workdays) },
        { label: 'Region multiplier', value: (regionMult * 100).toFixed(0) + '%' },
        { label: 'Annual hours', value: Math.round(prod.annual_hours).toLocaleString('en-US') + ' hr' },
        { label: 'Ops cost + overhead', value: fmt$(opsCost) },
        { label: 'Target bid @ ' + margin + '% margin', value: fmt$(bid) },
        { label: 'Monthly invoice', value: fmt$(bid / 12) },
        { label: '$/sqft/yr', value: fmt$(bid / prod.total_sqft) }
      ]
    };
  }

  /* ---- 1. bid-generator ---- */
  reg('bid-generator', {
    title: 'Bid Generator',
    blurb: 'Full bid with low/target/high range, labor, supplies, overhead.',
    primaryLabel: 'Target annual bid',
    mixPctFields: ['pct_carpet', 'pct_hard_floor', 'pct_restroom', 'pct_office', 'pct_common'],
    fields: [
      {
        id: 'facility_name',
        label: 'Account / building name',
        type: 'text',
        default: '',
        placeholder: 'e.g. Pacific Center Building B'
      },
      { id: 'facility_type', label: 'Facility type', type: 'select', default: 'office', options: benchmarkVerticalOpts() },
      {
        id: 'state',
        label: 'State',
        type: 'select',
        default: 'GA',
        options: stateOpts(),
        hint: 'Sets regional cost factor + SUTA / WC 9014 burden seeds'
      },
      { id: 'total_sqft', label: 'Total cleanable sqft', type: 'number', default: 65000, min: 500 },
      { id: 'frequency', label: 'Service frequency', type: 'select', default: 'nightly_5x', options: [
        { value: 'nightly_5x', label: 'Nightly 5×/week' }, { value: '3x_weekly', label: '3× weekly' },
        { value: '2x_weekly', label: '2× weekly' }, { value: '1x_weekly', label: 'Weekly' }
      ]},
      { id: 'appa_level', label: 'APPA level', type: 'select', default: '2', options: [
        { value: '1', label: 'Level 1 — White glove' },
        { value: '2', label: 'Level 2 — Standard' },
        { value: '3', label: 'Level 3 — Moderate' },
        { value: '4', label: 'Level 4 — Slack' },
        { value: '5', label: 'Level 5 — Partial / dash' }
      ]},
      {
        id: 'base_wage',
        label: 'Base wage ($/hr)',
        type: 'number',
        default: 16,
        hint: 'What you pay the cleaner — burden is applied in Advanced'
      },
      { id: 'margin_pct', label: 'Target margin (%)', type: 'number', default: 35 },
      {
        id: 'payroll_burden_pct',
        label: 'Payroll burden %',
        type: 'number',
        default: 50,
        advanced: true,
        info: 'WC + FICA/SUTA often 12–22%; full loaded (taxes+WC+benefits+PTO) often 40–55%. Default 50% → ~$24/hr from $16 wage.'
      },
      { id: 'pct_carpet', label: 'Carpet %', type: 'number', default: 40, advanced: true },
      { id: 'pct_hard_floor', label: 'Hard %', type: 'number', default: 20, advanced: true },
      { id: 'pct_restroom', label: 'Restroom %', type: 'number', default: 5, advanced: true },
      { id: 'pct_office', label: 'Office %', type: 'number', default: 25, advanced: true },
      { id: 'pct_common', label: 'Common %', type: 'number', default: 10, advanced: true },
      { id: 'fixtures', label: 'Restroom fixtures', type: 'number', advanced: true, hint: 'Tip: Enter fixture count for higher labor precision.' },
      {
        id: 'cleaning_supply_psf',
        label: 'Contractor supplies $/sf/yr',
        type: 'number',
        default: 0.06,
        advanced: true,
        info: 'Microfiber, chemicals, equipment depreciation — carries your target margin.'
      },
      {
        id: 'consumable_psf',
        label: 'Paper / soap $/sf/yr',
        type: 'number',
        default: 0.02,
        advanced: true,
        info: 'Pass-through consumables billed at a low markup (not full margin).'
      },
      {
        id: 'consumable_markup_pct',
        label: 'Consumables markup %',
        type: 'number',
        default: 8,
        advanced: true,
        info: 'Typical pass-through markup 5–10%.'
      },
      { id: 'equipment_annual', label: 'Equipment $/yr', type: 'number', default: 0, advanced: true },
      { id: 'overhead_pct', label: 'Overhead %', type: 'number', default: 12, advanced: true },
      {
        id: 'travel_allowance_mo',
        label: 'Travel $/mo',
        type: 'number',
        default: 0,
        advanced: true,
        info: 'Drive time / mileage stipend — cost load, not a production slowdown.'
      },
      {
        id: 'day_porter_hrs_week',
        label: 'Day porter hrs/wk',
        type: 'number',
        default: 0,
        advanced: true,
        info: 'Non-working supervision or day-porter hours priced at loaded labor.'
      }
    ],
    calculate: function (inputs) {
      var stateKey = String(inputs.state || 'GA').toUpperCase();
      var regionKey = (S.regionFromState && S.regionFromState(stateKey)) || inputs.region || 'national';
      inputs = Object.assign({}, inputs, { state: stateKey, region: regionKey });

      // Statutory wage floor clamp (seed only — divisor / leakage / OH math unchanged)
      var wageFloor = S.applyStateWageFloor
        ? S.applyStateWageFloor(stateKey, num(inputs.base_wage, 16))
        : null;
      if (wageFloor && wageFloor.clamped) {
        inputs = Object.assign({}, inputs, { base_wage: wageFloor.wage });
      }

      var laborRate = S.resolveLoadedLaborRate
        ? S.resolveLoadedLaborRate(inputs)
        : num(inputs.base_wage, 16) * (1 + num(inputs.payroll_burden_pct, 50) / 100);
      inputs = Object.assign({}, inputs, { labor_burden: laborRate });

      var BG = global.OporaBidGen;
      var r;
      if (BG && typeof BG.calculateBid === 'function') {
        r = BG.calculateBid(inputs);
        if (r.valid) {
          r.primary = fmt$(r.bid_target);
        }
      } else {
        r = simplifiedBid(inputs);
      }
      if (!r || !r.valid) return r;

      var annualH = num(r.annual_hours, 0);
      var monthlyH = annualH / 12;
      var labor = num(r.annual_labor_cost, 0);
      var cleaning = num(r.annual_cleaning_cost, 0);
      var consumableCost = num(r.annual_consumable_cost, 0);
      var consumableBill = num(r.consumable_bill, consumableCost * (1 + num(inputs.consumable_markup_pct, 8) / 100));
      var supply = num(r.annual_supply_cost, cleaning + consumableCost);
      if (!cleaning && supply && !consumableCost) {
        // Legacy path: single supply line
        cleaning = supply;
      }
      var equip = num(r.annual_equipment, 0);
      var oh = num(r.overhead_cost, 0);
      var travelAnnual = num(inputs.travel_allowance_mo, 0) * 12;
      var porterAnnual = num(inputs.day_porter_hrs_week, 0) * 52 * laborRate;
      // OporaBidGen path doesn't bake travel/porter — add as ops cost loads
      var usedSimplified = !(global.OporaBidGen && typeof global.OporaBidGen.calculateBid === 'function');
      if (!usedSimplified && (travelAnnual > 0 || porterAnnual > 0)) {
        labor += porterAnnual;
        var opsDirectAdj = labor + cleaning + equip + travelAnnual;
        var ohPct = num(inputs.overhead_pct, 12) / 100;
        oh = opsDirectAdj * ohPct;
        var marginNowAdj = num(inputs.margin_pct, 35);
        var opsCostAdj = opsDirectAdj + oh;
        var totalAdj = opsCostAdj + consumableCost;
        r.annual_labor_cost = labor;
        r.overhead_cost = oh;
        r.total_cost = totalAdj;
        r.bid_target = (opsCostAdj / (1 - marginNowAdj / 100)) + consumableBill;
        r.bid_low = (opsCostAdj / (1 - Math.max(0.01, (marginNowAdj - 8) / 100))) + consumableBill;
        r.bid_high = (opsCostAdj / (1 - Math.min(0.99, (marginNowAdj + 8) / 100))) + consumableBill;
        r.monthly_invoice = r.bid_target / 12;
        r.cost_per_sqft_yr = r.bid_target / Math.max(1, num(inputs.total_sqft, 1));
      }
      var totalCost = num(r.total_cost, labor + supply + equip + oh + (usedSimplified ? 0 : travelAnnual));
      var bidTarget = num(r.bid_target, 0);
      var bidLow = num(r.bid_low, bidTarget * 0.89);
      var bidHigh = num(r.bid_high, bidTarget * 1.14);
      var monthly = num(r.monthly_invoice, bidTarget / 12);
      var psf = num(r.cost_per_sqft_yr, bidTarget / Math.max(1, num(inputs.total_sqft, 1)));
      var sqft = num(inputs.total_sqft, r.total_sqft || 0);

      var mixSum = num(inputs.pct_carpet, 0) + num(inputs.pct_hard_floor, 0) +
        num(inputs.pct_restroom, 0) + num(inputs.pct_office, 0) + num(inputs.pct_common, 0);

      var facLabel = (S.SEED_BENCHMARKS[inputs.facility_type] && S.SEED_BENCHMARKS[inputs.facility_type].label) ||
        String(inputs.facility_type || 'office');
      var freqMap = {
        nightly_5x: 'Nightly 5×/week', '3x_weekly': '3× weekly',
        '2x_weekly': '2× weekly', '1x_weekly': 'Weekly', weekly: 'Weekly'
      };
      var freqLabel = freqMap[inputs.frequency] || String(inputs.frequency || '');
      var baseWage = num(inputs.base_wage, 16);
      var burPct = num(inputs.payroll_burden_pct, 50);

      r.metrics = [
        { label: 'Target annual bid', value: fmt$(bidTarget), accent: true, hero: true },
        { label: 'Monthly invoice', value: fmt$(monthly) },
        { label: '$/sqft/yr', value: fmt$(psf) }
      ];
      r.primary = fmt$(bidTarget);

      var marginNow = num(inputs.margin_pct, 35);
      var marginMin = 12;
      var marginMax = 55;
      // Interactive bar is ops-only (excl. pass-through consumables) so drag math stays correct
      var opsForTrack = Math.max(0, totalCost - consumableCost);
      var bidTargetOps = opsForTrack / (1 - marginNow / 100);
      // Track ends = statutory slider span (12% … 55%); thumb maps by margin, not bid-$
      var trackLow = opsForTrack / (1 - marginMin / 100);
      var trackHigh = opsForTrack / (1 - marginMax / 100);
      var marginSpan = marginMax - marginMin;
      var thumbPct = marginSpan > 0
        ? Math.max(0, Math.min(100, ((marginNow - marginMin) / marginSpan) * 100))
        : 50;

      r.rangeBar = {
        low: trackLow,
        target: bidTargetOps,
        high: trackHigh,
        lowLabel: fmt$(trackLow),
        targetLabel: fmt$(bidTargetOps),
        highLabel: fmt$(trackHigh),
        interactive: true,
        totalCost: opsForTrack,
        margin: marginNow,
        marginMin: marginMin,
        marginMax: marginMax,
        trackLow: trackLow,
        trackHigh: trackHigh,
        thumbPct: thumbPct,
        positionBy: 'margin',
        title: 'Operating services bid (excluding pass-through consumables)',
        markerLabel: 'Target',
        contractPill: consumableBill > 0
          ? 'Total contract value: ' + fmt$(bidTarget) +
            ' (' + fmt$(bidTargetOps) + ' ops + ' + fmt$(consumableBill) + ' consumables)'
          : null,
        passThroughBill: consumableBill > 0 ? consumableBill : 0,
        hint: consumableBill > 0
          ? 'Drag sets ops margin (' + marginMin + '–' + marginMax + '%). Full invoice adds ' +
            fmt$(consumableBill) + ' consumables at pass-through markup.'
          : 'Drag to set target margin (' + marginMin + '–' + marginMax + '%)'
      };

      // Gross-margin divisor vs flat markup leakage (ops cost only — excl. pass-through consumables)
      var flatMarkupOps = opsForTrack * (1 + marginNow / 100);
      var leakDelta = bidTargetOps - flatMarkupOps;
      r.leakageProof = {
        margin: marginNow,
        divisorBid: bidTargetOps,
        flatMarkupBid: flatMarkupOps,
        leak: leakDelta
      };

      // Stress-Test handoff — explicit alias query params (parsePrefill maps them)
      var laborShare = bidTarget > 0 ? Math.round((labor / bidTarget) * 100) : 0;
      var supplyShare = bidTarget > 0
        ? Math.round(((cleaning + consumableCost) / bidTarget) * 100)
        : 0;
      var ohShare = bidTarget > 0 ? Math.round((oh / bidTarget) * 100) : 0;
      var monthlyRounded = Math.round(monthly * 100) / 100;
      r.handoffUrl = '/pages/bid-stress-test'
        + '?monthlyRev=' + encodeURIComponent(String(monthlyRounded))
        + '&laborPct=' + encodeURIComponent(String(laborShare))
        + '&suppliesPct=' + encodeURIComponent(String(supplyShare))
        + '&overheadPct=' + encodeURIComponent(String(ohShare))
        + '&targetMargin=' + encodeURIComponent(String(marginNow))
        + '&state=' + encodeURIComponent(stateKey);

      var share = function (n) {
        return totalCost > 0 ? Math.round((n / totalCost) * 100) : 0;
      };
      var laborCore = Math.max(0, labor - porterAnnual);
      r.breakdown = [
        {
          label: 'Monthly hours',
          value: '~ ' + Math.round(monthlyH).toLocaleString() + ' hrs/mo',
          hint: Math.round(annualH).toLocaleString() + ' hrs/yr · APPA blend' +
            (inputs.frequency === '1x_weekly' || inputs.frequency === 'weekly'
              ? ' (+30% weekly)'
              : '')
        },
        {
          label: 'Direct labor',
          value: fmt$(laborCore),
          hint: share(laborCore) + '% · ' + fmt$(baseWage) + '/hr x ' +
            burPct.toFixed(0) + '% burden'
        },
        {
          label: 'Contractor cleaning supplies',
          value: fmt$(cleaning),
          hint: share(cleaning) + '% · carries target margin'
        },
        {
          label: 'Paper / soap consumables',
          value: fmt$(consumableCost),
          hint: share(consumableCost) + '% · billed ' + fmt$(consumableBill)
        },
        { label: 'Equipment', value: fmt$(equip), hint: share(equip) + '% of total cost' }
      ];
      if (porterAnnual > 0) {
        r.breakdown.push({
          label: 'Day porter / supervisor',
          value: fmt$(porterAnnual),
          hint: num(inputs.day_porter_hrs_week, 0) + ' hrs/wk x 52 x ' + fmt$(laborRate) + '/hr'
        });
      }
      if (travelAnnual > 0) {
        r.breakdown.push({
          label: 'Travel allowance',
          value: fmt$(travelAnnual),
          hint: fmt$(num(inputs.travel_allowance_mo, 0)) + '/mo x 12'
        });
      }
      r.breakdown.push(
        { label: 'Overhead', value: fmt$(oh), hint: share(oh) + '% of total cost' },
        { label: 'Total cost, pre-margin', value: fmt$(totalCost), emphasize: true }
      );

      if (Math.abs(mixSum - 100) > 0.5) {
        r.mixNote = 'Surface mix totals ' + mixSum.toFixed(0) +
          '%. Hours normalize the split to 100% — fix Advanced mix if this was unintentional.';
      }

      r.rows = [
        { label: 'Facility', value: facLabel },
        { label: 'State', value: stateKey + ' (' + regionKey + ')' },
        { label: 'Frequency', value: freqLabel },
        { label: 'APPA level', value: String(inputs.appa_level || '2') },
        { label: 'Cleanable sq. ft.', value: sqft.toLocaleString() },
        { label: 'Loaded labor', value: fmt$(laborRate) + '/hr' }
      ];

      var fixtureWarn = S.restroomFixtureSoftWarn
        ? S.restroomFixtureSoftWarn(sqft, inputs.facility_type, inputs.fixtures)
        : null;
      var consumableWarn = S.consumablePsfSoftWarn
        ? S.consumablePsfSoftWarn(inputs.consumable_psf, inputs.facility_type)
        : null;
      var banners = [];
      if (wageFloor && wageFloor.clamped && wageFloor.message) {
        banners.push({ level: 'warn', title: 'Statutory wage floor', text: wageFloor.message });
      }
      if (fixtureWarn) {
        banners.push({ level: 'warn', title: 'Fixture check', text: fixtureWarn });
      }
      if (consumableWarn) {
        banners.push({ level: 'warn', title: 'Consumables check', text: consumableWarn });
      }
      if (banners.length) {
        r.alertBanners = banners;
        r.alertBanner = banners[0];
      }
      if (wageFloor && wageFloor.clamped) {
        r.syncFields = { base_wage: { value: String(wageFloor.wage) } };
      }

      r.soWhat = 'For **' + sqft.toLocaleString() + ' sf**, open around **' +
        fmt$(bidTarget) + '/yr**, **' + fmt$(monthly) + '/mo**.';
      r.soWhatClient = 'Proposed annual investment of **' + fmt$(bidTarget) +
        '** (**' + fmt$(monthly) + '/mo**) for **' + sqft.toLocaleString() +
        ' sf** · ' + freqLabel + ' · APPA ' + String(inputs.appa_level || '2') + '.';

      var cleansPerYear = (FREQ_WORKDAYS[inputs.frequency] || 5) * 52;
      var hrsPerNight = cleansPerYear > 0 ? annualH / cleansPerYear : 0;
      var prodSqftHr = hrsPerNight > 0 ? sqft / hrsPerNight : 0;
      var shiftCap = 3.5;
      var crewN = hrsPerNight > 0 ? Math.max(1, Math.ceil(hrsPerNight / shiftCap)) : 0;
      r.staffingPdf = {
        annualHours: annualH,
        monthlyHours: monthlyH,
        cleansPerYear: cleansPerYear,
        hrsPerNight: hrsPerNight,
        prodSqftHr: prodSqftHr,
        crew: crewN,
        shiftCap: shiftCap,
        fixtures: num(inputs.fixtures, 0)
      };

      r.pdfScopeRows = [
        { label: 'Facility type', value: facLabel },
        { label: 'Service frequency', value: freqLabel },
        { label: 'APPA appearance level', value: 'Level ' + String(inputs.appa_level || '2') },
        { label: 'Cleanable area', value: sqft.toLocaleString() + ' sq. ft.' },
        {
          label: 'Surface mix',
          value: [
            num(inputs.pct_carpet, 40) + '% carpet',
            num(inputs.pct_hard_floor, 20) + '% hard',
            num(inputs.pct_restroom, 5) + '% restroom',
            num(inputs.pct_office, 25) + '% office',
            num(inputs.pct_common, 10) + '% common'
          ].join(' · ')
        },
        {
          label: 'Restroom fixtures',
          value: num(inputs.fixtures, 0) > 0 ? String(Math.round(num(inputs.fixtures, 0))) : 'Not specified'
        }
      ];

      r.copyLabel = 'Copy bid summary';
      var costBits = [
        'Labor ' + fmt$(labor),
        'Cleaning supplies ' + fmt$(cleaning),
        'Consumables ' + fmt$(consumableCost),
        'Equipment ' + fmt$(equip)
      ];
      if (travelAnnual > 0) costBits.push('Travel ' + fmt$(travelAnnual));
      if (porterAnnual > 0) costBits.push('Day porter ' + fmt$(porterAnnual));
      costBits.push('Overhead ' + fmt$(oh));
      r.copyText = [
        'Opora Bid Generator summary',
        'Facility: ' + (String(inputs.facility_name || '').trim() || facLabel),
        'Scope: ' + sqft.toLocaleString() + ' sf · ' + freqLabel + ' · APPA ' + String(inputs.appa_level || '2'),
        'Labor: ' + fmt$(baseWage) + '/hr wage + ' + burPct.toFixed(0) + '% burden, ' +
          fmt$(laborRate) + '/hr loaded',
        'Target annual: ' + fmt$(bidTarget),
        'Monthly invoice: ' + fmt$(monthly),
        '$/sqft/yr: ' + fmt$(psf),
        'Range: Low ' + fmt$(bidLow) + ' · Target ' + fmt$(bidTarget) + ' · High ' + fmt$(bidHigh),
        'Hours: ~ ' + Math.round(monthlyH).toLocaleString() + ' hrs/mo, ' + Math.round(annualH).toLocaleString() + ' hrs/yr',
        'Costs: ' + costBits.join(' · '),
        'Total cost, pre-margin: ' + fmt$(totalCost)
      ].join('\n');

      return r;
    }
  });

  /* ---- 2. bid-stress-test ---- */
  reg('bid-stress-test', {
    title: 'Bid Stress-Test',
    blurb: 'Pressure-test margin against wage, turnover, supply, and discount scenarios.',
    primaryLabel: 'Vulnerability',
    fields: [
      { id: 'bid_total', label: 'Monthly contract value ($)', type: 'number', default: 5000 },
      { id: 'labor_pct', label: 'Labor % of revenue', type: 'number', default: 58 },
      { id: 'supply_pct', label: 'Supplies %', type: 'number', default: 8 },
      { id: 'overhead_pct', label: 'Overhead %', type: 'number', default: 18 },
      { id: 'target_margin', label: 'Target margin (%)', type: 'number', default: 16 },
      {
        id: 'state',
        label: 'State',
        type: 'select',
        default: 'GA',
        options: stateOpts(),
        hint: 'Carried from Bid Generator for context — stress scenarios stay margin-based'
      },
      {
        id: 'wage_shift_pct',
        label: 'Wage shock (%)',
        type: 'number',
        default: 10,
        advanced: true,
        hint: 'Scheduled wage increase — combined with turnover/OT drag below'
      },
      {
        id: 'turnover_drag_pct',
        label: 'Turnover & shift-cover drag (%)',
        type: 'number',
        default: 8,
        advanced: true,
        hint: 'Janitorial turnover often 100–150%/yr — unfilled shifts, OT cover, and new-hire training eat margin faster than wage alone'
      },
      { id: 'supply_shock_pct', label: 'Supply shock (%)', type: 'number', default: 15, advanced: true },
      { id: 'discount_pct', label: 'Client discount (%)', type: 'number', default: 5, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.bidStressTest(inputs);
      if (r && r.valid) {
        var vuln = r.vulnerability || 'Medium';
        var tone = vuln === 'High' ? 'bad' : vuln === 'Medium' ? 'warn' : 'ok';
        var riskLabel = vuln === 'High' ? 'High risk' : vuln === 'Medium' ? 'Moderate risk' : 'Low risk';
        r.soWhat = 'At **' + fmt$(num(inputs.bid_total, 5000)) + '/mo**, this bid shows **' +
          riskLabel + '**' +
          (r.baseProfit != null ? ' — baseline profit **' + fmt$(r.baseProfit) + '/mo**' : '') +
          ' — rebuild hours or rate if margin collapses under wage, turnover, or a discount.';
        r.metrics = [
          {
            label: 'Vulnerability',
            value: riskLabel,
            accent: true,
            hero: true,
            tone: tone
          },
          { label: 'Scenarios below target', value: String(r.failing != null ? r.failing : '—') },
          { label: 'Baseline profit', value: r.baseProfit != null ? fmt$(r.baseProfit) + '/mo' : '—' }
        ];
        if (tone === 'bad') {
          r.statusPill = { level: 'bad', label: 'High risk', text: 'Multiple scenarios miss target margin.' };
        } else if (tone === 'warn') {
          r.statusPill = { level: 'warn', label: 'Moderate risk', text: 'At least one shock lands below target.' };
        } else {
          r.statusPill = { level: 'ok', label: 'Low risk', text: 'Scenarios hold above target margin.' };
        }
        var stateKey = String(inputs.state || 'GA').toUpperCase();
        var rev = num(inputs.bid_total, 5000);
        r.handoffUrl = '/pages/bid-drafter'
          + '?from=bid-stress-test'
          + '&rev=' + encodeURIComponent(String(rev))
          + '&escalation=true'
          + '&state=' + encodeURIComponent(stateKey);
        r.handoffLabel = 'Draft Bid with Statutory Wage Escalation Clause → Bid Drafter';
        r.handoffHint = 'Next: lock escalation language before the next wage cycle';
        r.handoffSecondary = {
          label: 'Compare to market → Bid Benchmarks',
          url: '/pages/cleaning-bid-benchmarks'
        };
      }
      return r;
    }
  });

  /* ---- 3. cleaning-bid-benchmarks ---- */
  reg('cleaning-bid-benchmarks', {
    title: 'Cleaning Bid Benchmarks',
    blurb: 'Compare your bid to industry $/sqft/yr ranges by vertical, region, and frequency.',
    primaryLabel: 'Benchmark range',
    fields: [
      { id: 'vertical', label: 'Vertical', type: 'select', default: 'office', options: benchmarkVerticalOpts() },
      { id: 'region', label: 'Region', type: 'select', default: 'national', options: regionOpts() },
      { id: 'sqft', label: 'Square footage', type: 'number', default: 65000, min: 1000 },
      {
        id: 'frequency',
        label: 'Service frequency',
        type: 'select',
        default: 'nightly_5x',
        options: [
          { value: 'nightly_5x', label: 'Nightly 5×/week' },
          { value: '3x_weekly', label: '3× weekly' },
          { value: '2x_weekly', label: '2× weekly' },
          { value: '1x_weekly', label: 'Weekly' }
        ]
      },
      { id: 'your_rate', label: 'Your bid ($/sqft/yr)', type: 'number', advanced: true }
    ],
    calculate: function (inputs) {
      var v = S.SEED_BENCHMARKS[inputs.vertical] || S.SEED_BENCHMARKS.office;
      var b = v.cost_per_sqft_per_year;
      var mult = (S.BID_REGIONAL && S.BID_REGIONAL[inputs.region]) || 1;
      var freqKey = inputs.frequency || 'nightly_5x';
      var freqScale = (S.BENCH_FREQ_ANNUAL && S.BENCH_FREQ_ANNUAL[freqKey]) || 1;
      var workdays = (S.BENCH_FREQ_WORKDAYS && S.BENCH_FREQ_WORKDAYS[freqKey]) || 5;
      var visitsYr = workdays * 52;
      var low = b.low * mult * freqScale;
      var med = b.median * mult * freqScale;
      var high = b.high * mult * freqScale;
      var sqft = num(inputs.sqft);
      if (!sqft || sqft <= 0) return { valid: false, errors: ['Enter square footage.'] };
      var yoursRaw = num(inputs.your_rate);
      var yours = yoursRaw;
      var loaded = S.LOADED_LABOR_DEFAULT || 24;
      var hrsLow = (low * 1000 / loaded).toFixed(0);
      var hrsHigh = (high * 1000 / loaded).toFixed(0);
      var minMoLow = S.BID_MIN_MONTHLY_LOW || 500;
      var minMoHigh = S.BID_MIN_MONTHLY_HIGH || 750;
      var monthlyMed = (med * sqft) / 12;
      var monthlyLow = (low * sqft) / 12;
      var belowFloor = monthlyMed < minMoLow;
      var nearFloor = !belowFloor && monthlyMed < minMoHigh;

      // Catch common typos: $2000 meant as $2.00/sqft, or annual total pasted into rate field
      var rateHint = null;
      if (yoursRaw && yoursRaw > Math.max(high * 5, 25)) {
        var scaled1000 = yoursRaw / 1000;
        var asPerSqft = yoursRaw / sqft;
        var nearBand = function (rate) {
          return rate > 0 && rate >= low * 0.35 && rate <= high * 2.75;
        };
        if (nearBand(scaled1000)) {
          rateHint = {
            suggested: scaled1000,
            message: 'Did you mean ' + fmt$(scaled1000) + '/sqft (' + fmt$(scaled1000 * sqft) + '/yr)? ' +
              'Your entry looks like cents omitted ($' + yoursRaw.toFixed(0) + ' vs $' + scaled1000.toFixed(2) + ').'
          };
        } else if (nearBand(asPerSqft)) {
          rateHint = {
            suggested: asPerSqft,
            message: 'Did you mean ' + fmt$(asPerSqft) + '/sqft (' + fmt$(yoursRaw) + '/yr total)? ' +
              'Your entry looks like an annual bid, not a $/sqft/yr rate.'
          };
        } else {
          rateHint = {
            suggested: scaled1000,
            message: 'Your bid rate looks out of scale for $/sqft/yr. ' +
              'If you meant ' + fmt$(scaled1000) + '/sqft, that is ' + fmt$(scaled1000 * sqft) + '/yr.'
          };
        }
      }

      var flag = null;
      var statusPill = null;
      if (belowFloor) {
        flag = 'Below mobilization floor';
        statusPill = {
          level: 'bad',
          label: 'Under $' + minMoLow + '–$' + minMoHigh + '/mo floor',
          text: 'Pure $/sqft math underprices small sites — most operators won’t mobilize below ~$' +
            minMoLow + '–$' + minMoHigh + '/mo.'
        };
      } else if (yours) {
        if (yours < low) {
          var dLo = low - yours;
          var pctLo = low > 0 ? (dLo / low) * 100 : 0;
          flag = 'Below market';
          statusPill = {
            level: 'bad',
            label: '−' + fmt$(dLo) + '/sqft (−' + pctLo.toFixed(0) + '% vs Low)',
            text: rateHint
              ? 'Rate looks out of scale — see suggestion below.'
              : 'Below the healthy band — rebuild hours before you cut further.'
          };
        } else if (yours > high) {
          var dHi = yours - high;
          var pctHi = high > 0 ? (dHi / high) * 100 : 0;
          flag = 'Above market';
          statusPill = {
            level: 'bad',
            label: rateHint
              ? 'Rate looks out of scale'
              : ('+' + fmt$(dHi) + '/sqft (+' + pctHi.toFixed(0) + '% vs High)'),
            text: rateHint
              ? 'Rate looks out of scale — see suggestion below.'
              : 'Above the healthy band — confirm scope and hours before you pad the bid.'
          };
        } else {
          flag = 'Market range';
          statusPill = {
            level: 'ok',
            label: 'Within healthy band',
            text: 'Your rate sits between Low and High for this vertical, region, and frequency.'
          };
        }
      } else if (nearFloor) {
        statusPill = {
          level: 'warn',
          label: 'Near mobilization floor',
          text: 'Median monthly (' + fmt$(monthlyMed) + ') is near the $' + minMoLow +
            '–$' + minMoHigh + '/mo floor — confirm travel and setup costs.'
        };
      }

      var marker = yours || med;
      var trackLow = low;
      var trackHigh = high;
      var overflowHigh = !!(yours && yours > high);
      var overflowLow = !!(yours && yours < low);
      var offChart = false;
      if (yours) {
        // Always place the marker at the real bid — never peg to HIGH/LOW
        trackLow = Math.min(low, yours) * 0.92;
        trackHigh = Math.max(high, yours) * 1.08;
        if (yours > high * 4 || yours < low / 4) {
          offChart = true;
        }
        marker = yours;
      }

      var perVisitLow = visitsYr > 0 ? low / visitsYr : 0;
      var perVisitMed = visitsYr > 0 ? med / visitsYr : 0;
      var perVisitHigh = visitsYr > 0 ? high / visitsYr : 0;
      var fmtRate = S.fmtUnitRate || fmt$;
      var freqLabels = {
        nightly_5x: 'Nightly 5×/week',
        '3x_weekly': '3× weekly',
        '2x_weekly': '2× weekly',
        '1x_weekly': 'Weekly'
      };
      var freqLabel = freqLabels[freqKey] || String(freqKey);

      var rows = [
        { label: 'Frequency', value: freqLabel + (freqScale !== 1 ? ' · ' + Math.round(freqScale * 100) + '% of 5× annual band' : '') },
        { label: 'Annual @ median', value: fmt$(med * sqft) + '/yr · ' + fmt$(monthlyMed) + '/mo' },
        {
          label: 'Per-visit @ median',
          value: fmtRate(perVisitMed) + '/sqft/visit · ' + fmt$(perVisitMed * sqft) + '/visit'
        }
      ];
      if (mult !== 1) rows.push({ label: 'Region', value: (mult * 100).toFixed(0) + '% of national' });
      rows.push({
        label: 'Mobilization floor',
        value: '$' + minMoLow + '–$' + minMoHigh + '/mo' +
          (belowFloor ? ' · median bid below floor' : (nearFloor ? ' · near floor' : ''))
      });
      if (yours) {
        rows.push({
          label: 'Your bid',
          value: fmt$(yours) + '/sqft/yr · ' + fmt$(yours * sqft) + '/yr'
        });
      }
      if (rateHint) {
        rows.push({
          label: 'Suggested rate',
          value: fmt$(rateHint.suggested) + '/sqft/yr · ' + fmt$(rateHint.suggested * sqft) + '/yr'
        });
      }

      var soWhat;
      if (belowFloor) {
        soWhat = 'At **' + sqft.toLocaleString() + ' sf** (' + freqLabel + '), median math is only **' +
          fmt$(monthlyMed) + '/mo** — treat **$' + minMoLow + '–$' + minMoHigh +
          '/mo** as the mobilization floor, not the raw $/sqft output.';
      } else {
        soWhat = 'For **' + sqft.toLocaleString() + ' sf** at **' + freqLabel +
          '**, healthy band is **' + fmt$(low) + '–' + fmt$(high) + '/sqft/yr** · **' +
          fmtRate(perVisitLow) + '–' + fmtRate(perVisitHigh) + '/sqft/visit**.';
      }

      var rangeHint;
      if (offChart) {
        rangeHint = 'Your entered rate is far outside the chart scale — check $/sqft vs total bid.';
      } else if (overflowHigh) {
        var pctOver = high > 0 ? ((yours - high) / high) * 100 : 0;
        rangeHint = 'Your bid is +' + pctOver.toFixed(0) +
          '% above the HIGH corridor — marker sits on the extended track outside the shaded band.';
      } else if (overflowLow) {
        var pctUnder = low > 0 ? ((low - yours) / low) * 100 : 0;
        rangeHint = 'Your bid is −' + pctUnder.toFixed(0) +
          '% below the LOW corridor — marker sits on the extended track outside the shaded band.';
      } else if (yours) {
        rangeHint = 'Shaded band is the frequency-adjusted market corridor; marker is your bid.';
      } else {
        rangeHint = 'Shaded band is the frequency-adjusted market corridor; marker is the median.';
      }

      return {
        valid: true,
        primary: fmt$(low) + ' – ' + fmt$(high) + '/sqft/yr',
        secondary: hrsLow + '–' + hrsHigh + ' hrs/1K sqft/yr',
        secondaryLabel: 'Labor intensity (at $' + loaded + '/hr)',
        flag: flag,
        statusPill: statusPill,
        soWhat: soWhat,
        mixNote: belowFloor
          ? 'Small-site alert: $/sqft bands ignore fixed mobilization. Floor callout $' +
            minMoLow + '–$' + minMoHigh + '/mo (median monthly ' + fmt$(monthlyMed) +
            '; low band monthly ' + fmt$(monthlyLow) + ').'
          : (freqScale !== 1
            ? 'Bands scaled for ' + freqLabel + ' (' + Math.round(freqScale * 100) +
              '% of Nightly 5× annual). Per-visit rates rise as frequency drops.'
            : null),
        metrics: [
          { label: 'Low', value: fmt$(low) },
          { label: 'Median', value: fmt$(med), hero: true, accent: true },
          { label: 'High', value: fmt$(high) }
        ],
        // no bands — metrics already show Low/Median/High (avoids duplicate cards)
        rangeBar: {
          low: low,
          high: high,
          target: marker,
          fillLow: low,
          fillHigh: high,
          trackLow: trackLow,
          trackHigh: trackHigh,
          lowLabel: fmt$(low),
          highLabel: fmt$(high),
          markerLabel: yours ? 'Your bid' : 'Median',
          targetLabel: overflowHigh
            ? (fmt$(yours) + '/sqft (out of bounds)')
            : (overflowLow
              ? (fmt$(yours) + '/sqft (below band)')
              : (yours ? fmt$(yours) + '/sqft' : fmt$(med) + '/sqft')),
          overflow: overflowHigh || overflowLow,
          hint: rangeHint
        },
        rateHint: rateHint,
        rows: rows
      };
    }
  });

  /* ---- 4. per-clean-vs-hourly ---- */
  reg('per-clean-vs-hourly', {
    title: 'Per-Clean vs Hourly vs Flat',
    blurb: 'Compare pricing models for scope volatility and frequency.',
    primaryLabel: 'Recommended model',
    fields: [
      { id: 'sqft', label: 'Square footage', type: 'number', default: 12000 },
      {
        id: 'freq',
        label: 'Visits per month',
        type: 'number',
        default: 21.67,
        hint: 'Industry calendar: 5×/week × 4.33 weeks/mo (52÷12) ≈ 21.67 — not a static 22'
      },
      { id: 'prod_rate', label: 'Production rate (sqft/hr)', type: 'number', default: 3700 },
      { id: 'loaded_rate', label: 'Loaded labor rate ($/hr)', type: 'number', default: 24 },
      {
        id: 'overhead_pct',
        label: 'Overhead (%)',
        type: 'number',
        default: 12,
        hint: 'Cost load on labor (admin, insurance allocation, etc.) — not profit'
      },
      {
        id: 'target_margin',
        label: 'Target gross margin (%)',
        type: 'number',
        default: 35,
        hint: 'True margin: bill = cost ÷ (1 − margin%). 35% margin ≠ 35% markup'
      },
      { id: 'scope_volatility', label: 'Scope volatility', type: 'select', default: 'medium', options: [
        { value: 'low', label: 'Low — locked scope, stable access' },
        { value: 'medium', label: 'Medium — occasional extras' },
        { value: 'high', label: 'High — access delays / scope creep' }
      ], advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.perCleanVsHourly(inputs);
      if (r && r.valid && r.recommended) {
        // Keep narrative short — compare cards + mixNote carry the teaching
        r.narrative = null;
        var rec = r.recommended;
        var hourlyBill = r.hourly_bill;
        var billVisit = r.per_clean_rate;
        var flatMo = r.flat_monthly;
        var hourlyMo = r.hourly_monthly;
        var hrs = r.hours_per_visit;
        var freq = r.visits_per_month;
        var ohPct = r.overhead_pct;
        var margin = r.target_margin;
        var loaded = num(inputs.loaded_rate, S.LOADED_LABOR_DEFAULT || 24);
        var recRate = rec === 'Hourly'
          ? (fmt$(hourlyBill) + '/hr')
          : (rec === 'Flat Monthly' ? (fmt$(flatMo) + '/mo') : (fmt$(billVisit) + '/visit'));
        var monthlyAnchor = rec === 'Hourly'
          ? fmt$(hourlyMo) + '/mo'
          : (rec === 'Flat Monthly' ? fmt$(flatMo) + '/mo' : fmt$(billVisit * freq) + '/mo');
        // Do not repeat monthlyAnchor when recRate is already a /mo figure (Flat Monthly)
        r.soWhat = 'Recommended: **' + rec + ' @ ' + recRate + '** (~' +
          Number(hrs).toFixed(1) + ' base hours/visit). ' + (r.reason || '');
        r.metrics = [
          {
            label: 'Recommended',
            value: rec + ' @ ' + recRate,
            sub: rec === 'Flat Monthly'
              ? ('~' + Number(hrs).toFixed(1) + ' hr/visit')
              : (monthlyAnchor + ' · ~' + Number(hrs).toFixed(1) + ' hr/visit'),
            accent: true,
            hero: true
          },
          { label: 'Hourly bill', value: fmt$(hourlyBill) + '/hr' },
          { label: 'Flat monthly', value: fmt$(flatMo) + '/mo' }
        ];
        r.pdfCompareRows = [
          {
            model: 'Per-Clean',
            rate: fmt$(billVisit) + '/visit',
            monthly: fmt$(billVisit * freq) + '/mo',
            creep: 'Low if capped',
            ot: 'Capped overage',
            recommended: rec === 'Per-Clean'
          },
          {
            model: 'Hourly',
            rate: fmt$(hourlyBill) + '/hr',
            monthly: fmt$(hourlyMo) + '/mo',
            creep: 'Zero for contractor',
            ot: 'Client pays hours',
            recommended: rec === 'Hourly'
          },
          {
            model: 'Flat Monthly',
            rate: fmt$(flatMo) + '/mo',
            monthly: fmt$(flatMo) + '/mo',
            creep: 'High without budget',
            ot: 'Contractor eats OT',
            recommended: rec === 'Flat Monthly'
          }
        ];
        r.sowClauses = (r.copyText || '').split(/\n/).filter(function (line) {
          return /^\d+\.\s/.test(String(line || '').trim());
        }).map(function (line) {
          return String(line).replace(/^\d+\.\s*/, '').trim();
        });
        if (!r.sowClauses.length && r.rows) {
          r.sowClauses = r.rows.filter(function (row) {
            return row && row.meta && row.meta.some(function (m) {
              return /^language$/i.test(String(m.k || ''));
            });
          }).map(function (row) {
            var m = (row.meta || []).filter(function (x) {
              return /^language$/i.test(String(x.k || ''));
            })[0];
            return m ? String(m.v || '') : '';
          }).filter(Boolean);
        }
        // Deep-link Bill Rate with active stack (base ≈ loaded/1.2 mirrors common seed)
        var baseApprox = Math.round((loaded / 1.2) * 100) / 100;
        r.handoffUrl = '/pages/bill-rate-calculator'
          + '?baseWage=' + encodeURIComponent(String(baseApprox))
          + '&loadedWage=' + encodeURIComponent(String(loaded))
          + '&billRate=' + encodeURIComponent(String(Math.round(hourlyBill * 100) / 100))
          + '&margin=' + encodeURIComponent(String(margin))
          + '&overhead=' + encodeURIComponent(String(ohPct));
        r.handoffLabel = 'Price the model → Bill Rate';
        r.handoffHint = 'Next: validate loaded labor and margin behind this rate';
        r.pdfFacilityBits = [
          Number(inputs.sqft || 0).toLocaleString() + ' SF',
          Number(inputs.prod_rate || 0).toLocaleString() + ' sqft/hr',
          Number(freq).toFixed(2) + ' visits/mo'
        ];
      }
      return r;
    }
  });

  /* SOW lives on Opora Edge only, /pages/scope-of-work-generator (opora-tool-d4-scope-of-work-generator) */

  /* ---- 5. bill-rate-calculator ---- */
  reg('bill-rate-calculator', {
    title: 'Bill Rate Calculator',
    headline: 'Calculate your loaded bill rate',
    deck: 'Enter your labor costs and get the fully-loaded bill rate you need to charge to hit your margin target.',
    blurb: 'Loaded bill rate from wage, burden, and target margin.',
    primaryLabel: 'Bill rate',
    handoffs: [
      { label: 'Stress-test your bid margin', url: '/pages/bid-stress-test', description: 'Bid Stress-Test' },
      { label: 'Build a full contract bid', url: '/pages/bid-generator', description: 'Bid Generator' },
      { label: 'Job costing for one visit', url: '/pages/job-costing-calculator', description: 'Job Costing Calculator' }
    ],
    d4: {
      basicSection: 'Labor',
      advancedSection: 'Burden & direct costs'
    },
    fields: [
      { id: 'base_wage', label: 'Base wage ($/hr)', type: 'number', default: 16 },
      { id: 'target_margin', label: 'Target margin (%)', type: 'number', default: 35 },
      { id: 'state', label: 'State', type: 'select', default: 'TX', options: stateOpts() },
      { id: 'benefits_pct', label: 'Benefits (%)', type: 'number', default: 8, advanced: true },
      { id: 'overhead_pct', label: 'Overhead (%)', type: 'number', default: 12, advanced: true },
      { id: 'supplies_per_hr', label: 'Supplies ($/hr)', type: 'number', default: 0.5, advanced: true },
      { id: 'travel_per_hr', label: 'Travel ($/hr)', type: 'number', default: 0.3, advanced: true },
      { id: 'equipment_per_hr', label: 'Equipment ($/hr)', type: 'number', default: 0.2, advanced: true },
      {
        id: 'seven_day_account',
        label: '7-day account — blend OT into loaded wage',
        type: 'checkbox',
        default: false,
        advanced: true,
        fullWidth: true,
        hint: 'Assumes ~1/7 of hours at 1.5× OT (~+7% effective wage).'
      }
    ],
    calculate: function (inputs) {
      var r = S.billRateCalc(inputs);
      if (r.valid && !r.primary) r.primary = fmt$(r.bill_rate);
      if (r.valid) {
        var baseW = num(inputs.base_wage, 16);
        r.soWhat = 'At **' + fmt$(baseW) + '/hr** wage and **' +
          String(num(inputs.target_margin, 35)) + '%** target margin, charge about **' +
          fmt$(r.bill_rate) + '/hr** loaded, this rate funds labor, OH, and margin' +
          (r.seven_day_account ? ' (includes 7-day OT blend)' : '') + '.';
        // NY Downstate advisory (Upstate floor $16 / Downstate $17) — no clamp
        if (String(inputs.state || '').toUpperCase() === 'NY' && baseW < 17) {
          r.alertBanners = [{
            level: 'warn',
            title: 'NY regional minimum wage',
            text: '$' + Number(baseW).toFixed(2) +
              '/hr meets Upstate NY minimum wage. If servicing NYC, Long Island, or Westchester County, the 2026 statutory floor is $17.00/hr.'
          }];
        }
      }
      return r;
    }
  });

  /* ---- 5b. 1099-vs-w2-calculator ---- */
  var IC_TEST_BY_STATE = {
    CA: { test: 'ABC test (AB5)', risk: 'high', note: 'California AB5 is among the strictest — on-site cleaners with set schedules usually fail the ABC test.' },
    MA: { test: 'ABC test', risk: 'high', note: 'Massachusetts ABC test makes controlled on-site cleaning hard to classify as IC.' },
    NJ: { test: 'ABC test', risk: 'high', note: 'New Jersey ABC test heavily favors employee status for directed site work.' },
    NY: { test: 'ABC / common-law hybrid', risk: 'high', note: 'New York leans employee for directed janitorial work — confirm with counsel.' },
    IL: { test: 'ABC test', risk: 'high', note: 'Illinois ABC test is strict for construction/cleaning-adjacent work.' },
    CT: { test: 'ABC test', risk: 'high', note: 'Connecticut ABC test raises misclassification risk for scheduled site cleaners.' },
    WA: { test: 'ABC-style economic reality', risk: 'elevated', note: 'Washington applies a strict economic-reality / ABC-style analysis for many workers.' },
    OR: { test: 'ABC elements', risk: 'elevated', note: 'Oregon applies ABC-like factors — directed schedules push toward W-2.' },
    CO: { test: 'Modified ABC', risk: 'elevated', note: 'Colorado modified ABC / economic reality — treat controlled cleaners carefully.' },
    TX: { test: 'Common law (20-factor)', risk: 'moderate', note: 'Texas uses common-law control factors — still risky if you set hours, tools, and route.' },
    FL: { test: 'Common law', risk: 'moderate', note: 'Florida common-law test still flags behavioral control on night crews.' },
    OTHER: { test: 'Common law / state factors', risk: 'moderate', note: 'Most states weigh behavioral, financial, and relationship control — confirm locally.' }
  };

  function compare1099VsW2(inputs) {
    var wage = num(inputs.base_wage, 17.84);
    var hours = num(inputs.annual_hours, 2080);
    var benefitsPct = num(inputs.benefits_pct, 0);
    var contractorRate = num(inputs.contractor_rate, 22);
    var overheadSavPct = num(inputs.overhead_savings_pct, 5);
    var includeReserve = !!(inputs.include_misclass_reserve === true ||
      inputs.include_misclass_reserve === 'true' ||
      inputs.include_misclass_reserve === 1 ||
      inputs.include_misclass_reserve === '1' ||
      inputs.include_misclass_reserve === 'on');
    if (!(wage > 0)) return { valid: false, errors: ['Enter a W-2 base wage greater than $0.'] };
    if (!(hours > 0)) return { valid: false, errors: ['Annual hours must be greater than 0.'] };
    if (!(contractorRate > 0)) return { valid: false, errors: ['Enter a 1099 contractor rate greater than $0.'] };

    var stateKey = String(inputs.state || 'TX').toUpperCase();
    var st = (S.STATE_BURDEN && (S.STATE_BURDEN[stateKey] || S.STATE_BURDEN.OTHER)) || { suta: 0.027, wc: 0.042 };
    var FICA = 0.0765;
    var FUTA = 0.006;
    var FUTA_BASE = 7000;
    var annual = wage * hours;
    var fica = annual * FICA;
    var futa = Math.min(annual, FUTA_BASE) * FUTA;
    var suta = annual * st.suta;
    var wcCost = annual * st.wc;
    var benefits = annual * (benefitsPct / 100);
    var taxes = fica + futa + suta + wcCost;
    var w2Total = annual + taxes + benefits;
    var w2Hr = hours > 0 ? w2Total / hours : 0;
    var w2Burden = annual > 0 ? ((taxes + benefits) / annual) * 100 : 0;
    var contractorPay = contractorRate * hours;
    var overheadSav = contractorPay * (overheadSavPct / 100);
    var misclass = includeReserve ? contractorPay * 0.20 : 0;
    var net1099 = contractorPay - overheadSav + misclass;
    var net1099Hr = hours > 0 ? net1099 / hours : 0;
    var diff = net1099 - w2Total;
    var cheaperIsW2 = diff > 0;
    var costNeutral = hours > 0 ? w2Total / hours : 0;
    var reqPremium = wage > 0 ? ((costNeutral / wage) - 1) * 100 : 0;
    var icMeta = IC_TEST_BY_STATE[stateKey] || IC_TEST_BY_STATE.OTHER;
    var pathKey = cheaperIsW2 ? 'W-2' : '1099';
    var label = cheaperIsW2 ? 'Recommended: W-2' : 'Recommended: 1099';
    var absDiff = Math.abs(diff);
    var rows = [
      { label: 'W-2 base pay', value: fmt$(annual) },
      { label: 'Employer FICA (7.65%)', value: fmt$(fica) },
      { label: 'FUTA', value: fmt$(futa) },
      { label: 'SUTA (' + stateKey + ')', value: fmt$(suta) },
      { label: 'Workers\' comp (' + stateKey + ')', value: fmt$(wcCost) },
      { label: 'Benefits', value: fmt$(benefits) },
      { label: 'W-2 total annual', value: fmt$(w2Total), emphasize: true },
      { label: '1099 contractor pay', value: fmt$(contractorPay) },
      { label: '1099 overhead savings', value: '(' + fmt$(overheadSav) + ')', credit: true },
      { label: 'Misclassification reserve', value: fmt$(misclass) },
      { label: '1099 net annual cost', value: fmt$(net1099), emphasize: true }
    ];
    var deltaLabel = cheaperIsW2
      ? ('-' + fmt$(absDiff) + ' (W-2 savings)')
      : ('+' + fmt$(absDiff) + ' (1099 savings)');
    var recText = cheaperIsW2
      ? ('Cash cost favors W-2 by ' + fmt$(absDiff) + '/yr at these inputs. Still confirm classification under ' +
        stateKey + ' rules before you hire.')
      : ('Cash cost favors 1099 by ' + fmt$(absDiff) + '/yr at these inputs. Misclassification risk in ' +
        stateKey + ' is ' + icMeta.risk + ' — confirm with counsel before you engage.');
    return {
      valid: true,
      primary: label,
      secondary: fmt$(absDiff) + '/yr gap · cost-neutral 1099 ' + fmt$(costNeutral) + '/hr',
      secondaryLabel: 'Annual cost delta',
      soWhat: '**Recommended path: ' + pathKey + '.** At **' + fmt$(wage) + '/hr** W-2 vs **' +
        fmt$(contractorRate) + '/hr** 1099 in **' + stateKey + '**, **' + pathKey +
        '** is lower cash cost by **' + fmt$(absDiff) + '/yr**. Cost-neutral 1099 rate is about **' +
        fmt$(costNeutral) + '/hr** (' + reqPremium.toFixed(1) + '% above base). ' + stateKey +
        ' uses **' + icMeta.test + '** — risk band **' + icMeta.risk + '**.',
      recommendationPill: {
        label: 'RECOMMENDED PATH: ' + pathKey,
        level: 'ok',
        text: recText
      },
      statusPill: {
        label: icMeta.risk.toUpperCase() + ' RISK · ' + stateKey,
        level: icMeta.risk === 'high' ? 'bad' : (icMeta.risk === 'elevated' ? 'warn' : 'ok'),
        text: icMeta.note
      },
      metrics: [
        { label: 'W-2 annual', value: fmt$(w2Total) },
        { label: '1099 annual', value: fmt$(net1099) },
        { label: 'Annual delta', value: deltaLabel, hero: true, accent: true }
      ],
      bands: [
        { label: 'W-2 $/hr', value: fmt$(w2Hr) },
        { label: '1099 $/hr', value: fmt$(net1099Hr) },
        { label: 'Neutral 1099', value: fmt$(costNeutral), target: true }
      ],
      rows: rows,
      findings: [
        'Recommended path: ' + pathKey + ' (lower cash cost by ' + fmt$(absDiff) + '/yr).',
        'Cost-neutral 1099 rate: ' + fmt$(costNeutral) + '/hr (' + reqPremium.toFixed(1) + '% above W-2 base).',
        stateKey + ' classification test: ' + icMeta.test + ' — ' + icMeta.note,
        'This is a cost and risk screen, not legal advice. Confirm with payroll counsel before you post the role.'
      ],
      w2_total: w2Total,
      net1099: net1099,
      cost_neutral_rate: costNeutral,
      req_premium: reqPremium,
      state: stateKey,
      risk_level: icMeta.risk,
      recommended_path: pathKey
    };
  }

  reg('1099-vs-w2-calculator', {
    title: '1099 vs W-2 Calculator',
    headline: 'Compare true 1099 vs W-2 cost',
    deck: 'See payroll burden, cost-neutral contractor rate, and state misclassification risk before you decide.',
    blurb: 'True annual cost of W-2 vs 1099 with state burden and risk flags.',
    primaryLabel: 'Recommended path',
    actionLabel: 'Calculate costs',
    handoffs: [
      { label: 'Screen the hire', url: '/pages/hire-right', description: 'Hire Right' },
      { label: 'Price loaded labor', url: '/pages/bill-rate-calculator', description: 'Bill Rate Calculator' },
      { label: 'Draft IC agreement checklist', url: '/pages/independent-contractor-agreement', description: 'IC Agreement' }
    ],
    d4: {
      basicSection: 'W-2 employee',
      advancedSection: 'Benefits & reserves'
    },
    fields: [
      { id: 'base_wage', label: 'W-2 base hourly wage ($/hr)', type: 'number', default: 17.84 },
      { id: 'state', label: 'State', type: 'select', default: 'TX', options: stateOpts() },
      { id: 'annual_hours', label: 'Annual hours worked', type: 'number', default: 2080 },
      { id: 'contractor_rate', label: '1099 contractor rate ($/hr)', type: 'number', default: 22 },
      { id: 'benefits_pct', label: 'Benefits (% of W-2 wages)', type: 'number', default: 0, advanced: true },
      {
        id: 'overhead_savings_pct',
        label: '1099 overhead savings (%)',
        type: 'number',
        default: 5,
        advanced: true,
        hint: 'Admin / payroll time you avoid by not putting them on payroll.'
      },
      {
        id: 'include_misclass_reserve',
        label: 'Include 20% misclassification reserve on 1099 cost',
        type: 'checkbox',
        default: true,
        advanced: true,
        fullWidth: true,
        hint: 'Illustrative reserve for back taxes / penalties if the worker is reclassified.'
      }
    ],
    calculate: function (inputs) {
      return compare1099VsW2(inputs);
    }
  });

  /* ---- 7. federal-rfp-filter ---- */
  /** Static SBA receipts caps (avg annual receipts, 5-yr). Verify on SBA table before certifying size. */
  var FED_NAICS_SBA = {
    '561720': { label: 'Janitorial Services', fit: 'strong', sizeM: 22 },
    '561790': { label: 'Other Building / Dwelling Services', fit: 'strong', sizeM: 9 },
    '561210': { label: 'Facilities Support Services (Base Ops)', fit: 'adjacent', sizeM: 47 },
    '561730': { label: 'Landscaping Services', fit: 'adjacent', sizeM: 9.5 },
    '561740': { label: 'Carpet & Upholstery Cleaning', fit: 'adjacent', sizeM: 8.5 },
    '238990': { label: 'Specialty Trade Contractors', fit: 'adjacent', sizeM: 19 },
    '561110': { label: 'Office Administrative Services', fit: 'weak', sizeM: 12.5 }
  };
  var FED_SET_ASIDE_LABELS = {
    unrestricted: 'Unrestricted / open',
    total_sb: 'Total Small Business',
    '8a': '8(a)',
    wosb: 'WOSB / EDWOSB',
    sdvosb: 'SDVOSB',
    hubzone: 'HUBZone'
  };

  /** Normalize free-text county for SAM.gov WD keyword search. */
  function normalizeFedCounty(raw) {
    var s = String(raw == null ? '' : raw)
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
    if (!s) return '';
    // "County of X" / "Parish of X" before stripping the bare suffix word
    s = s.replace(/^(county|parish)\s+of\s+/i, '').trim();
    // "Flathead County" → "Flathead"; keep independent-city names like "St. Louis City"
    s = s.replace(/\b(county|parish|borough|census area|municipality|city and borough)\.?$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
    // Cap length / strip control chars for URL safety
    s = s.replace(/[^\w\s.'\-]/g, '').slice(0, 80).trim();
    return s;
  }

  function buildSamWdUrl(stateAbbr, countyRaw, wdNumber) {
    if (wdNumber) {
      return 'https://sam.gov/wage-determination/' + encodeURIComponent(String(wdNumber));
    }
    var state = String(stateAbbr || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
    var county = normalizeFedCounty(countyRaw);
    var parts = ['SCA'];
    if (county) parts.push(county);
    if (state) parts.push(state);
    var q = parts.join(' ');
    return 'https://sam.gov/search/?index=wd&page=1&pageSize=25&sort=-modifiedDate&sfm%5BsimpleSearch%5D%5BkeywordRadio%5D=ALL&sfm%5BsimpleSearch%5D%5BkeywordTags%5D%5B0%5D%5Bkey%5D=' +
      encodeURIComponent(q) +
      '&sfm%5BsimpleSearch%5D%5BkeywordTags%5D%5B0%5D%5Bvalue%5D=' +
      encodeURIComponent(q);
  }

  function bindFederalRfpCountyCombobox(root) {
    if (!root || root.dataset.fedPopBound || !global.OporaFedPop) return;
    var stateEl = root.querySelector('[data-calc-field="state"]');
    var countyEl = root.querySelector('[data-calc-field="county"]');
    if (!stateEl || !countyEl) return;
    root.dataset.fedPopBound = '1';

    var fieldWrap = countyEl.closest('.d4-f-field');
    if (!fieldWrap) return;
    fieldWrap.classList.add('fed-pop-combobox');

    var listId = 'fed-pop-list-' + Math.random().toString(36).slice(2, 9);
    var list = document.createElement('ul');
    list.className = 'fed-pop-combobox__list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    var note = document.createElement('p');
    note.className = 'fed-pop-combobox__note';
    note.hidden = true;

    countyEl.setAttribute('role', 'combobox');
    countyEl.setAttribute('aria-autocomplete', 'list');
    countyEl.setAttribute('aria-controls', listId);
    countyEl.setAttribute('aria-expanded', 'false');
    countyEl.setAttribute('autocomplete', 'off');
    countyEl.setAttribute('spellcheck', 'false');

    fieldWrap.appendChild(list);
    fieldWrap.appendChild(note);

    var activeIndex = -1;
    var currentItems = [];
    var countyFocused = false;

    var stateFieldWrap = stateEl.closest('.d4-f-field');

    function clearNote() {
      note.hidden = true;
      note.textContent = '';
      note.classList.remove('fed-pop-combobox__note--error', 'fed-pop-combobox__note--hint');
      fieldWrap.classList.remove('fed-pop-combobox--invalid');
      countyEl.removeAttribute('aria-invalid');
      if (stateFieldWrap) stateFieldWrap.classList.remove('fed-pop-combobox--invalid');
      stateEl.removeAttribute('aria-invalid');
    }

    function showTypingHint() {
      var stateLabel = global.OporaFedPop.stateName(stateEl.value) || stateEl.value || 'this state';
      note.textContent = 'Searching ' + stateLabel + ' cities and counties…';
      note.hidden = false;
      note.classList.remove('fed-pop-combobox__note--error');
      note.classList.add('fed-pop-combobox__note--hint');
    }

    function showFieldError(msg, isError, geo) {
      note.textContent = msg;
      note.hidden = false;
      note.classList.toggle('fed-pop-combobox__note--error', isError !== false);
      note.classList.remove('fed-pop-combobox__note--hint');
      fieldWrap.classList.add('fed-pop-combobox--invalid');
      countyEl.setAttribute('aria-invalid', 'true');
      if (geo && geo.mismatch && stateFieldWrap) {
        stateFieldWrap.classList.add('fed-pop-combobox--invalid');
        stateEl.setAttribute('aria-invalid', 'true');
      }
    }

    function validateCountyField(opts) {
      opts = opts || {};
      var raw = countyEl.value.trim();
      if (!raw) {
        if (opts.require) {
          showFieldError(
            'Enter the county or major city of performance — SCA wage determinations are indexed by county, not state-wide.',
            true
          );
          fieldWrap.classList.add('fed-pop-combobox--invalid');
          countyEl.setAttribute('aria-invalid', 'true');
        } else {
          clearNote();
        }
        return false;
      }
      var geo = global.OporaFedPop.resolve(stateEl.value, raw);
      if (geo.ok) {
        clearNote();
        return true;
      }
      showFieldError(geo.error, !geo.unindexed, geo);
      return false;
    }

    function setCountyFocused(focused) {
      countyFocused = !!focused;
      global.OporaFedPop.countyFocused = countyFocused;
      if (countyFocused) {
        fieldWrap.classList.remove('fed-pop-combobox--invalid');
        countyEl.removeAttribute('aria-invalid');
      }
    }

    global.OporaFedPop.showCountyFieldError = function (msg, isError, geo) {
      showFieldError(msg, isError, geo);
    };
    global.OporaFedPop.clearCountyFieldError = clearNote;
    global.OporaFedPop.validateCountyOnSubmit = function () {
      return validateCountyField({ require: true });
    };

    function closeList() {
      list.hidden = true;
      countyEl.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      currentItems = [];
      list.innerHTML = '';
    }

    function renderList(items) {
      currentItems = items;
      activeIndex = items.length ? 0 : -1;
      if (!items.length) {
        closeList();
        if (countyFocused && countyEl.value.trim().length >= 2) showTypingHint();
        else clearNote();
        return;
      }
      list.innerHTML = items.map(function (item, idx) {
        return '<li class="fed-pop-combobox__option" role="option" data-idx="' + idx + '" id="' + listId + '-opt-' + idx + '">' +
          item.label + (item.wd ? (' <span class="fed-pop-combobox__wd">WD ' + item.wd + '</span>') : '') +
          '</li>';
      }).join('');
      list.hidden = false;
      countyEl.setAttribute('aria-expanded', 'true');
      highlightActive();
      clearNote();
    }

    function highlightActive() {
      var opts = list.querySelectorAll('.fed-pop-combobox__option');
      opts.forEach(function (el, i) {
        el.classList.toggle('is-active', i === activeIndex);
        el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
      if (activeIndex >= 0 && opts[activeIndex]) {
        countyEl.setAttribute('aria-activedescendant', opts[activeIndex].id);
      } else {
        countyEl.removeAttribute('aria-activedescendant');
      }
    }

    function pick(item) {
      if (!item) return;
      countyEl.value = item.value;
      closeList();
      clearNote();
      countyEl.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function onInput() {
      var q = countyEl.value.trim();
      if (q.length < 2) {
        closeList();
        clearNote();
        return;
      }
      renderList(global.OporaFedPop.search(stateEl.value, q, 8));
    }

    countyEl.addEventListener('focus', function () {
      setCountyFocused(true);
      var q = countyEl.value.trim();
      if (q.length >= 2) onInput();
      else clearNote();
    });

    countyEl.addEventListener('input', onInput);

    countyEl.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!currentItems.length) return;
        activeIndex = Math.min(activeIndex + 1, currentItems.length - 1);
        highlightActive();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        highlightActive();
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && currentItems[activeIndex]) {
          e.preventDefault();
          pick(currentItems[activeIndex]);
        }
      } else if (e.key === 'Escape') {
        closeList();
      }
    });

    list.addEventListener('mousedown', function (e) {
      var opt = e.target.closest('.fed-pop-combobox__option');
      if (!opt) return;
      e.preventDefault();
      var idx = parseInt(opt.getAttribute('data-idx') || '-1', 10);
      if (currentItems[idx]) pick(currentItems[idx]);
    });

    countyEl.addEventListener('blur', function () {
      setCountyFocused(false);
      setTimeout(function () {
        closeList();
        validateCountyField();
      }, 150);
    });

    stateEl.addEventListener('change', function () {
      countyEl.value = '';
      closeList();
      clearNote();
    });

    stateEl.addEventListener('focus', function () {
      if (stateFieldWrap) stateFieldWrap.classList.remove('fed-pop-combobox--invalid');
      stateEl.removeAttribute('aria-invalid');
    });
  }

  if (global.OporaCalc && typeof global.OporaCalc.mount === 'function') {
    var _fedOrigMount = global.OporaCalc.mount;
    global.OporaCalc.mount = function (container) {
      var slug = container.getAttribute('data-slug') || container.getAttribute('data-tool') || '';
      if (slug === 'federal-rfp-filter') bindFederalRfpCountyCombobox(container);
      _fedOrigMount(container);
    };
  }

  reg('federal-rfp-filter', {
    title: 'Federal RFP Filter',
    blurb: 'Screen federal janitorial opportunities by NAICS, SCA, SAT, and set-aside.',
    primaryLabel: 'Verdict',
    fields: [
      { id: 'naics', label: 'NAICS code', type: 'select', default: '561720', fullWidth: true, options: [
        { value: '561720', label: '561720 — Janitorial' },
        { value: '561790', label: '561790 — Other building svcs' },
        { value: '561210', label: '561210 — Facilities support' },
        { value: '561730', label: '561730 — Landscaping' },
        { value: '561740', label: '561740 — Carpet cleaning' },
        { value: '238990', label: '238990 — Specialty trades' },
        { value: '561110', label: '561110 — Office admin (weak)' }
      ]},
      { id: 'contract_value', label: 'Estimated contract value ($)', type: 'number', default: 250000 },
      { id: 'state', label: 'Place of performance (state)', type: 'select', default: 'TX', options: stateOpts() },
      { id: 'county', label: 'County / city of performance', type: 'text', default: '', placeholder: 'Type city or county — e.g. Fort Worth, Tarrant', hint: 'Type 2+ characters for matches. County is safest — SCA WDs are indexed by county.' },
      { id: 'set_aside', label: 'Set-aside track', type: 'select', default: 'unrestricted', fullWidth: true, options: [
        { value: 'unrestricted', label: 'Unrestricted / open' },
        { value: 'total_sb', label: 'Total Small Business' },
        { value: '8a', label: '8(a)' },
        { value: 'wosb', label: 'WOSB / EDWOSB' },
        { value: 'sdvosb', label: 'SDVOSB' },
        { value: 'hubzone', label: 'HUBZone' }
      ]},
      { id: 'sca_wd_pulled', label: 'I already pulled the SCA WD', type: 'checkbox', default: false, advanced: true }
    ],
    calculate: function (inputs) {
      var naics = String(inputs.naics || '561720');
      var val = num(inputs.contract_value, 0);
      if (!val || val < 0) return { valid: false, errors: ['Enter contract value.'] };
      var state = String(inputs.state || '').toUpperCase() || '—';
      var countyRaw = String(inputs.county || '').replace(/\s+/g, ' ').trim();
      var geo = global.OporaFedPop && typeof global.OporaFedPop.resolve === 'function'
        ? global.OporaFedPop.resolve(state, countyRaw)
        : null;
      var popUi = global.OporaFedPop;
      var countyTyping = popUi && popUi.countyFocused;
      var popResultHint = 'Enter place of performance to run the bid screen.';
      if (geo && !geo.ok) {
        if (!countyTyping && popUi && typeof popUi.validateCountyOnSubmit === 'function') {
          popUi.validateCountyOnSubmit();
        } else if (!countyTyping && popUi && typeof popUi.showCountyFieldError === 'function') {
          popUi.showCountyFieldError(geo.error, !geo.unindexed, geo);
        }
        return {
          valid: false,
          errors: [],
          resultHint: geo.error,
          resultHintLevel: geo.mismatch ? 'warn' : 'neutral'
        };
      }
      if (!countyRaw) {
        if (!countyTyping && popUi && typeof popUi.validateCountyOnSubmit === 'function') {
          popUi.validateCountyOnSubmit();
        }
        return { valid: false, errors: [], resultHint: popResultHint };
      }
      if (!geo) {
        return { valid: false, errors: ['Place-of-performance lookup is unavailable. Refresh and try again.'] };
      }
      if (popUi && typeof popUi.clearCountyFieldError === 'function') popUi.clearCountyFieldError();

      var countyNorm = geo.county;
      var wdNumber = geo.wd || null;
      var popLabel = geo.label + ', ' + state;
      var samWdUrl = buildSamWdUrl(state, countyNorm, wdNumber);

      var meta = FED_NAICS_SBA[naics] || { label: 'Unknown NAICS', fit: 'weak', sizeM: null };
      var naicsStrong = meta.fit === 'strong';
      var naicsAdjacent = meta.fit === 'adjacent';
      var naicsOk = naicsStrong || naicsAdjacent;
      var scaRequired = val >= 2500;
      var satAtOrAbove = val >= 250000;
      var wdPulled = !!inputs.sca_wd_pulled;
      var setAsideKey = String(inputs.set_aside || 'unrestricted');
      var setAsideLabel = FED_SET_ASIDE_LABELS[setAsideKey] || setAsideKey;
      var setAsideRestricted = setAsideKey !== 'unrestricted';

      var sizeStr = meta.sizeM != null
        ? ('$' + (Number.isInteger(meta.sizeM) ? meta.sizeM.toFixed(1) : String(meta.sizeM)) + 'M avg annual receipts (5-yr)')
        : 'Look up on SBA size standards table';

      var walkAway = !naicsOk;
      var pass = !walkAway && (!scaRequired || wdPulled);
      var needsReview = !walkAway && !pass;

      var scaValue = !scaRequired
        ? 'Not required (<$2,500)'
        : (wdPulled
          ? ('Required — ' + (wdNumber ? ('WD ' + wdNumber + ' ') : '') + 'marked pulled (verify active rate on SAM.gov)')
          : ('Required by FAR Part 22 — pull ' + (wdNumber ? ('WD ' + wdNumber) : 'county WD') + ' on SAM.gov'));
      var scaOk = !scaRequired || wdPulled;
      var satValue = satAtOrAbove
        ? 'At/above $250k SAT (FAR Part 13)'
        : 'Below $250k Simplified Acquisition Threshold';

      var next = [];
      if (walkAway) {
        next.push('NAICS ' + naics + ' is a weak fit for janitorial/facilities work — walk away unless the SOW clearly maps to your services.');
      } else if (scaRequired && !wdPulled) {
        // Single directive — do not also push a separate "maps to WD…" line (that looped the same pull instruction)
        if (wdNumber) {
          next.push(
            'SCA locality maps to WD ' + wdNumber + ' for ' + popLabel +
            '. Because this contract exceeds the statutory $2,500 SCA threshold, pull WD ' + wdNumber +
            ' from SAM.gov to price prevailing wages and mandatory Health & Welfare fringe rates before submitting.'
          );
        } else {
          next.push(
            'Because this contract exceeds the statutory $2,500 SCA threshold, pull the county SCA wage determination from SAM.gov to price prevailing wages and mandatory Health & Welfare fringe rates before submitting.'
          );
        }
      } else if (wdNumber) {
        next.push(
          'SCA locality maps to WD ' + wdNumber + ' for ' + popLabel +
          ' — confirm the solicitation attaches that determination before pricing labor.'
        );
      }
      if (satAtOrAbove) next.push('Contract value is at or above the $250,000 Simplified Acquisition Threshold — confirm acquisition procedure and competition rules.');
      if (setAsideRestricted) next.push('Confirm your active SAM.gov / SBA certification matches ' + setAsideLabel + ' before you bid.');
      if (meta.sizeM != null && setAsideRestricted) {
        next.push('SBA size standard for this NAICS is ' + sizeStr + ' — certify size at time of offer.');
      }
      if (pass && !next.length) next.push('Screen looks clear. Still verify SOW, SCA WD, and SAM.gov before bidding.');

      var primary = walkAway ? 'Walk away' : (needsReview || !pass ? 'Review required' : 'Pass');
      var secondary = walkAway
        ? 'NAICS fit is too weak for a janitorial bid screen'
        : (pass ? 'Filters clear for a facilities / janitorial bid screen' : 'Resolve the flags below before you bid');
      var verdictTone = walkAway ? 'bad' : (pass ? 'ok' : 'warn');
      var localeMeta = state + ' · ' + countyNorm + (wdNumber ? (' · WD ' + wdNumber) : '');

      return {
        valid: true,
        primary: primary,
        secondary: secondary,
        soWhat: next.join(' '),
        // Amber / rose / emerald on Verdict — matches Needs review / Walk away / Pass
        metrics: [
          {
            label: 'Verdict',
            value: primary,
            accent: true,
            hero: true,
            tone: verdictTone
          },
          {
            label: 'Detail',
            value: secondary
          }
        ],
        statusPill: {
          label: walkAway ? 'Weak NAICS fit' : (pass ? 'Bid-ready screen' : 'Needs review'),
          level: walkAway ? 'bad' : (pass ? 'ok' : 'warn')
        },
        // PDF header meta — never inherit Facility SF from sibling tools / shared shell
        pdfHeaderMeta: 'NAICS: ' + naics + ' | Value: ' + fmt$(val) + ' | Locality: ' + localeMeta,
        bands: [
          { label: 'NAICS', value: naics, target: naicsOk },
          { label: 'Value', value: fmt$(val) },
          { label: 'Locale', value: localeMeta }
        ],
        rows: [
          { label: 'NAICS fit', value: meta.label + (meta.fit === 'adjacent' ? ' (adjacent)' : (meta.fit === 'weak' ? ' (weak)' : '')), ok: naicsOk },
          { label: 'SBA size standard', value: sizeStr, ok: meta.sizeM != null, warn: setAsideRestricted },
          { label: 'SCA wage determination', value: scaValue, ok: scaOk, warn: scaRequired && !wdPulled },
          { label: 'SAT posture', value: satValue, ok: true, warn: satAtOrAbove },
          { label: 'Set-aside track', value: setAsideLabel, ok: true, warn: setAsideRestricted },
          { label: 'Place of performance', value: popLabel + (wdNumber ? (' · WD ' + wdNumber) : ''), ok: true, warn: false }
        ],
        handoffSecondary: scaRequired
          ? { label: (wdNumber ? ('Open WD ' + wdNumber + ' on SAM.gov →') : 'Find SCA WD on SAM.gov →'), url: samWdUrl }
          : null
      };
    }
  });

  /* ---- 8. price-increase-letter ---- */
  function parsePriceIncreaseDate(raw) {
    var s = String(raw || '').trim();
    if (!s || /^next\s+renewal$/i.test(s)) return null;
    var m = s.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/);
    if (m) {
      var y = parseInt(m[3], 10);
      if (y < 100) y += 2000;
      var d = new Date(y, parseInt(m[1], 10) - 1, parseInt(m[2], 10));
      return isNaN(d.getTime()) ? null : d;
    }
    m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      var d2 = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
      return isNaN(d2.getTime()) ? null : d2;
    }
    var d3 = new Date(s);
    return isNaN(d3.getTime()) ? null : d3;
  }
  function formatPriceIncreaseLongDate(d) {
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  function formatPriceIncreaseShortDate(d) {
    var mm = String(d.getMonth() + 1);
    var dd = String(d.getDate());
    if (mm.length < 2) mm = '0' + mm;
    if (dd.length < 2) dd = '0' + dd;
    return mm + '/' + dd + '/' + d.getFullYear();
  }
  function addPriceIncreaseDays(base, n) {
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() + n);
    return d;
  }
  function daysNoticePriceIncrease(from, to) {
    var a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
    var b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
    return Math.round((b - a) / 86400000);
  }

  reg('price-increase-letter', {
    title: 'Price Increase Letter',
    kind: 'generator',
    blurb: 'Generate a professional price adjustment letter preview.',
    primaryLabel: 'New monthly rate',
    actionLabel: 'Generate',
    fields: [
      { id: 'client_name', label: 'Client name', type: 'text', default: 'Acme Facilities' },
      { id: 'current_monthly', label: 'Current monthly rate ($)', type: 'number', default: 4200 },
      { id: 'increase_pct', label: 'Increase (%)', type: 'number', default: 5 },
      {
        id: 'effective_date',
        label: 'Effective date',
        type: 'text',
        default: '10/15/2026',
        hint: 'Use MM/DD/YYYY. Most commercial agreements need 30–60 days written notice.'
      },
      {
        id: 'reason',
        label: 'Primary reason',
        type: 'select',
        default: 'statutory_wage',
        fullWidth: true,
        options: [
          { value: 'statutory_wage', label: 'Statutory wage increase' },
          { value: 'bls_cpi', label: 'BLS CPI indexation' },
          { value: 'contract_escalation', label: 'Contractual annual escalation clause' },
          { value: 'supply', label: 'Supply & chemical inflation' },
          { value: 'insurance', label: 'Insurance premium increase' },
          { value: 'scope', label: 'Scope expansion' }
        ]
      },
      { id: 'contractor_name', label: 'Your company name (letterhead)', type: 'text', default: '', advanced: true, placeholder: 'Your Company LLC' },
      { id: 'contract_number', label: 'Contract / account #', type: 'text', default: '', advanced: true, placeholder: 'Optional — shown on RE: line' },
      {
        id: 'wage_from',
        label: 'Prior wage ($/hr)',
        type: 'number',
        default: 15.5,
        advanced: true,
        visibleWhen: { id: 'reason', eq: 'statutory_wage' }
      },
      {
        id: 'wage_to',
        label: 'New wage ($/hr)',
        type: 'number',
        default: 16.5,
        advanced: true,
        visibleWhen: { id: 'reason', eq: 'statutory_wage' }
      },
      {
        id: 'labor_cost_share',
        label: 'Labor share of operating cost (%)',
        type: 'number',
        default: 62,
        advanced: true,
        visibleWhen: { id: 'reason', eq: 'statutory_wage' }
      },
      {
        id: 'cpi_pct',
        label: 'BLS CPI-U 12-mo change (%)',
        type: 'number',
        default: 4.2,
        advanced: true,
        visibleWhen: { id: 'reason', eq: 'bls_cpi' }
      },
      {
        id: 'contract_section',
        label: 'Contract section reference',
        type: 'text',
        default: '4.2 (Annual Escalation)',
        advanced: true,
        visibleWhen: { id: 'reason', eq: 'contract_escalation' }
      }
    ],
    calculate: function (inputs) {
      var cur = num(inputs.current_monthly);
      var pct = num(inputs.increase_pct, 5);
      var client = capitalizeWords(inputs.client_name);
      if (!client) return { valid: false, errors: ['Enter client name.'] };
      if (!cur) return { valid: false, errors: ['Enter current monthly rate.'] };
      var neu = cur * (1 + pct / 100);
      var deltaMo = neu - cur;
      var deltaYr = deltaMo * 12;
      var reasonKey = String(inputs.reason || 'statutory_wage');
      var wageFrom = num(inputs.wage_from, 15.5);
      var wageTo = num(inputs.wage_to, 16.5);
      var laborShare = num(inputs.labor_cost_share, 62);
      var cpiPct = num(inputs.cpi_pct, 4.2);
      var contractSection = String(inputs.contract_section || '4.2 (Annual Escalation)').trim() || '4.2 (Annual Escalation)';
      var contractorName = String(inputs.contractor_name || '').trim() || 'Contractor Operations';
      var contractNumber = String(inputs.contract_number || '').replace(/^#+/, '').trim();
      var contractRef = contractNumber || '[XXXX]';

      var wageDeltaPct = wageFrom > 0 ? ((wageTo - wageFrom) / wageFrom) * 100 : 0;
      var justification = '';
      if (reasonKey === 'statutory_wage') {
        justification =
          'This adjustment reflects the mandatory state minimum wage increase from ' +
          fmt$(wageFrom) + '/hr to ' + fmt$(wageTo) + '/hr (+' + wageDeltaPct.toFixed(1) +
          '%), which represents approximately ' + laborShare.toFixed(0) +
          '% of our direct operating costs on this account.';
      } else if (reasonKey === 'bls_cpi') {
        justification =
          'This adjustment reflects the trailing 12-month Bureau of Labor Statistics Consumer Price Index (CPI-U) change of ' +
          cpiPct.toFixed(1) + '%, alongside regional supply and consumables cost pressure.';
      } else if (reasonKey === 'contract_escalation') {
        justification =
          'This notice is submitted in accordance with Section ' + contractSection +
          ' of our executed Service Agreement.';
      } else if (reasonKey === 'supply') {
        justification = 'This adjustment reflects supply and chemical cost inflation that we can no longer absorb without eroding service quality.';
      } else if (reasonKey === 'insurance') {
        justification = 'This adjustment reflects insurance premium increases allocated to this account.';
      } else if (reasonKey === 'scope') {
        justification = 'This adjustment reflects expanded scope of services agreed for this account.';
      } else {
        justification = 'This adjustment reflects operating cost increases that affect delivery of the contracted scope.';
      }

      var today = new Date();
      var effRaw = String(inputs.effective_date || '').trim();
      var effDate = parsePriceIncreaseDate(effRaw);
      var effLabel = effDate ? formatPriceIncreaseLongDate(effDate) : (effRaw || 'your next renewal');
      var todayLabel = formatPriceIncreaseLongDate(today);
      var noticeDays = effDate != null ? daysNoticePriceIncrease(today, effDate) : null;

      var alertBanners = [];
      if (noticeDays != null && noticeDays < 30) {
        var rec30 = formatPriceIncreaseShortDate(addPriceIncreaseDays(today, 30));
        var rec60 = formatPriceIncreaseShortDate(addPriceIncreaseDays(today, 60));
        alertBanners.push({
          level: 'warn',
          title: 'Notice period',
          text: 'Notice window is ' + noticeDays + ' day' + (noticeDays === 1 ? '' : 's') +
            '. Most commercial agreements require at least 30 to 60 days\' advance written notice. Recommended effective date: ' +
            rec30 + ' (30 days) or ' + rec60 + ' (60 days).',
          actions: [
            { label: 'Set to 30 days out', days: 30 },
            { label: 'Set to 60 days out', days: 60 }
          ]
        });
      }

      var pctLabel = (Math.round(pct * 10) / 10).toFixed(1).replace(/\.0$/, '');
      var rateSentence =
        'Effective ' + effLabel + ', our monthly service rate for janitorial services will adjust from ' +
        fmt$(cur) + ' to ' + fmt$(neu) + ' (+' + pctLabel + '% / +' + fmt$(deltaMo) +
        '/month), or +' + fmt$(deltaYr) + '/year.';

      var bodyParas = [
        rateSentence,
        justification,
        'Scope and service standards remain unchanged. We value your partnership and welcome a conversation before the effective date.'
      ];

      var reLine = 'NOTICE OF SERVICE RATE ADJUSTMENT - CONTRACT #' +
        (contractNumber ? contractNumber : ' [XXXX]');
      var letterLines = [
        todayLabel,
        '',
        'VIA ELECTRONIC DELIVERY',
        client,
        'Attn: Facilities / Property Management',
        '',
        'RE: ' + reLine,
        '',
        'Dear ' + client + ' Team,',
        '',
        bodyParas[0],
        '',
        bodyParas[1],
        '',
        bodyParas[2],
        '',
        'Sincerely,',
        contractorName,
        'Account Manager / Operations',
        '',
        'AGREED & ACCEPTED:',
        client,
        '',
        'By: _________________________________    Date: ____________________',
        'Name / Title: ___________________________________________________'
      ];
      var letterText = letterLines.join('\n');

      return {
        valid: true,
        primary: fmt$(neu) + '/mo',
        rows: [
          { label: 'Current', value: fmt$(cur) },
          { label: 'Increase', value: pctLabel + '%' },
          { label: 'New monthly', value: fmt$(neu) },
          { label: 'Annual delta', value: fmt$(deltaYr) }
        ],
        alertBanners: alertBanners,
        narrative: letterText,
        narrativeLabel: 'Letter',
        copyText: letterText,
        copyLabel: 'Copy letter',
        // Dedicated formal PDF — not the calculator dashboard
        formalLetter: {
          letterhead: contractorName,
          dateLabel: todayLabel,
          client: client,
          reLine: reLine,
          salutation: 'Dear ' + client + ' Team,',
          paragraphs: bodyParas,
          closer: 'Sincerely,',
          signerName: contractorName,
          signerTitle: 'Account Manager / Operations',
          acceptClient: client
        }
      };
    }
  });

  /* ---- 9. sales-script-picker ---- */
  reg('sales-script-picker', {
    title: 'Sales Script Picker',
    blurb: 'Objection-handling scripts for commercial cleaning sales.',
    primaryLabel: 'Script',
    actionLabel: 'Generate',
    fields: [
      { id: 'objection_type', label: 'Objection type', type: 'select', default: 'price', options: [
        { value: 'price', label: 'Price too high' },
        { value: 'incumbent', label: 'Happy with current vendor' },
        { value: 'timing', label: 'Bad timing' },
        { value: 'scope', label: 'Scope too broad' },
        { value: 'insurance', label: 'Insurance requirements' },
        { value: 'three_bids', label: 'Need three bids' },
        { value: 'in_house', label: 'We clean in-house' },
        { value: 'decision_maker', label: 'Decision-maker not here' },
        { value: 'too_small', label: 'Account feels too small / too big' }
      ]},
      { id: 'facility_type', label: 'Facility type', type: 'select', default: 'office', options: benchmarkVerticalOpts() },
      { id: 'tone', label: 'Tone', type: 'select', default: 'direct', options: [
        { value: 'direct', label: 'Direct' },
        { value: 'soft', label: 'Soft' },
        { value: 'executive', label: 'Executive' }
      ]},
      {
        id: 'contact_role',
        label: 'Target contact role',
        type: 'select',
        default: 'facility_mgr',
        fullWidth: true,
        options: [
          { value: 'facility_mgr', label: 'Property / Facility Manager' },
          { value: 'store_gm', label: 'General Manager / Store Lead' },
          { value: 'procurement', label: 'Procurement Officer' }
        ]
      },
      { id: 'company_name', label: 'Your company name', type: 'text', default: '', advanced: true },
      {
        id: 'price_band',
        label: 'Price / range to mention',
        type: 'text',
        default: '',
        advanced: true,
        placeholder: 'e.g. 2000 or 2000-2500',
        hint: 'Single amount or corridor (2000-2500). Formats as $2,000/mo or $2,000–$2,500/mo.'
      },
      { id: 'renewal_month', label: 'Renewal month (if known)', type: 'text', default: '', advanced: true }
    ],
    calculate: function (inputs) {
      var s = buildSalesScript(inputs);
      var metaBits = [s.toneLabel, s.facilityLabel, s.contactLabel];
      if (s.company) metaBits.push(s.company);
      return {
        valid: true,
        layout: 'script',
        primary: s.title,
        secondary: metaBits.join(' · '),
        secondaryLabel: 'Tone · Facility',
        secondaryParts: [
          { t: s.toneLabel, hl: true },
          { t: ' · ' },
          { t: s.facilityLabel, hl: true },
          { t: ' · ' },
          { t: s.contactLabel, hl: true }
        ].concat(s.company ? [{ t: ' · ' }, { t: s.company, hl: true }] : []),
        scriptBeats: s.beats,
        copyText: s.copyText,
        copyLabel: 'Copy script',
        soWhat: 'Use the Ask, then show where your number sits vs market — do not open with a discount.',
        handoffHint: 'Next: pressure-test the priced scope behind this objection',
        handoffLabel: 'Re-scope this objection → Bid Stress-Test',
        // PDF header — never map company_name as Facility
        pdfHeaderMeta: 'Target: ' + s.facilityLabel +
          ' | Rep Firm: ' + (s.company || 'Sales Operations') +
          ' | Focus: ' + s.title
      };
    }
  });

  /* ---- 10. independent-contractor-agreement ---- */
  reg('independent-contractor-agreement', {
    title: 'Independent Contractor Agreement',
    kind: 'generator',
    blurb: 'Draft a commercial janitorial subcontract checklist with consideration, access, and insurance terms.',
    primaryLabel: 'Agreement',
    actionLabel: 'Generate',
    fields: [
      { id: 'state', label: 'State', type: 'select', default: 'TX', options: stateOpts() },
      { id: 'contractor_name', label: 'Subcontractor name', type: 'text', default: '' },
      {
        id: 'entity_type',
        label: 'Subcontractor entity type',
        type: 'select',
        default: 'llc',
        fullWidth: true,
        options: [
          { value: 'llc', label: 'LLC / Corporation (EIN required)' },
          { value: 'sole', label: 'Individual / Sole Proprietor' }
        ]
      },
      {
        id: 'facility_name',
        label: 'Facility / site name',
        type: 'text',
        default: '',
        placeholder: 'e.g. Parkway Medical Plaza'
      },
      {
        id: 'comp_model',
        label: 'Compensation model',
        type: 'select',
        default: 'monthly',
        options: [
          { value: 'monthly', label: 'Flat monthly fee ($/mo)' },
          { value: 'per_visit', label: 'Per-clean rate ($/visit)' },
          { value: 'hourly', label: 'Hourly rate ($/hr)' }
        ]
      },
      { id: 'agreed_rate', label: 'Agreed rate ($)', type: 'number', default: 2100 },
      {
        id: 'scope_description',
        label: 'Scope summary',
        type: 'text',
        default: 'Commercial janitorial services',
        fullWidth: true
      },
      {
        id: 'payment_terms',
        label: 'Invoice terms',
        type: 'select',
        default: 'net30',
        advanced: true,
        options: [
          { value: 'net15', label: 'Net 15' },
          { value: 'net30', label: 'Net 30' },
          { value: 'due_receipt', label: 'Due on receipt' }
        ]
      },
      {
        id: 'access_window',
        label: 'Access / service window',
        type: 'text',
        default: 'Unrestricted within 6:00 PM - 5:00 AM window',
        advanced: true,
        fullWidth: true
      },
      {
        id: 'key_liability',
        label: 'Master key / fob liability ($)',
        type: 'number',
        default: 2500,
        advanced: true,
        hint: 'Typical commercial re-key exposure runs $5,000-$25,000; set the contract deductible here.'
      },
      {
        id: 'prime_name',
        label: 'Prime contractor / company name',
        type: 'text',
        default: '',
        advanced: true,
        placeholder: 'Your company legal name'
      },
      { id: 'w9_verified', label: 'W-9 / EIN verified on file', type: 'checkbox', default: true, advanced: true },
      { id: 'insurance_required', label: 'Require GL + WC certificates', type: 'checkbox', default: true, advanced: true },
      { id: 'include_nonsolicit', label: 'Include non-solicit (clients / staff)', type: 'checkbox', default: true, advanced: true }
    ],
    calculate: function (inputs) {
      var name = capitalizeWords(inputs.contractor_name) || '[Subcontractor Name]';
      var prime = capitalizeWords(inputs.prime_name) || '[Prime Contractor]';
      var state = String(inputs.state || 'TX').toUpperCase();
      var stateLabel = state;
      try {
        var stOpt = (stateOpts() || []).filter(function (o) { return String(o.value) === state; })[0];
        if (stOpt && stOpt.label) stateLabel = String(stOpt.label).replace(/\s*\(.*$/, '').trim() || state;
      } catch (eSt) { /* keep code */ }
      var payMap = { net15: 'Net 15', net30: 'Net 30', due_receipt: 'due on receipt' };
      var pay = payMap[inputs.payment_terms] || payMap.net30;
      var scope = String(inputs.scope_description || 'Commercial janitorial services').trim() ||
        'Commercial janitorial services';
      var facility = String(inputs.facility_name || '').trim() || '[Facility Name]';
      var access = String(inputs.access_window || '').trim() ||
        'Unrestricted within 6:00 PM - 5:00 AM window';
      var keyLiab = num(inputs.key_liability, 2500);
      var rate = num(inputs.agreed_rate, 2100);
      var model = String(inputs.comp_model || 'monthly');
      var entity = String(inputs.entity_type || 'llc');
      var entityLabel = entity === 'sole'
        ? 'Individual / Sole Proprietor'
        : 'LLC / Corporation (EIN)';
      var rateUnit = model === 'hourly' ? '/hr' : (model === 'per_visit' ? '/visit' : '/mo');
      var rateLabel = fmt$(rate) + rateUnit;
      var modelLabel = model === 'hourly'
        ? 'hourly billed rate'
        : (model === 'per_visit' ? 'per-clean / per-visit rate' : 'flat monthly subcontract fee');
      var abcStrict = { CA: 1, MA: 1, NJ: 1 }[state];
      var w9Ok = inputs.w9_verified !== false;
      var todayLabel = new Date().toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric'
      });

      var clauses = [
        {
          title: 'Parties and engagement',
          detail: 'This Independent Contractor / Subcontract Agreement is entered as of ' + todayLabel +
            ' between ' + prime + ' ("Company") and ' + name + ' ("Contractor"), ' +
            ((/^LLC\b/i.test(entityLabel) || /^[AEIOU]/i.test(entityLabel)) ? 'an' : 'a') +
            ' ' + entityLabel +
            ' engaged to perform commercial cleaning services at ' + facility + ' in ' + stateLabel +
            ' (' + state + ').'
        },
        {
          title: 'Independent contractor status',
          detail: 'Contractor is an independent contractor and not an employee, partner, or agent of Company. ' +
            'Contractor controls the means and methods of performance, furnishes its own supervision, and is free to ' +
            'determine sequencing within the access window stated herein (IRS Pub 15-A / common-law right-of-control factors). ' +
            'Nothing in this Agreement creates an employment relationship.'
        },
        {
          title: 'Scope of work and facility',
          detail: 'Contractor shall perform the following scope at ' + facility + ': ' + scope +
            '. Permitted service access is ' + access +
            '. Contractor may set its own start/finish times inside that window and is not required to punch a Company timeclock.'
        },
        {
          title: 'Compensation and payment terms',
          detail: 'As consideration, Company shall pay Contractor an agreed ' + modelLabel + ' of ' + rateLabel +
            '. Company shall disburse ' + rateLabel + ' upon receipt of a conforming invoice, payable on ' + pay +
            ' terms, contingent upon signed facility inspection acceptance for the billed period. ' +
            'No wages, overtime, PTO, or employee benefits are owed under this Agreement.'
        },
        {
          title: 'Tools, supplies, and HazCom',
          detail: 'Contractor furnishes its own tools, equipment, and supplies unless the parties execute a written addendum. ' +
            'Contractor is responsible for OSHA HazCom compliance for chemicals it brings on site, including current SDS availability for its crew.'
        },
        {
          title: 'Tax responsibility and W-9',
          detail: 'Contractor is solely responsible for all federal, state, and local taxes arising from amounts paid under this Agreement, ' +
            'including self-employment tax where applicable. ' +
            (w9Ok
              ? 'Contractor represents that a current Form W-9 (and EIN for entity contractors) is on file with Company before the first disbursement.'
              : 'Contractor shall deliver a completed Form W-9 (and EIN for entity contractors) before the first disbursement; Company may withhold payment until received.')
        },
        {
          title: 'Non-exclusive engagement and right to contract',
          detail: 'Contractor maintains an independent business enterprise and retains the full right to market services and contract ' +
            'with other commercial entities during the term of this Agreement, without restriction by Company, provided such work does not ' +
            'interfere with performance at ' + facility + '.'
        },
        {
          title: 'Term and termination',
          detail: 'Either party may terminate this Agreement with fourteen (14) calendar days\' advance written notice. ' +
            'Termination does not relieve either party of accrued payment, indemnity, key-liability, or confidentiality obligations.'
        }
      ];

      if (inputs.include_nonsolicit !== false) {
        clauses.push({
          title: 'Non-solicitation of clients and staff',
          detail: 'During the engagement and for twelve (12) months after, Contractor will not solicit Company\'s facility clients ' +
            'for competing cleaning services, or recruit Company\'s employees or other contractors, except with prior written consent.'
        });
      }

      clauses.push({
        title: 'Master key and security access liability',
        detail: 'Contractor is responsible for safekeeping of any master keys, access cards, fobs, or codes issued for ' + facility +
          '. If Contractor loses or compromises such access media, Contractor shall reimburse Company\'s documented re-key / re-credential costs ' +
          'up to ' + fmt$(keyLiab) + ' per incident, which Company may deduct from amounts otherwise due.'
      });

      clauses.push({
        title: 'Indemnification and waiver of subrogation',
        detail: 'To the fullest extent permitted by law, Contractor shall indemnify, defend, and hold harmless Company and the facility owner/manager ' +
          'from claims, damages, losses, and expenses (including reasonable attorneys\' fees) arising out of Contractor\'s negligent acts or omissions, ' +
          'willful misconduct, or failure to maintain required insurance, including workers\' compensation claims by Contractor\'s workers. ' +
          'Contractor\'s insurers shall waive subrogation against Company where commercially available.'
      });

      clauses.push({
        title: 'State compliance',
        detail: 'Contractor shall comply with ' + stateLabel + ' (' + state + ') labor, licensing, tax, and workplace-safety requirements applicable to its independent business.'
      });

      if (inputs.insurance_required !== false) {
        clauses.push({
          title: 'Insurance minimums',
          detail: 'Before mobilizing, Contractor shall maintain Commercial General Liability of at least $1,000,000 per occurrence / $2,000,000 aggregate, ' +
            'automobile liability where vehicles are used, and workers\' compensation as required by ' + state + ' law. Company and the facility owner shall be ' +
            'named as additional insureds on the GL policy when the facility requires it.'
        });
        clauses.push({
          title: 'Certificate of insurance',
          detail: 'Contractor shall deliver certificates of insurance (COI) evidencing the coverages above before first service, with at least thirty (30) days\' ' +
            'prior written notice of cancellation or material reduction.'
        });
      }

      var copyText = clauses.map(function (c, i) {
        return (i + 1) + '. ' + c.title.toUpperCase() + '\n' + c.detail;
      }).join('\n\n');

      var handoffUrl = '/pages/job-costing-calculator';
      if (model === 'hourly') {
        handoffUrl += '?loaded_labor_rate=' + encodeURIComponent(String(rate));
      } else {
        handoffUrl += '?subcontractor_cost=' + encodeURIComponent(String(rate));
      }

      var out = {
        valid: true,
        primary: clauses.length + ' articles',
        secondary: name + ' · ' + state + ' · ' + rateLabel,
        secondaryLabel: 'Subcontractor',
        statusPill: { label: 'Draft agreement ready', level: 'ok' },
        clauses: clauses,
        copyText: copyText,
        copyLabel: 'Copy agreement draft',
        copyTop: true,
        rows: clauses.map(function (c, i) {
          return {
            label: (i + 1) + '. ' + c.title,
            value: '',
            meta: [{ k: 'Language', v: c.detail }]
          };
        }),
        soWhat: 'This is a counsel-ready draft subcontract with consideration, access, key liability, and insurance — have counsel review before signature.',
        handoffUrl: handoffUrl,
        handoffLabel: 'Price the work → Job Costing',
        handoffHint: 'Next: make sure the engagement still clears margin',
        pdfHeaderMeta: name + ' | ' + state + ' | ' + rateLabel,
        formalAgreement: {
          title: 'INDEPENDENT CONTRACTOR / SUBCONTRACT AGREEMENT',
          subtitle: 'Draft for counsel review — not a substitute for signed legal advice',
          dateLabel: todayLabel,
          partiesLine: prime + ' ("Company") and ' + name + ' ("Contractor")',
          facilityLine: facility + ' · ' + stateLabel + ' (' + state + ')',
          articles: clauses,
          signatures: [
            {
              heading: 'PRIME CONTRACTOR (COMPANY)',
              lines: [
                'Signature: ________________________________',
                'Name / Title: _____________________________',
                'EIN / Tax ID: _____________________________',
                'Date: ____________________________________'
              ]
            },
            {
              heading: 'SUBCONTRACTOR',
              lines: [
                'Signature: ________________________________',
                'Name / Title: _____________________________',
                'EIN / Tax ID: _____________________________',
                'Date: ____________________________________'
              ]
            }
          ]
        }
      };

      if (abcStrict) {
        out.alertBanners = [{
          level: 'warn',
          title: 'High regulatory risk — ' + stateLabel + ' ABC test',
          text: stateLabel + ' enforces a strict ABC worker-classification test. Because cleaning is the usual course of a janitorial company\'s business, ' +
            'hiring individual 1099 cleaners for core site work carries extreme reclassification exposure under Prong B. ' +
            'Engage only valid B2B corporate entities (EIN) with independent operations, or hire as W-2. ' +
            (entity === 'sole'
              ? 'Your selected entity type is Individual / Sole Proprietor — treat this as a stop sign until counsel clears a lawful path.'
              : 'Confirm the subcontractor is a true independent business, not a scheduled crew under your control.')
        }];
        out.statusPill = {
          label: 'ABC-test state — review carefully',
          level: 'warn'
        };
      } else if (entity === 'sole') {
        out.alertBanners = [{
          level: 'warn',
          title: 'Entity risk',
          text: 'Subcontracting an unincorporated individual for core commercial cleaning raises unemployment and workers\' comp audit exposure in many states. Prefer an LLC/Corp with EIN where possible.'
        }];
        out.statusPill = { label: 'Sole prop — verify classification', level: 'warn' };
      }

      return out;
    }
  });

  /* ---- 11. production-rate-calculator ---- */
  reg('production-rate-calculator', {
    title: 'Production Rate Calculator',
    blurb: 'APPA-aligned hours and FTE from building mix and appearance level (conservative vs large-office blended estimators).',
    primaryLabel: 'Annual FTE',
    mixPctFields: ['pct_carpet', 'pct_hard_floor', 'pct_restroom', 'pct_office', 'pct_common'],
    fields: [
      { id: 'mode', label: 'Input mode', type: 'select', default: 'simple', options: [
        { value: 'simple', label: 'Total sqft + area mix %' },
        { value: 'detailed', label: 'Sqft by area type' }
      ]},
      { id: 'total_sqft', label: 'Total square footage', type: 'number', default: 65000 },
      { id: 'appa_level', label: 'APPA level', type: 'select', default: '2', options: [
        { value: '1', label: 'Level 1 — White glove' },
        { value: '2', label: 'Level 2 — Standard' },
        { value: '3', label: 'Level 3 — Moderate' },
        { value: '4', label: 'Level 4 — Slack' },
        { value: '5', label: 'Level 5 — Partial / dash' }
      ]},
      {
        id: 'workdays',
        label: 'Service days per week',
        type: 'number',
        default: 5,
        min: 1,
        max: 7,
        hint: '1×/week auto-adds ~30% hours for soil buildup'
      },
      {
        id: 'shift_timing',
        label: 'Shift timing',
        type: 'select',
        default: 'nightly',
        advanced: true,
        options: [
          { value: 'nightly', label: 'Nightly / unoccupied (baseline)' },
          { value: 'daytime', label: 'Daytime / occupied (−20% speed)' }
        ]
      },
      {
        id: 'soil_density',
        label: 'Soil & occupancy density',
        type: 'select',
        default: 'medium',
        advanced: true,
        options: [
          { value: 'light', label: 'Light soil / low clutter (+10% speed)' },
          { value: 'medium', label: 'Medium soil / standard' },
          { value: 'heavy', label: 'Heavy soil / high density (−15% speed)' }
        ]
      },
      { id: 'fte_divisor', label: 'FTE divisor (annual hrs)', type: 'number', default: 2080, advanced: true },
      {
        id: 'labor_burden',
        label: 'Loaded labor rate ($/hr)',
        type: 'number',
        default: '',
        advanced: true,
        placeholder: 'Optional — set in Bill Rate',
        hint: 'Optional. Leave blank to price on Bill Rate. Typical commercial loaded rates: $18–$32/hr.',
        hintAsTooltip: true
      },
      {
        id: 'fixtures',
        label: 'Fixture count',
        type: 'number',
        default: '',
        advanced: true,
        placeholder: 'Auto from restroom sqft',
        hint: 'Leave blank to auto-estimate from restroom sqft',
        hintAsTooltip: true
      },
      { id: 'min_per_fixture', label: 'Mins / set', type: 'number', default: 9, advanced: true },
      { id: 'fixture_density_sqft', label: 'Sqft / fixture', type: 'number', default: 200, advanced: true },
      { id: 'pct_carpet', label: '% carpet', type: 'number', default: 40, advanced: true },
      { id: 'pct_hard_floor', label: '% hard floor', type: 'number', default: 20, advanced: true },
      { id: 'pct_restroom', label: '% restroom', type: 'number', default: 5, advanced: true },
      { id: 'pct_office', label: '% office', type: 'number', default: 25, advanced: true },
      { id: 'pct_common', label: '% common', type: 'number', default: 10, advanced: true },
      { id: 'sqft_carpet', label: 'Carpet sqft', type: 'number', default: 26000, advanced: true },
      { id: 'sqft_hard_floor', label: 'Hard floor sqft', type: 'number', default: 13000, advanced: true },
      { id: 'sqft_restroom', label: 'Restroom sqft', type: 'number', default: 3250, advanced: true },
      { id: 'sqft_office', label: 'Office sqft', type: 'number', default: 16250, advanced: true },
      { id: 'sqft_common', label: 'Common area sqft', type: 'number', default: 6500, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.productionCalc(inputs);
      if (!r.valid) return r;
      var burden = num(inputs.labor_burden, 0);
      var costSqft = burden > 0 && r.total_sqft > 0 ? (r.annual_hours * burden / r.total_sqft) : null;
      var mixSum = num(inputs.pct_carpet, 0) + num(inputs.pct_hard_floor, 0) + num(inputs.pct_restroom, 0) +
        num(inputs.pct_office, 0) + num(inputs.pct_common, 0);
      var flag = (inputs.mode !== 'detailed' && mixSum > 0 && Math.abs(mixSum - 100) > 0.5) ? 'Mix adjusted' : null;
      /* ASCII thousands commas — avoid locale/nbsp separators that jsPDF mangles */
      var fmtInt = function (n) {
        return String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };
      var fmtSqft = function (n) {
        return fmtInt(n);
      };
      var fmtRate = function (n) {
        return fmtInt(n) + ' sf/hr';
      };
      var breakdown = (r.tasks || []).map(function (t) {
        var sq = t.sqft > 0 ? fmtSqft(t.sqft) + ' sqft' : '';
        var label = t.label + (sq ? ' (' + sq + ')' : '');
        var value = (t.hours || 0).toFixed(2) + ' hrs/night';
        var hint = '';
        if (t.key === 'restroom') {
          hint = String(t.fixtures || 0) + ' fixtures @ ' + (t.min_per_fixture || 9) + ' min' +
            (t.fixtures_auto ? ' (auto)' : '');
        } else if (t.rate) {
          hint = '@ ' + fmtRate(t.rate);
        }
        return { label: label, value: value, hint: hint };
      });
      if (r.staffing_line) {
        /* Compact roster so PDF VALUE column stays one line (label | roster | note) */
        var roster = r.staffing_line.replace(/^Staffing configuration:\s*/, '')
          .replace(/full-time cleaners?/g, 'full-time')
          .replace(/part-time swing cleaner/g, 'swing')
          .replace(/part-time cleaner/g, 'part-time')
          .replace(/swing cleaner/g, 'swing')
          .replace(/\((\d+(?:\.\d+)?) hrs each\)/g, '($1h each)')
          .replace(/\((\d+(?:\.\d+)?) hrs\)/g, '($1h)');
        breakdown.push({
          label: 'Crew / shift',
          value: roster,
          hint: r.nightly_hours.toFixed(2) + ' hr/night',
          emphasize: true
        });
      }
      var fixtureLabel = r.fixtures_auto
        ? ('Auto: ' + r.fixtures_used + ' from restroom sqft')
        : String(r.fixtures_used);
      var visitLabel = r.shift_timing === 'daytime' ? 'day' : 'night';
      var rows = [
        { label: 'Hours per service day', value: r.nightly_hours.toFixed(2) + ' hr' },
        { label: 'Weekly hours', value: r.weekly_hours.toFixed(2) + ' hr' },
        { label: 'Annual hours', value: fmtInt(r.annual_hours) + ' hr' },
        {
          label: 'Fixtures used',
          value: fixtureLabel + ' @ ' + (r.min_per_fixture || 9) + ' min'
        }
      ];
      if (r.modifier_notes && r.modifier_notes.length) {
        rows.push({ label: 'Site modifiers', value: r.modifier_notes.join(' · ') });
      }
      var out = {
        valid: true,
        primary: r.fte.toFixed(2) + ' FTE',
        secondary: costSqft ? fmt$(costSqft) + '/sqft/yr' : (r.blended_sf_per_hr ? fmtRate(r.blended_sf_per_hr) : null),
        secondaryLabel: costSqft ? 'Labor cost/sqft/yr' : 'Blended production',
        metrics: [
          { label: 'Annual FTE', value: r.fte.toFixed(2) + ' FTE', accent: true, hero: true },
          {
            label: costSqft ? 'Labor cost/sqft/yr' : 'Blended production',
            value: costSqft
              ? fmt$(costSqft) + '/sqft/yr'
              : (r.blended_sf_per_hr ? fmtRate(r.blended_sf_per_hr) : '—')
          }
        ],
        soWhat: 'For a **' + fmtInt(r.total_sqft) + ' sf** Level ' + String(inputs.appa_level || '2') +
          ' building at **' + String(inputs.workdays || 5) + ' days/week**, plan about **' +
          r.fte.toFixed(1) + ' full-time cleaners** (~' + r.nightly_hours.toFixed(0) +
          ' ' + visitLabel + ' hours per service day)' +
          (r.staffing_line ? (' — **' + r.staffing_line.replace(/^Staffing configuration:\s*/, '') + '**.') : '.'),
        flag: flag,
        mixNote: (r.modifier_notes && r.modifier_notes.length)
          ? ('Applied: ' + r.modifier_notes.join(' · ') + '.')
          : '',
        breakdown: breakdown,
        syncFields: r.fixtures_auto ? {
          fixtures: {
            placeholder: 'Auto: ' + r.fixtures_used,
            hint: 'Auto: ' + r.fixtures_used + ' from restroom sqft — edit to override',
            clearValue: true
          }
        } : {
          fixtures: {
            placeholder: 'Auto from restroom sqft',
            hint: 'Leave blank to auto-estimate from restroom sqft'
          }
        },
        rows: rows
      };
      // Soft advisory only — do not clamp; blank burden still means "price on Bill Rate"
      if (burden > 0 && burden < 10) {
        out.alertBanners = [{
          level: 'warn',
          title: 'Loaded wage looks unrealistically low',
          text: 'Loaded wage is below typical statutory minimum wage burdens. Standard commercial loaded rates range from $18.00–$32.00/hr. Confirm local wages before you price this crew.'
        }];
      }
      return out;
    }
  });

  /* ---- 12. chemical-compatibility ---- */
  reg('chemical-compatibility', {
    title: 'Chemical Compatibility Checker',
    blurb: 'Check whether two chemistries can be mixed or must be sequenced.',
    primaryLabel: 'Verdict',
    d4: {
      basicSection: 'Chemistry pair',
      advancedSection: 'Concentration, surface & air'
    },
    fields: [
      // Short labels + full-width stack so closed selects never clip mid-word
      { id: 'chem_a', label: 'Chemistry A', type: 'select', default: 'Bleach',
        options: chemOptsDilution(), fullWidth: true },
      { id: 'chem_b', label: 'Chemistry B', type: 'select', default: 'Quat',
        options: chemOptsDilution(), fullWidth: true },
      {
        id: 'concentration',
        label: 'Concentration state',
        type: 'select',
        default: 'rtu',
        advanced: true,
        options: [
          { value: 'rtu', label: 'Ready-to-use (RTU dilution)' },
          { value: 'concentrate', label: 'Concentrate (drum / dispenser mix)' }
        ]
      },
      {
        id: 'target_surface',
        label: 'Target surface / substrate',
        type: 'select',
        default: 'general',
        advanced: true,
        options: [
          { value: 'general', label: 'General / resilient flooring (VCT)' },
          { value: 'stone', label: 'Polished stone (marble / terrazzo)' },
          { value: 'metal', label: 'Stainless steel / metal' },
          { value: 'carpet', label: 'Carpeting / fabric' }
        ]
      },
      {
        id: 'environment',
        label: 'Ventilation / enclosure',
        type: 'select',
        default: 'ventilated',
        advanced: true,
        options: [
          { value: 'enclosed', label: 'Enclosed room / supply closet' },
          { value: 'ventilated', label: 'Standard well-ventilated space' }
        ]
      }
    ],
    calculate: function (inputs) {
      var a = inputs.chem_a;
      var b = inputs.chem_b;
      if (!a || !b) return { valid: false, errors: ['Select both chemistries.'] };
      var ctx = {
        concentration: inputs.concentration,
        surface: inputs.target_surface,
        environment: inputs.environment
      };
      if (a === b) return S.chemCompatResult(a, b, { rating: 'self' }, ctx);
      var matrix = D.compatibility_matrix && D.compatibility_matrix.chemistry_vs_chemistry;
      var cell = matrix && matrix[a] && matrix[a][b];
      if (!cell) return { valid: false, errors: ['Compatibility data not found for this pair.'] };
      return S.chemCompatResult(a, b, cell, ctx);
    }
  });

  /* ---- 13. dilution-calculator ---- */
  reg('dilution-calculator', {
    title: 'Dilution Calculator',
    blurb: 'Convert dilution ratios to oz/gal, percent, PPM, jug yield, and cost per ready-to-use gallon, with chemistry-specific safe ranges and dwell guidance.',
    primaryLabel: 'Total concentrate',
    ratioChips: [32, 64, 128, 256, 512],
    ratioChipTarget: 'ratio_str',
    containerPresets: [
      { label: '32 oz Bottle', size: 32, unit: 'floz' },
      { label: 'Mop Bucket (4 gal)', size: 4, unit: 'gal' },
      { label: 'Backpack Sprayer (4 gal)', size: 4, unit: 'gal' },
      { label: 'Auto-Scrubber (15 gal)', size: 15, unit: 'gal' }
    ],
    handoffs: [
      { label: 'Chemical Compatibility', url: '/pages/chemical-compatibility', description: 'Confirm mix safety' },
      { label: 'VOC Compliance', url: '/pages/voc-compliance', description: 'Check VOC limits' }
    ],
    fields: [
      { id: 'chemistry', label: 'Chemistry class', type: 'select', default: 'Quat', options: chemOptsDilution() },
      { id: 'dilution_mode', label: 'Dilution input mode', type: 'select', default: 'ratio', options: [
        { value: 'ratio', label: 'Ratio (1:X)' },
        { value: 'ppm', label: 'Target PPM (food / healthcare)' },
        { value: 'ozpgal', label: 'Oz concentrate per gallon' },
        { value: 'percent', label: 'Percent concentrate (v/v)' }
      ]},
      // Mode-gated fields are full-width so they never steal the container size|unit pair
      { id: 'ratio_str', label: 'Dilution ratio (1:X)', type: 'text', default: '1:64', placeholder: 'e.g. 1:64 or 64',
        fullWidth: true, visibleWhen: { id: 'dilution_mode', in: ['ratio'] } },
      { id: 'oz_per_gal', label: 'Oz concentrate per gallon', type: 'number', default: 2, step: 0.01,
        fullWidth: true, visibleWhen: { id: 'dilution_mode', eq: 'ozpgal' } },
      { id: 'percent_conc', label: 'Concentrate percent (v/v)', type: 'number', default: 1.5, step: 0.01,
        fullWidth: true, visibleWhen: { id: 'dilution_mode', eq: 'percent' } },
      { id: 'target_ppm', label: 'Target PPM', type: 'number', default: 200, step: 1, min: 1,
        visibleWhen: { id: 'dilution_mode', eq: 'ppm' },
        hint: 'Food-contact sanitizing often 50–200 ppm chlorine or ≥200 ppm quat; hard-surface bleach disinfection commonly 600–5,000+ ppm.',
        hintAsTooltip: true },
      { id: 'conc_active_pct', label: 'Concentrate active %', type: 'number', default: 5.25, step: 0.01, min: 0.01, max: 100,
        visibleWhen: { id: 'dilution_mode', eq: 'ppm' },
        hint: 'Label strength of available chlorine / active ingredient (e.g. 5.25% or 8.25% NaOCl).',
        hintAsTooltip: true },
      { id: 'container_size', label: 'Container size', type: 'number', default: 1 },
      { id: 'container_unit', label: 'Container unit', type: 'select', default: 'gal', options: [
        { value: 'gal', label: 'Gallons' },
        { value: 'floz', label: 'Fluid ounces' },
        { value: 'L', label: 'Liters' }
      ]},
      { id: 'concentrate_cost', label: 'Concentrate cost ($/gal)', type: 'number', default: 0, advanced: true, fullWidth: true,
        hint: 'Wholesale cost per gallon of concentrate — surfaces RTU and per-batch cost in results.',
        hintAsTooltip: true }
    ],
    calculate: function (inputs) {
      var r = S.dilutionCalc(inputs);
      if (!r.valid) return r;
      var chem = (D.chemistries || []).find(function (c) { return c.id === inputs.chemistry; });
      var tradeNames = chem && chem.common_trade_names ? chem.common_trade_names.slice(0, 3).join(', ') : '—';
      var concDisplay = (S.formatDilutionOz ? S.formatDilutionOz(r.concOz) : r.concOz.toFixed(2)) + ' oz';
      var yieldBottles = Math.round(r.yieldBottles32);

      var metrics = [
        {
          label: 'Total concentrate',
          value: concDisplay,
          sub: 'for this ' + r.batchLabel,
          hero: true,
          accent: true
        },
        {
          label: 'Concentrate per gallon',
          value: r.ozPerGal.toFixed(3) + ' oz/gal',
          sub: r.equiv.ratio + ' dilution'
        },
        {
          label: 'RTU jug yield',
          value: yieldBottles + ' bottles (32 oz)',
          sub: 'from 1-gal jug @ ' + r.equiv.ratio
        }
      ];

      if (r.costPerGal) {
        metrics.push({
          label: 'Cost per RTU gallon',
          value: fmt$(r.costPerGal) + '/gal',
          accent: true
        });
      } else if (r.achievedPpm != null && isFinite(r.achievedPpm)) {
        metrics.push({
          label: 'Use-dilution PPM',
          value: Math.round(r.achievedPpm) + ' ppm',
          sub: r.concActivePct ? (r.concActivePct + '% concentrate') : 'from active %',
          accent: inputs.dilution_mode === 'ppm'
        });
      }

      // Keep web grid at 4 primary cards; batch cost stays in detail rows when present
      if (r.costPerBatch && !r.costPerGal) {
        metrics.push({
          label: r.isBottle ? 'Cost per bottle' : 'Cost per batch',
          value: fmt$(r.costPerBatch) + (r.isBottle ? '/bottle' : ''),
          accent: true
        });
      }

      var rows = [
        { label: 'Chemistry', value: chem ? chem.name : (inputs.chemistry || '—') },
        { label: 'Common products', value: tradeNames },
        { label: 'Water needed', value: (S.formatDilutionOz ? S.formatDilutionOz(r.waterOz) : r.waterOz.toFixed(2)) + ' oz' },
        { label: 'Container volume', value: r.containerOz.toFixed(1) + ' fl oz' },
        { label: '% concentrate (v/v)', value: r.pct.toFixed(3) + '%' },
        { label: 'Equivalent ratio', value: r.equiv.ratio },
        { label: 'Oz per gallon RTU', value: r.ozPerGal.toFixed(3) + ' oz/gal' },
        { label: 'RTU yield (1-gal jug)', value: yieldBottles + ' x 32 oz bottles (' +
          (r.yieldRtuGal % 1 === 0 ? String(Math.round(r.yieldRtuGal)) : r.yieldRtuGal.toFixed(1)) + ' gal RTU)' }
      ];
      if (r.costPerBatch) {
        rows.push({
          label: r.isBottle ? 'Cost per bottle' : 'Cost per batch',
          value: fmt$(r.costPerBatch) + (r.isBottle ? '/bottle' : '')
        });
      }
      if (r.dwell && r.dwell.short) {
        rows.push({ label: 'Typical wet dwell', value: r.dwell.short });
      }
      if (r.achievedPpm != null && isFinite(r.achievedPpm)) {
        rows.push({ label: 'Use-dilution PPM', value: Math.round(r.achievedPpm) + ' ppm' +
          (r.concActivePct ? ' @ ' + r.concActivePct + '% concentrate' : '') });
      }

      return {
        valid: true,
        primary: concDisplay,
        secondary: r.ozPerGal.toFixed(3) + ' oz/gal',
        secondaryLabel: 'Concentrate per gallon',
        soWhat: 'Mix **' + concDisplay + '** of concentrate into your **' + r.batchLabel +
          '** (' + r.equiv.ratio + '). ' + r.yieldLine + '.',
        metrics: metrics.slice(0, 4),
        instruction: r.mixingInstruction,
        dwell: r.dwell,
        statusPill: r.statusPill,
        equiv: r.equiv,
        handoffSecondary: {
          label: 'Check VOC limits → VOC Compliance',
          url: '/pages/voc-compliance'
        },
        rows: rows
      };
    }
  });

  /* ---- 14. floor-program-builder ---- */
  reg('floor-program-builder', {
    title: 'Floor Care Program Builder',
    blurb: 'Build daily, interim, and restorative floor care by type, traffic, and finish — with pad/RPM and surface safety.',
    primaryLabel: 'Program',
    d4: {
      basicSection: 'Floor & traffic',
      advancedSection: 'Equipment, zone & cadence'
    },
    fields: [
      { id: 'floor_type', label: 'Floor type', type: 'select', default: '8',
        options: floorTypeOpts(), fullWidth: true },
      { id: 'traffic_level', label: 'Traffic level', type: 'select', default: 'high', options: [
        { value: 'low', label: 'Low' },
        { value: 'med', label: 'Medium' },
        { value: 'high', label: 'High' }
      ]},
      // Default = Granite (idx 8); options rewritten from FLOOR_DATABASE on floor_type change
      { id: 'finish_status', label: 'Finish status', type: 'select',
        default: floorProfile(8).defaultFinish,
        options: finishOptsForProfile(floorProfile(8)) },
      {
        id: 'primary_equipment',
        label: 'Primary equipment',
        type: 'select',
        default: 'autoscrubber',
        advanced: true,
        fullWidth: true,
        options: [
          { value: 'autoscrubber', label: 'Walk-Behind Auto-Scrubber' },
          { value: 'rotary175', label: 'Rotary Floor Machine (175 RPM)' },
          { value: 'burnisher', label: 'High-Speed Burnisher (1500-2000 RPM)' },
          { value: 'dual', label: 'Dual-Speed Rotary (175 / 300 RPM)' }
        ]
      },
      {
        id: 'traffic_zone',
        label: 'Traffic zone focus',
        type: 'select',
        default: 'corridor',
        advanced: true,
        fullWidth: true,
        options: [
          { value: 'entrance', label: 'High-Traffic Entrance / Lobby' },
          { value: 'corridor', label: 'Standard Corridors' },
          { value: 'office', label: 'Secondary Office Space' }
        ]
      },
      {
        id: 'cadence_standard',
        label: 'Maintenance cadence standard',
        type: 'select',
        default: 'enterprise',
        advanced: true,
        fullWidth: true,
        options: [
          { value: 'enterprise', label: 'Commercial Enterprise Standard' },
          { value: 'economy', label: 'Economical / Low Frequency' },
          { value: 'premium', label: 'Class A Premium Gloss' }
        ]
      }
    ],
    calculate: function (inputs) {
      var idx = parseInt(inputs.floor_type, 10);
      if (isNaN(idx)) idx = 0;
      var f = (D.floor_types || [])[idx];
      if (!f) return { valid: false, errors: ['Select a floor type.'] };
      var profile = floorProfile(idx);
      var traffic = inputs.traffic_level || 'med';
      var finish = clampFloorFinish(profile, inputs.finish_status || profile.defaultFinish);
      var rawEquip = inputs.primary_equipment || 'autoscrubber';
      var shortName = (floorTypeOpts().find(function (o) { return o.value === String(idx); }) || {}).label || profile.name;
      var equipWarn = floorEquipmentWarning(profile, rawEquip, shortName);
      var prog = buildFloorProgram(idx, traffic, finish, {
        equipment: rawEquip,
        zone: inputs.traffic_zone,
        cadence: inputs.cadence_standard
      });
      var trafficLabel = traffic === 'high' ? 'High' : (traffic === 'low' ? 'Low' : 'Medium');
      var finishLabel = prog.finish;
      var padCard = prog.pads + ' (' + prog.rpm + ')';
      var alertBanners = [];
      if (equipWarn) {
        alertBanners.push({ level: 'warn', title: 'Equipment guardrail', text: equipWarn });
      }

      return {
        valid: true,
        primary: f.name,
        soWhat: 'Run this **Daily → Interim → Restorative** cadence for ' + trafficLabel.toLowerCase() +
          ' traffic on a ' + finishLabel.toLowerCase() + ' surface, then match pads and dilution to each step.',
        safetyWarning: prog.surfaceSafety || f.key_cautions || '',
        alertBanners: alertBanners,
        handoffSecondary: {
          label: 'Set chemical dilution → Dilution Calculator',
          url: '/pages/dilution-calculator'
        },
        metrics: [
          {
            label: 'Substrate & finish',
            value: shortName + ' · ' + finishLabel,
            hero: true,
            accent: true
          },
          {
            label: 'Pad specification',
            value: padCard
          },
          {
            label: 'Daily chemistry',
            value: prog.chemistry,
            accent: true
          }
        ],
        maintenanceMatrix: prog.matrix,
        rows: [
          { label: 'Daily maintenance', value: prog.daily },
          { label: 'Interim maintenance', value: prog.interim },
          { label: 'Restorative maintenance', value: prog.restorative },
          { label: 'Machine RPM', value: prog.rpm },
          { label: 'Pad colors', value: prog.pads },
          { label: 'pH range', value: prog.phRange || f.ph_range },
          { label: 'PPE level', value: f.ppe_level },
          { label: 'Recommended chemistry', value: prog.chemistry },
          { label: 'Traffic / finish', value: trafficLabel + ' | ' + finishLabel },
          { label: 'Surface safety', value: prog.surfaceSafety || f.key_cautions || '—' }
        ]
      };
    }
  });

  /**
   * Floor Pad Selector — comprehensive SSOT matrix (floor × finish × task) v2.
   * Universal guardrails applied after lookup (burnisher lockout, autoscrubber wet, melamine/stone).
   */
  var PAD_FINISH_OPTS = {
    VCT: [
      { value: 'coated', label: 'Coated (acrylic wax)' },
      { value: 'factory', label: 'Bare unsealed tile' }
    ],
    LVT: [
      { value: 'factory', label: 'Factory wear-layer' },
      { value: 'coated', label: 'Coated (sacrificial matte)' }
    ],
    Rubber: [
      { value: 'factory', label: 'Factory vulcanized smooth' },
      { value: 'textured', label: 'Textured acoustic rubber' }
    ],
    'Ceramic tile': [
      { value: 'natural', label: 'Unglazed / natural porcelain' },
      { value: 'glazed', label: 'Glazed ceramic tile' }
    ],
    'Quarry tile': [
      { value: 'bare', label: 'Bare unsealed kiln-fired' },
      { value: 'silicone', label: 'Penetrating silicone seal' }
    ],
    Marble: [
      { value: 'polished', label: 'Polished calcite (high gloss)' },
      { value: 'honed', label: 'Honed (satin / matte)' }
    ],
    Granite: [
      { value: 'polished', label: 'Polished (natural gloss)' },
      { value: 'honed', label: 'Honed (matte / satin)' }
    ],
    Terrazzo: [
      { value: 'densified', label: 'Densified / diamond polished' },
      { value: 'coated', label: 'Coated (acrylic wax)' }
    ],
    'Sealed concrete': [
      { value: 'coated', label: 'Coated (acrylic/epoxy seal)' },
      { value: 'penetrating', label: 'Solvent penetrating seal' }
    ],
    'Polished concrete': [
      { value: 'densified', label: 'Densified / lithium polish' },
      { value: 'mechanical', label: 'Mechanically polished bare' }
    ],
    Hardwood: [
      { value: 'factory', label: 'Factory polyurethane' },
      { value: 'coated', label: 'Site-applied waterborne urethane' }
    ],
    'Hardwood oil': [
      { value: 'oil', label: 'Penetrating / hardwax natural oil' },
      { value: 'raw', label: 'Raw oiled timber' }
    ],
    'Painted wood': [
      { value: 'gym', label: 'MFMA-approved gym finish' },
      { value: 'linepaint', label: 'High-gloss line-painted wood' }
    ],
    Epoxy: [
      { value: 'coated', label: 'High-solids resin topcoat' },
      { value: 'textured', label: 'Non-slip textured aggregate' }
    ],
    Resinous: [
      { value: 'coated', label: 'High-build MMA topcoat' },
      { value: 'textured', label: 'Quartz aggregate slurry' }
    ],
    ESD: [
      { value: 'dissipative', label: 'Dissipative coated tile' },
      { value: 'conductive', label: 'Uncoated conductive vinyl' }
    ],
    'Safety floor': [
      { value: 'grit', label: 'Carborundum grit-embedded vinyl' },
      { value: 'bare', label: 'Bare textured safety vinyl' }
    ],
    Carpet: [
      { value: 'modular', label: 'Modular carpet tiles' },
      { value: 'broadloom', label: 'Glue-down broadloom' }
    ]
  };

  var FINISH_LABELS = {
    coated: 'Coated (acrylic / sacrificial)',
    factory: 'Bare unsealed tile',
    textured: 'Textured / acoustic profile',
    natural: 'Unglazed / natural porcelain',
    glazed: 'Glazed ceramic tile',
    bare: 'Bare unsealed',
    polished: 'Polished (high gloss)',
    honed: 'Honed (satin / matte)',
    densified: 'Densified / lithium polish',
    mechanical: 'Mechanically polished bare',
    oil: 'Penetrating / hardwax natural oil',
    raw: 'Raw oiled timber',
    gym: 'MFMA-approved gym finish',
    linepaint: 'High-gloss line-painted wood',
    silicone: 'Penetrating silicone seal',
    penetrating: 'Solvent penetrating seal',
    dissipative: 'Dissipative coated tile',
    conductive: 'Uncoated conductive vinyl',
    grit: 'Carborundum grit-embedded vinyl',
    modular: 'Modular carpet tiles',
    broadloom: 'Glue-down broadloom',
    uncoated: 'Uncoated / densified / honed'
  };

  var PAD_MATRIX = {
    'VCT|coated|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Light down-pressure; neutral floor cleaner (pH 7-9).',
      burnishOk: false
    },
    'VCT|coated|scrub': {
      pad: 'Blue',
      alt: 'Green pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Top-scrubs surface particulate without cutting into base finish coats.',
      burnishOk: false
    },
    'VCT|coated|grout': {
      pad: 'Melamine',
      alt: 'Poly-bristle scrubbing brush',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Run wet with neutral cleaner; extracts ground-in soil from tile seams.',
      burnishOk: false,
      wetRequired: true
    },
    'VCT|coated|strip': {
      pad: 'Black',
      alt: 'Maroon SPP (Wet with water)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Black pad with chemical stripper (pH 12-13); SPP with clean water only.',
      burnishOk: false,
      wetRequired: true
    },
    'VCT|coated|burnish': {
      pad: 'White',
      alt: 'Aqua / Natural hair blend',
      machine: '1500-3000 RPM high-speed burnisher',
      directive: 'Thermal-buffs acrylic polymers to restore high-gloss optical clarity.',
      burnishOk: true
    },
    'VCT|factory|daily': {
      pad: 'Red',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral cleaner; prevent standing water on unsealed seams and joints.',
      burnishOk: false
    },
    'VCT|factory|scrub': {
      pad: 'Red',
      alt: 'Blue pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Top-scrub only — bare VCT has no acrylic film to cut through.',
      burnishOk: false
    },
    'VCT|factory|grout': {
      pad: 'Melamine',
      alt: 'Poly-bristle scrubbing brush',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Run wet; clean tile texture without carbide gouging.',
      burnishOk: false,
      wetRequired: true
    },
    'VCT|factory|strip': {
      blocked: true,
      title: 'No finish present to strip',
      directive: 'REJECT: Bare unsealed VCT has no finish to strip; black pads abrade vinyl tile.'
    },
    'VCT|factory|burnish': {
      pad: 'White',
      alt: 'Red spray-buff',
      machine: '175-350 RPM rotary ONLY',
      directive: 'No acrylic film to UHS-burnish; low-speed spray-buff only.',
      burnishOk: false
    },
    'LVT|factory|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Light pad pressure; removes surface film without hazing polyurethane.',
      burnishOk: false
    },
    'LVT|factory|scrub': {
      pad: 'Red',
      alt: 'Soft nylon cylindrical brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'NEVER use Green or Black pads; abrasive grains scratch factory wear-layers.',
      burnishOk: false
    },
    'LVT|factory|grout': {
      pad: 'Melamine (Wet)',
      alt: 'Cylindrical soft brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Run WET with neutral solution to clean embossed architectural texture.',
      burnishOk: false,
      wetRequired: true
    },
    'LVT|factory|strip': {
      blocked: true,
      title: 'Factory wear-layer strip prohibited',
      directive: 'REJECT: Strippers dissolve adhesive; bare wear-layers cannot be stripped.',
      insteadOf: {
        pad: 'Red pad (deep scrub)',
        machine: 'Walk-behind auto-scrubber (175-350)',
        text: 'Do this instead: switch task to Scrub / heavy soil with a Red pad and neutral cleaner. If a third party applied topical wax, set Finish Status to Coated (sacrificial matte) before stripping.'
      }
    },
    'LVT|factory|burnish': {
      blocked: true,
      title: 'Burnish lockout on LVT factory wear-layer',
      directive: 'LOCKOUT: 1500+ RPM burnishers melt wear-layer and blister vinyl tile.',
      safeRemap: {
        pad: 'White pad (175 RPM dry buff)',
        alt: 'White pad',
        machine: '175 RPM swing rotary ONLY',
        advisory: 'High-speed burnishers cannot be used on LVT. To achieve gloss on this substrate, execute low-speed spray buffing at 175 RPM with a White pad.'
      }
    },
    'LVT|coated|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Light pressure; neutral cleaner over sacrificial coat.',
      burnishOk: false
    },
    'LVT|coated|scrub': {
      pad: 'Red',
      alt: 'Soft nylon cylindrical brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Avoid Green/Black — they cut through thin sacrificial coats too fast.',
      burnishOk: false
    },
    'LVT|coated|grout': {
      pad: 'Melamine (Wet)',
      alt: 'Cylindrical soft brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Run wet with neutral solution on embossed grain.',
      burnishOk: false,
      wetRequired: true
    },
    'LVT|coated|strip': {
      pad: 'Maroon SPP (Wet)',
      alt: 'Blue pad + Neutral cleaner',
      machine: 'Auto-scrubber / Rotary (175 RPM)',
      directive: 'Run WET with water; removes sacrificial coating without solvent damage.',
      burnishOk: false,
      wetRequired: true,
      level: 'warn'
    },
    'LVT|coated|burnish': {
      pad: 'White',
      alt: 'Beige soft buff pad',
      machine: '175-350 RPM rotary ONLY',
      directive: 'Restrict speed to 350 RPM maximum; avoid heat build-up on resilient vinyl.',
      burnishOk: false
    },
    'Rubber|factory|daily': {
      pad: 'Red',
      alt: 'Soft nylon brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Use solvent-free rubber conditioner (pH 7-8.5); squeegee recovery.',
      burnishOk: false
    },
    'Rubber|factory|scrub': {
      pad: 'Blue',
      alt: 'Cylindrical soft brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Extracts athletic sweat salts, body oils, and chalk from rubber profile.',
      burnishOk: false
    },
    'Rubber|textured|grout': {
      pad: 'Cylindrical Brush',
      alt: 'Red pad (Low pressure)',
      machine: 'Auto-scrubber (175 RPM)',
      directive: 'Flat pads tear on studs and aggregate; cylindrical bristles clean valleys.',
      burnishOk: false
    },
    'Rubber|factory|grout': {
      pad: 'Cylindrical Brush',
      alt: 'Red pad (Low pressure)',
      machine: 'Auto-scrubber (175 RPM)',
      directive: 'Flat pads tear on studs and aggregate; cylindrical bristles clean valleys.',
      burnishOk: false
    },
    'Rubber|factory|strip': {
      blocked: true,
      title: 'Chemical strip prohibited on rubber',
      directive: 'REJECT: Solvents and high-alkali strippers dissolve vulcanized binders.'
    },
    'Rubber|factory|burnish': {
      blocked: true,
      title: 'Burnish lockout on rubber',
      directive: 'High-speed friction burns synthetic rubber, leaving permanent scorch marks.'
    },
    'Rubber|textured|daily': {
      pad: 'Red',
      alt: 'Soft nylon brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Use solvent-free rubber conditioner (pH 7-8.5); squeegee recovery.',
      burnishOk: false
    },
    'Rubber|textured|scrub': {
      pad: 'Blue',
      alt: 'Cylindrical soft brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Extracts athletic sweat salts from textured profiles.',
      burnishOk: false
    },
    'Rubber|textured|strip': {
      blocked: true,
      title: 'Chemical strip prohibited on rubber',
      directive: 'REJECT: Solvents and high-alkali strippers dissolve vulcanized binders.'
    },
    'Rubber|textured|burnish': {
      blocked: true,
      title: 'Burnish lockout on rubber',
      directive: 'High-speed friction burns synthetic rubber, leaving permanent scorch marks.'
    },
    'Ceramic tile|natural|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral synthetic cleaner; agitate surface without leaving soapy surfactant.',
      burnishOk: false
    },
    'Ceramic tile|natural|scrub': {
      pad: 'Green',
      alt: 'Blue pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Removes heavy grease and soil; tile vitreous surface is scratch-resistant.',
      burnishOk: false
    },
    'Ceramic tile|glazed|grout': {
      pad: 'Melamine (Wet)',
      alt: 'Silicon carbide grit brush',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Melamine runs wet to pull grime out of micropores; safe on glazed ceramic.',
      burnishOk: false,
      wetRequired: true
    },
    'Ceramic tile|natural|grout': {
      pad: 'Melamine (Wet)',
      alt: 'Silicon carbide grit brush',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Melamine runs wet to pull grime out of micropores; safe on ceramic.',
      burnishOk: false,
      wetRequired: true
    },
    'Ceramic tile|glazed|strip': {
      pad: 'Black',
      alt: 'Brown pad',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Use only if legacy acrylic finish was applied over glaze and is flaking.',
      burnishOk: false,
      level: 'warn'
    },
    'Ceramic tile|glazed|burnish': {
      blocked: true,
      title: 'Burnish lockout on ceramic glaze',
      directive: 'Non-porous ceramic glaze cannot take mechanical or thermal burnishing.'
    },
    'Ceramic tile|glazed|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral synthetic cleaner; agitate surface without leaving soapy surfactant.',
      burnishOk: false
    },
    'Ceramic tile|glazed|scrub': {
      pad: 'Green',
      alt: 'Blue pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Removes heavy grease and soil; tile glaze is scratch-resistant.',
      burnishOk: false
    },
    'Ceramic tile|natural|strip': {
      pad: 'Black',
      alt: 'Brown pad',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Use only if previous contractor waxed over ceramic — uncommon on unglazed.',
      burnishOk: false,
      level: 'warn'
    },
    'Ceramic tile|natural|burnish': {
      blocked: true,
      title: 'Burnish lockout on ceramic',
      directive: 'Non-porous ceramic cannot take mechanical or thermal burnishing.'
    },
    'Quarry tile|bare|daily': {
      pad: 'Cylindrical Grit Brush',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175 RPM)',
      directive: 'Bio-enzymatic cleaner; breaks down kitchen fats without slippery residue.',
      burnishOk: false
    },
    'Quarry tile|bare|scrub': {
      pad: 'Silicon Carbide Brush',
      alt: 'Green pad',
      machine: '175 RPM swing rotary (Heavy)',
      directive: 'High-load scrub with foaming alkaline degreaser; squeegee to drains.',
      burnishOk: false
    },
    'Quarry tile|bare|grout': {
      pad: 'Silicon Carbide Brush',
      alt: 'Deck scrubbing brush',
      machine: '175 RPM swing rotary (Heavy)',
      directive: 'Rigid bristle tips reach recessed wide grout joints to extract mineral scale.',
      burnishOk: false
    },
    'Quarry tile|bare|strip': {
      pad: 'Black',
      alt: 'Wire / Grit rotary brush',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Phosphoric acid descaler or heavy degreaser to strip polymerized cooking grease.',
      burnishOk: false
    },
    'Quarry tile|bare|burnish': {
      blocked: true,
      title: 'Burnish lockout on quarry tile',
      directive: 'Porous unsealed kiln-fired clay cannot take a burnished mechanical shine.'
    },
    'Marble|polished|daily': {
      pad: 'White',
      alt: 'Microfiber flat mop',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Must use pH 7.0 neutral stone detergent; quats leave film and attract soil.',
      burnishOk: false
    },
    'Marble|polished|scrub': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad + Stone cleaner',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Mechanical micro-conditioning; never use chemical degreasers or coarse pads.',
      burnishOk: false
    },
    'Marble|polished|grout': {
      pad: 'Cylindrical Poly Brush',
      alt: 'Soft horsehair brush',
      machine: 'Auto-scrubber / Rotary (175 RPM)',
      directive: 'DO NOT USE MELAMINE: Melamine (Mohs 4) micro-scratches calcite marble (Mohs 3).',
      burnishOk: false,
      level: 'warn'
    },
    'Marble|polished|strip': {
      blocked: true,
      title: 'Chemical strip prohibited on stone',
      directive: 'Chemical strippers (pH > 10) leach natural stone matrix; hone with diamonds.'
    },
    'Marble|polished|burnish': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad + Polishing paste',
      machine: '175-350 RPM rotary ONLY',
      directive: 'Mechanical wet friction polish; dry 1500+ burnishing scorches stone paste.',
      burnishOk: false
    },
    'Marble|honed|daily': {
      pad: 'White',
      alt: 'Red pad (Ultra-low pressure)',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'pH 7.0 neutral stone cleaner; maintains uniform satin matte appearance.',
      burnishOk: false
    },
    'Marble|honed|scrub': {
      pad: 'Diamond pad (800-1500g)',
      alt: 'White pad',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Preserves low-luster honed profile without developing unwanted specular gloss.',
      burnishOk: false
    },
    'Marble|honed|grout': {
      pad: 'Cylindrical Poly Brush',
      alt: 'Soft horsehair brush',
      machine: 'Auto-scrubber / Rotary (175 RPM)',
      directive: 'DO NOT USE MELAMINE on calcite stone.',
      burnishOk: false,
      level: 'warn'
    },
    'Marble|honed|strip': {
      blocked: true,
      title: 'Chemical strip prohibited on stone',
      directive: 'Chemical strippers damage stone binders. Use diamond honing cuts instead.'
    },
    'Marble|honed|burnish': {
      pad: 'Diamond pad (800-1500g)',
      alt: 'White pad + Stone paste',
      machine: '175-350 RPM rotary ONLY',
      directive: 'Preserve honed matte — do not push to high-gloss with UHS burnishers.',
      burnishOk: false
    },
    'Marble|honed|restorative': {
      pad: 'Diamond resin discs',
      alt: '400 → 800 grit wet hone',
      machine: '175 RPM swing rotary (Wet)',
      directive: 'Wet rotary cut to remove traffic scratches; apply penetrating impregnator.',
      burnishOk: false,
      wetRequired: true
    },
    'Granite|polished|daily': {
      pad: 'White',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'pH 7.0 neutral stone cleaner; high silica density resists chemical wear.',
      burnishOk: false
    },
    'Granite|polished|scrub': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Removes surface film while conditioning natural high-gloss reflection.',
      burnishOk: false
    },
    'Granite|polished|grout': {
      pad: 'Soft Nylon Brush',
      alt: 'White pad',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Cleans joint relief; granite feldspar resists scratching better than marble.',
      burnishOk: false
    },
    'Granite|polished|strip': {
      blocked: true,
      title: 'Chemical strip not used on granite',
      directive: 'Chemical strippers are not used on polished granite — restorative impregnator path only.'
    },
    'Granite|polished|restorative': {
      pad: 'White pad + Impregnator',
      alt: 'Solvent fluoropolymer seal',
      machine: 'Manual / 175 RPM rotary',
      directive: 'Deep-clean, dry, and apply solvent-based penetrating sealer; water-bead test.',
      burnishOk: false
    },
    'Granite|polished|burnish': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad + Granite paste',
      machine: '175-1500+ RPM rotary/burnisher',
      directive: 'Diamond maintenance burnishing approved on dense natural granite.',
      burnishOk: true
    },
    'Terrazzo|densified|daily': {
      pad: 'White',
      alt: 'Diamond pad (3000 grit)',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'pH 7.0 neutral cleaner; maintains polished marble chips and binder.',
      burnishOk: true
    },
    'Terrazzo|densified|scrub': {
      pad: 'Diamond pad (1500g)',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Cleans traffic soil without causing micro-abrasion to cementitious binder.',
      burnishOk: false
    },
    'Terrazzo|densified|grout': {
      pad: 'Soft Nylon Brush',
      alt: 'White pad',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Cleans divider strips and filler joints without eroding softer marble aggregates.',
      burnishOk: false
    },
    'Terrazzo|densified|strip': {
      blocked: true,
      title: 'No acrylic film on densified terrazzo',
      directive: 'Densified/honed terrazzo has no sacrificial wax to strip. Use progressive diamond cut if restoration is needed.'
    },
    'Terrazzo|densified|burnish': {
      pad: 'Diamond pad (3000g)',
      alt: 'Natural hog hair / White pad',
      machine: '1500-3000 RPM high-speed burnisher',
      directive: 'Dry burnish develops thermal friction to harden and brighten crystal gloss.',
      burnishOk: true
    },
    'Terrazzo|coated|daily': {
      pad: 'White',
      alt: 'Red pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral cleaner over acrylic terrazzo finish.',
      burnishOk: false
    },
    'Terrazzo|coated|scrub': {
      pad: 'Blue',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Top-scrub acrylic without cutting to matrix.',
      burnishOk: false
    },
    'Terrazzo|coated|grout': {
      pad: 'Soft Nylon Brush',
      alt: 'White pad',
      machine: 'Auto-scrubber / Rotary (175-300 RPM)',
      directive: 'Cleans matrix lines carefully.',
      burnishOk: false
    },
    'Terrazzo|coated|strip': {
      pad: 'Blue / Green pad',
      alt: 'Low-pH stripper (pH 9-10)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Avoid aggressive black pads and caustic strippers (pH > 11); etches binder.',
      burnishOk: false,
      level: 'warn'
    },
    'Terrazzo|coated|burnish': {
      pad: 'White',
      alt: 'Aqua',
      machine: '1500-3000 RPM high-speed burnisher',
      directive: 'Burnish acrylic terrazzo finish only — confirm densified vs coated before UHS.',
      burnishOk: true,
      level: 'warn'
    },
    'Sealed concrete|coated|daily': {
      pad: 'Red',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral cleaner (pH 7-9); light head-pressure protects topical film thickness.',
      burnishOk: false
    },
    'Sealed concrete|coated|scrub': {
      pad: 'Blue',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Lifts shop oils and tire particulate; avoid aggressive green pads on clear coat.',
      burnishOk: false
    },
    'Sealed concrete|coated|grout': {
      pad: 'Poly-bristle Brush',
      alt: 'Cylindrical nylon brush',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Cleans control joints and textured broom finishes without wearing the seal.',
      burnishOk: false
    },
    'Sealed concrete|coated|strip': {
      pad: 'Black',
      alt: 'Brown pad',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Low-odor chemical stripper; double-rinse and neutralize before resealing.',
      burnishOk: false
    },
    'Sealed concrete|coated|burnish': {
      blocked: true,
      title: 'Burnish lockout on topical seals',
      directive: 'High-speed burnishers burn, blister, and peel topical acrylic/epoxy sealers.',
      safeRemap: {
        pad: 'White pad (175 RPM buff)',
        alt: 'White pad',
        machine: '175 RPM rotary ONLY',
        advisory: 'High-speed burnishers scorch topical acrylic/epoxy seals. Remap: low-speed buff at 175 RPM with a White pad — never 1500+ RPM on sealed concrete.'
      }
    },
    'Polished concrete|densified|daily': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Colloidal silica conditioner (pH 7-8); replenishes lithium/silica surface bond.',
      burnishOk: true
    },
    'Polished concrete|densified|scrub': {
      pad: 'Diamond pad (1500g)',
      alt: 'Red pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Conditions concrete pores; cleans tire tracks and industrial grime.',
      burnishOk: false
    },
    'Polished concrete|densified|grout': {
      pad: 'Poly-grit Brush',
      alt: 'Medium cylindrical brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Cleans contraction joints and saw cuts without rounding joint shoulders.',
      burnishOk: false
    },
    'Polished concrete|densified|strip': {
      blocked: true,
      title: 'Not a chemical strip',
      directive: 'NOT APPLICABLE: Mechanically hone with 400 -> 800 -> 1500 grit resin diamonds — no chemical strip.'
    },
    'Polished concrete|densified|restorative': {
      pad: 'Diamond resin discs',
      alt: '400 → 800 → 1500 grit cut',
      machine: 'Planetary grinder / Heavy rotary',
      directive: 'Step-cut wet honing to eliminate traffic scratches; reapply lithium densifier.',
      burnishOk: false,
      wetRequired: true
    },
    'Polished concrete|densified|burnish': {
      pad: 'Diamond pad (3000g)',
      alt: 'Natural hair / Tan burnish pad',
      machine: '1500-3000 RPM high-speed burnisher',
      directive: 'High-speed dry burnish generates friction heat to maximize DOI reflectivity.',
      burnishOk: true
    },
    'Hardwood|factory|daily': {
      pad: 'Microfiber Flat-Mop',
      alt: 'Terrycloth push-mop',
      machine: 'Manual flat-mop ONLY',
      directive: 'LOCKOUT: Auto-scrubbers force water into tongue-and-groove, causing cupping.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood|factory|scrub': {
      pad: 'Red pad (Spray clean)',
      alt: 'White pad',
      machine: '175 RPM swing (Well-wrung)',
      directive: 'Low-moisture spray buff only; immediate dry microfiber towel pickup.',
      burnishOk: false,
      autoscrubberOk: false,
      level: 'warn'
    },
    'Hardwood|factory|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber mop',
      machine: 'Manual / Low-speed swing',
      directive: 'Gentle pass along board bevels; avoid rotary scrubbers across plank joints.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood|factory|strip': {
      blocked: true,
      title: 'Never chemical-strip hardwood',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers permanently cup, swell, and destroy wood timber.',
      insteadOf: {
        pad: 'Abrasive screen mesh 120-150 grit (dry)',
        machine: '175-350 RPM swing rotary',
        text: 'Do this instead: dry mechanical abrasion with a 120–150 grit screen disc at 175 RPM under dust containment, vacuum, then recoat with commercial urethane. Never flood-rinse or chemical-strip wood.'
      }
    },
    'Hardwood|factory|burnish': {
      pad: 'White pad (Dry buff)',
      alt: 'None',
      machine: '175 RPM swing rotary ONLY',
      directive: '1500+ burnishers generate extreme thermal friction, melting urethane topcoats.',
      burnishOk: false
    },
    'Hardwood|coated|daily': {
      pad: 'Microfiber Flat-Mop',
      alt: 'Terrycloth push-mop',
      machine: 'Manual flat-mop ONLY',
      directive: 'LOCKOUT: Auto-scrubbers force water into tongue-and-groove, causing cupping.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood|coated|scrub': {
      pad: 'Red pad (Spray clean)',
      alt: 'White pad',
      machine: '175 RPM swing (Well-wrung)',
      directive: 'Low-moisture spray buff only; immediate dry microfiber towel pickup.',
      burnishOk: false,
      autoscrubberOk: false,
      level: 'warn'
    },
    'Hardwood|coated|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber mop',
      machine: 'Manual / Low-speed swing',
      directive: 'Gentle pass along board bevels; avoid rotary scrubbers across plank joints.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood|coated|strip': {
      blocked: true,
      title: 'Never chemical-strip hardwood',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers permanently cup, swell, and destroy wood timber.',
      insteadOf: {
        pad: 'Abrasive screen mesh 120-150 grit (dry)',
        machine: '175-350 RPM swing rotary',
        text: 'Do this instead: dry mechanical abrasion with a 120–150 grit screen disc at 175 RPM under dust containment, vacuum, then recoat with commercial urethane. Never flood-rinse or chemical-strip wood.'
      }
    },
    'Hardwood|coated|burnish': {
      pad: 'White pad (Dry buff)',
      alt: 'None',
      machine: '175 RPM swing rotary ONLY',
      directive: '1500+ burnishers generate extreme thermal friction, melting urethane topcoats.',
      burnishOk: false
    },
    'Hardwood|coated|restorative': {
      pad: 'Abrasive screen disc',
      alt: '120-150 grit screen',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Screen existing urethane to abrade surface; vacuum; apply commercial urethane.',
      burnishOk: false
    },
    'Hardwood|factory|restorative': {
      pad: 'Abrasive screen disc',
      alt: '120-150 grit screen',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Screen existing urethane to abrade surface; vacuum; apply commercial urethane.',
      burnishOk: false
    },
    'Hardwood oil|oil|daily': {
      pad: 'Microfiber Flat-Mop',
      alt: 'Cotton push-mop',
      machine: 'Manual flat-mop ONLY',
      directive: 'LOCKOUT: Waterborne cleaners cloud oil finish. Use nourishing plant-oil soap.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|oil|scrub': {
      pad: 'White pad (Dry buff)',
      alt: 'Red pad (Ultra-light pressure)',
      machine: '175 RPM swing rotary (Dry)',
      directive: 'Dry-buff scuffs; never wet-scrub raw timber. Water swells grain.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|oil|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber tack mop',
      machine: 'Manual / 175 RPM swing',
      directive: 'Follow wood grain direction; clean micro-bevels without liquid pooling.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|oil|strip': {
      blocked: true,
      title: 'Never chemical-strip oil-finished hardwood',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers ruin open-grain oiled timber and void NWFA guidance.',
      insteadOf: {
        pad: 'Green pad (prep) then White pad (oil buff)',
        machine: '175 RPM rotary ONLY',
        text: 'Do this instead: deep-clean with intensive wood soap, then buff fresh hardwax / maintenance oil into the grain. Never chemical-strip oil-finished wood.'
      }
    },
    'Hardwood oil|oil|burnish': {
      pad: 'White pad + Oil',
      alt: 'Natural hair buffer pad',
      machine: '175 RPM rotary ONLY',
      directive: 'Work liquid maintenance refresher oil deep into open pores of timber.',
      burnishOk: false
    },
    'Hardwood oil|oil|restorative': {
      pad: 'Green pad (Prep)',
      alt: 'White pad (Oil buff)',
      machine: '175 RPM rotary ONLY',
      directive: 'Deep-clean with wood cleaner; buff fresh hardwax maintenance oil to grain.',
      burnishOk: false
    },
    'Painted wood|gym|daily': {
      pad: 'Microfiber Push-Mop',
      alt: 'Terrycloth tack towel',
      machine: 'Manual push-mop ONLY',
      directive: 'LOCKOUT: Auto-scrubbers flood seams and warp athletic gym sports floors.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|gym|scrub': {
      pad: 'White pad (Dry buff)',
      alt: 'Red pad (Tack mist)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Light dry buffing to remove sneaker burn marks; tack with MFMA cleaner.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|gym|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber mop',
      machine: 'Manual / Low-speed swing',
      directive: 'Gentle pass along painted lines and bevels only.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|gym|strip': {
      blocked: true,
      title: 'Never chemical-strip gym finish',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers peel game lines and warp athletic subfloors.',
      insteadOf: {
        pad: 'Screen disc 100-120 grit (dry) / Maroon Prep Pad',
        machine: '175 RPM rotary (Dry with vac)',
        text: 'Do this instead: dry screen or maroon prep under dust containment, vacuum-tack, touch up lines, then recoat with MFMA-approved gym finish.'
      }
    },
    'Painted wood|gym|burnish': {
      pad: 'White pad',
      alt: 'Tan buffing pad',
      machine: '175 RPM rotary ONLY',
      directive: '1500+ burnishing burns gym urethane and creates irregular traction coefficients.',
      burnishOk: false
    },
    'Painted wood|gym|restorative': {
      pad: 'Maroon Prep Pad',
      alt: 'Screen disc (100-120 grit)',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Abrade court; vacuum tack; touch up game lines; coat with MFMA gym finish.',
      burnishOk: false
    },
    'Epoxy|coated|daily': {
      pad: 'Red',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Low down-pressure; neutral synthetic industrial degreaser (pH 7-9).',
      burnishOk: false
    },
    'Epoxy|coated|scrub': {
      pad: 'Blue',
      alt: 'Green pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Removes forklift tire marks and grease; rinse thoroughly to prevent haze.',
      burnishOk: false
    },
    'Epoxy|textured|grout': {
      pad: 'Cylindrical Poly Brush',
      alt: 'Nylon deck scrubbing brush',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Flat pads tear on aggregate profiles; cylindrical bristles reach base texture.',
      burnishOk: false
    },
    'Epoxy|coated|grout': {
      pad: 'Cylindrical Poly Brush',
      alt: 'Nylon deck scrubbing brush',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Flat pads tear on aggregate profiles; cylindrical bristles reach base texture.',
      burnishOk: false
    },
    'Epoxy|coated|strip': {
      pad: 'Maroon Prep Pad',
      alt: 'Brown pad (Light pressure)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Mechanical abrade for recoat; solvent strippers soften underlying epoxy.',
      burnishOk: false
    },
    'Epoxy|coated|burnish': {
      blocked: true,
      title: 'Burnish lockout on epoxy',
      directive: 'LOCKOUT: High-speed burnishers scorch resin binders, causing yellowing.',
      insteadOf: {
        pad: 'Red (daily) or Blue (scrub)',
        machine: 'Auto-scrubber / 175-350 RPM swing',
        text: 'Do this instead: daily-clean or scrub with Red / Blue pads on an auto-scrubber or 175-350 RPM swing — epoxy does not take a high-speed burnish.'
      }
    },
    'Epoxy|textured|daily': {
      pad: 'Red',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Low down-pressure; neutral synthetic industrial degreaser (pH 7-9).',
      burnishOk: false
    },
    'Epoxy|textured|scrub': {
      pad: 'Blue',
      alt: 'Green pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Removes forklift tire marks and grease; rinse thoroughly.',
      burnishOk: false
    },
    'Epoxy|textured|strip': {
      pad: 'Maroon Prep Pad',
      alt: 'Brown pad (Light pressure)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Mechanical abrade for recoat; solvent strippers soften underlying epoxy.',
      burnishOk: false
    },
    'Epoxy|textured|burnish': {
      blocked: true,
      title: 'Burnish lockout on epoxy',
      directive: 'LOCKOUT: High-speed burnishers scorch resin binders, causing yellowing.',
      insteadOf: {
        pad: 'Red (daily) or Blue (scrub)',
        machine: 'Auto-scrubber / 175-350 RPM swing',
        text: 'Do this instead: daily-clean or scrub with Red / Blue pads on an auto-scrubber or 175-350 RPM swing — epoxy does not take a high-speed burnish.'
      }
    },
    'Resinous|coated|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral-to-mild alkaline industrial cleaner; wash away process chemical residue.',
      burnishOk: false
    },
    'Resinous|coated|scrub': {
      pad: 'Blue',
      alt: 'Green pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'High chemical and thermal shock resistance; scrub embedded manufacturing oils.',
      burnishOk: false
    },
    'Resinous|textured|grout': {
      pad: 'Nylon Grit Brush',
      alt: 'Cylindrical poly brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Bristles penetrate textured quartz profile to lift particulate without wear.',
      burnishOk: false
    },
    'Resinous|coated|grout': {
      pad: 'Nylon Grit Brush',
      alt: 'Cylindrical poly brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Bristles penetrate textured quartz profile to lift particulate without wear.',
      burnishOk: false
    },
    'Resinous|coated|strip': {
      pad: '80-Grit Screen Disc',
      alt: 'Maroon SPP',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Heavy diamond or screen grind to mechanically key surface for fresh MMA coat.',
      burnishOk: false
    },
    'Resinous|coated|burnish': {
      blocked: true,
      title: 'Burnish lockout on MMA resinous',
      directive: 'Thermoplastic MMA resins soften and smear under high-speed friction.',
      insteadOf: {
        pad: 'Red (daily) or Blue (scrub)',
        machine: 'Auto-scrubber / 175-350 RPM swing',
        text: 'Do this instead: scrub or daily-clean with Red / Blue pads on an auto-scrubber or 175-350 RPM swing — do not high-speed burnish MMA.'
      }
    },
    'Resinous|textured|daily': {
      pad: 'Red',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral-to-mild alkaline industrial cleaner; wash away process chemical residue.',
      burnishOk: false
    },
    'Resinous|textured|scrub': {
      pad: 'Blue',
      alt: 'Green pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Scrub embedded manufacturing oils from quartz aggregate.',
      burnishOk: false
    },
    'Resinous|textured|strip': {
      pad: '80-Grit Screen Disc',
      alt: 'Maroon SPP',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Heavy diamond or screen grind to mechanically key surface for fresh MMA coat.',
      burnishOk: false
    },
    'Resinous|textured|burnish': {
      blocked: true,
      title: 'Burnish lockout on MMA resinous',
      directive: 'Thermoplastic MMA resins soften and smear under high-speed friction.',
      insteadOf: {
        pad: 'Red (daily) or Blue (scrub)',
        machine: 'Auto-scrubber / 175-350 RPM swing',
        text: 'Do this instead: scrub or daily-clean with Red / Blue pads on an auto-scrubber or 175-350 RPM swing — do not high-speed burnish MMA.'
      }
    },
    'ESD|dissipative|daily': {
      pad: 'White (ESD-safe)',
      alt: 'Microfiber flat pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Dedicated anti-static ESD cleaner; preserves grounding conductivity path.',
      burnishOk: false
    },
    'ESD|dissipative|scrub': {
      pad: 'White (ESD-safe)',
      alt: 'Red pad (Ultra-light pressure)',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Avoid abrasive pads that scratch carbon veins or conductive elements.',
      burnishOk: false
    },
    'ESD|dissipative|grout': {
      pad: 'Soft Nylon Brush',
      alt: 'Microfiber mop',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Flushes dust without abrading conductive matrix; rinse with deionized water.',
      burnishOk: false
    },
    'ESD|dissipative|strip': {
      pad: 'Blue / Green (ESD-safe)',
      alt: 'Low-abrasive strip pad',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Use ESD-safe neutral stripper; test resistance per ANSI/ESD STM 7.1.',
      burnishOk: false
    },
    'ESD|dissipative|burnish': {
      blocked: true,
      title: 'Burnish lockout on ESD flooring',
      directive: 'High-speed burnishers generate static charges and strip dissipative topcoats.'
    },
    'Safety floor|grit|daily': {
      pad: 'Cylindrical Nylon Brush',
      alt: 'Soft poly bristle brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'NO PADS: Embedded aluminum oxide/silicon carbide grains shred floor pads.',
      burnishOk: false
    },
    'Safety floor|grit|scrub': {
      pad: 'Counter-Rotating Brush',
      alt: 'Nylon deck scrubbing brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Brushes extract particulate from micro-texture valleys without fiber shedding.',
      burnishOk: false
    },
    'Safety floor|grit|grout': {
      pad: 'Cylindrical Nylon Brush',
      alt: 'High-pressure extraction',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Cleans relief pattern; use alkaline safety cleaner to lift bound soils.',
      burnishOk: false
    },
    'Safety floor|grit|strip': {
      pad: 'Green Scrub Brush',
      alt: 'Alkaline safety wash (pH 9-10)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Strippers soften vinyl matrix; pads tear immediately. Use brush & alkaline wash.',
      burnishOk: false
    },
    'Safety floor|grit|burnish': {
      blocked: true,
      title: 'Burnish lockout on safety flooring',
      directive: 'Burnishing melts grit granules, destroys traction, and voids slip ratings.',
      insteadOf: {
        pad: 'Cylindrical Nylon Brush',
        machine: 'Cylindrical / orbital scrubber (175-300)',
        text: 'Do this instead: scrub with a cylindrical / orbital deck and nylon bristle brushes — never flat pads or high-speed burnishers on grit-embedded safety vinyl.'
      }
    },
    'Carpet|broadloom|daily': {
      pad: 'Dual-motor Upright Vacuum',
      alt: 'HEPA backpack vacuum',
      machine: 'Manual vacuuming ONLY',
      directive: 'Extract surface soil daily before particulate works down into carpet backing.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Carpet|modular|interim': {
      pad: 'Fiber Encapsulation Pad',
      alt: 'Microfiber bonnet pad',
      machine: '175 RPM rotary / Orbital',
      directive: 'Mist CRI-approved polymer encapsulant; agitate; vacuum crystal residues.',
      burnishOk: false
    },
    'Carpet|broadloom|interim': {
      pad: 'Fiber Encapsulation Pad',
      alt: 'Microfiber bonnet pad',
      machine: '175 RPM rotary / Orbital',
      directive: 'Mist CRI-approved polymer encapsulant; agitate; vacuum crystal residues.',
      burnishOk: false
    },
    'Carpet|modular|daily': {
      pad: 'Dual-motor Upright Vacuum',
      alt: 'HEPA backpack vacuum',
      machine: 'Manual vacuuming ONLY',
      directive: 'Extract surface soil daily before particulate works down into carpet backing.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Carpet|broadloom|restorative': {
      pad: 'Extraction Wand',
      alt: 'CRI-SOA certified extractor',
      machine: 'Hot water extraction (< 120°F)',
      directive: 'Deep flush; pre-spray traffic lanes; extract with vacuum; place air movers.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Carpet|modular|restorative': {
      pad: 'Extraction Wand',
      alt: 'CRI-SOA certified extractor',
      machine: 'Hot water extraction (< 120°F)',
      directive: 'Deep flush; pre-spray traffic lanes; extract with vacuum; place air movers.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Carpet|broadloom|scrub': {
      pad: 'Fiber Encapsulation Pad',
      alt: 'Microfiber bonnet pad',
      machine: '175 RPM rotary / Orbital',
      directive: 'Interim-style encapsulation scrub for traffic lanes; vacuum residues.',
      burnishOk: false
    },
    'Carpet|modular|scrub': {
      pad: 'Fiber Encapsulation Pad',
      alt: 'Microfiber bonnet pad',
      machine: '175 RPM rotary / Orbital',
      directive: 'Interim-style encapsulation scrub for traffic lanes; vacuum residues.',
      burnishOk: false
    },
    'Carpet|broadloom|strip': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Carpet cannot be chemically stripped like hard floors.',
      safeRemap: {
        pad: 'Extraction Wand',
        alt: 'CRI-SOA certified extractor',
        machine: 'Hot water extraction (< 120 F)',
        advisory: 'Invalid task: carpet is not chemically stripped. Do this instead: restorative hot-water extraction, or interim encapsulation / bonnet cleaning on a 175 RPM rotary.'
      }
    },
    'Carpet|modular|strip': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Carpet cannot be chemically stripped like hard floors.',
      safeRemap: {
        pad: 'Extraction Wand',
        alt: 'CRI-SOA certified extractor',
        machine: 'Hot water extraction (< 120 F)',
        advisory: 'Invalid task: carpet is not chemically stripped. Do this instead: restorative hot-water extraction, or interim encapsulation / bonnet cleaning on a 175 RPM rotary.'
      }
    },
    'Carpet|broadloom|burnish': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Carpet cannot be burnished or polished. A swing rotary is legal for encapsulation or bonnet cleaning — not for polish.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Microfiber bonnet pad',
        machine: '175 RPM rotary / Orbital',
        advisory: 'Invalid task: carpet cannot be burnished or polished. Do this instead: low-moisture encapsulation or bonnet cleaning with a Fiber Encapsulation Pad (or Microfiber bonnet) on a 175 RPM swing / orbital. Never a high-speed burnisher.'
      }
    },
    'Carpet|modular|burnish': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Carpet cannot be burnished or polished. A swing rotary is legal for encapsulation or bonnet cleaning — not for polish.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Microfiber bonnet pad',
        machine: '175 RPM rotary / Orbital',
        advisory: 'Invalid task: carpet cannot be burnished or polished. Do this instead: low-moisture encapsulation or bonnet cleaning with a Fiber Encapsulation Pad (or Microfiber bonnet) on a 175 RPM swing / orbital. Never a high-speed burnisher.'
      }
    },
    'Carpet|broadloom|hone': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Diamond honing does not apply to carpet pile.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Extraction Wand',
        machine: '175 RPM rotary / Hot-water extractor',
        advisory: 'Invalid task: carpet cannot be diamond-honed. Do this instead: interim encapsulation / bonnet, or restorative hot-water extraction.'
      }
    },
    'Carpet|modular|hone': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Diamond honing does not apply to carpet pile.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Extraction Wand',
        machine: '175 RPM rotary / Hot-water extractor',
        advisory: 'Invalid task: carpet cannot be diamond-honed. Do this instead: interim encapsulation / bonnet, or restorative hot-water extraction.'
      }
    },
    'Carpet|broadloom|grout': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Grout cleaning does not apply to carpet.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Microfiber bonnet pad',
        machine: '175 RPM rotary / Orbital',
        advisory: 'Invalid task: grout work does not apply to carpet. Do this instead: interim encapsulation or restorative extraction.'
      }
    },
    'Carpet|modular|grout': {
      blocked: true,
      taskInvalid: true,
      title: 'Invalid task for carpet',
      directive: 'Grout cleaning does not apply to carpet.',
      safeRemap: {
        pad: 'Fiber Encapsulation Pad',
        alt: 'Microfiber bonnet pad',
        machine: '175 RPM rotary / Orbital',
        advisory: 'Invalid task: grout work does not apply to carpet. Do this instead: interim encapsulation or restorative extraction.'
      }
    },
    'Quarry tile|silicone|daily': {
      pad: 'Cylindrical Grit Brush',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175 RPM)',
      directive: 'Bio-enzymatic cleaner; breaks down kitchen fats without slippery residue.',
      burnishOk: false
    },
    'Quarry tile|silicone|scrub': {
      pad: 'Silicon Carbide Brush',
      alt: 'Green pad',
      machine: '175 RPM swing rotary (Heavy)',
      directive: 'High-load scrub with foaming alkaline degreaser; squeegee to drains.',
      burnishOk: false
    },
    'Quarry tile|silicone|grout': {
      pad: 'Silicon Carbide Brush',
      alt: 'Deck scrubbing brush',
      machine: '175 RPM swing rotary (Heavy)',
      directive: 'Rigid bristle tips reach recessed wide grout joints to extract mineral scale.',
      burnishOk: false
    },
    'Quarry tile|silicone|strip': {
      pad: 'Black',
      alt: 'Wire / Grit rotary brush',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Phosphoric acid descaler or heavy degreaser to strip polymerized cooking grease.',
      burnishOk: false
    },
    'Quarry tile|silicone|burnish': {
      blocked: true,
      title: 'Burnish lockout on quarry tile',
      directive: 'Porous unsealed kiln-fired clay cannot take a burnished mechanical shine.'
    },
    'Sealed concrete|penetrating|daily': {
      pad: 'Red',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Neutral cleaner (pH 7-9); light head-pressure protects topical film thickness.',
      burnishOk: false
    },
    'Sealed concrete|penetrating|scrub': {
      pad: 'Blue',
      alt: 'Red pad',
      machine: 'Auto-scrubber / Rotary (175-350 RPM)',
      directive: 'Lifts shop oils and tire particulate; avoid aggressive green pads on clear coat.',
      burnishOk: false
    },
    'Sealed concrete|penetrating|grout': {
      pad: 'Poly-bristle Brush',
      alt: 'Cylindrical nylon brush',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Cleans control joints and textured broom finishes without wearing the seal.',
      burnishOk: false
    },
    'Sealed concrete|penetrating|strip': {
      pad: 'Black',
      alt: 'Brown pad',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Low-odor chemical stripper; double-rinse and neutralize before resealing.',
      burnishOk: false
    },
    'Sealed concrete|penetrating|burnish': {
      blocked: true,
      title: 'Burnish lockout on topical seals',
      directive: 'High-speed burnishers burn, blister, and peel topical acrylic/epoxy sealers.',
      safeRemap: {
        pad: 'White pad (175 RPM buff)',
        alt: 'White pad',
        machine: '175 RPM rotary ONLY',
        advisory: 'High-speed burnishers scorch topical acrylic/epoxy seals. Remap: low-speed buff at 175 RPM with a White pad — never 1500+ RPM on sealed concrete.'
      }
    },
    'Polished concrete|mechanical|daily': {
      pad: 'Diamond pad (3000g)',
      alt: 'White pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Colloidal silica conditioner (pH 7-8); replenishes lithium/silica surface bond.',
      burnishOk: true
    },
    'Polished concrete|mechanical|scrub': {
      pad: 'Diamond pad (1500g)',
      alt: 'Red pad',
      machine: 'Auto-scrubber (175-350 RPM)',
      directive: 'Conditions concrete pores; cleans tire tracks and industrial grime.',
      burnishOk: false
    },
    'Polished concrete|mechanical|grout': {
      pad: 'Poly-grit Brush',
      alt: 'Medium cylindrical brush',
      machine: 'Auto-scrubber (175-300 RPM)',
      directive: 'Cleans contraction joints and saw cuts without rounding joint shoulders.',
      burnishOk: false
    },
    'Polished concrete|mechanical|strip': {
      blocked: true,
      title: 'Not a chemical strip',
      directive: 'NOT APPLICABLE: Mechanically hone with 400 -> 800 -> 1500 grit resin diamonds — no chemical strip.'
    },
    'Polished concrete|mechanical|burnish': {
      pad: 'Diamond pad (3000g)',
      alt: 'Natural hair / Tan burnish pad',
      machine: '1500-3000 RPM high-speed burnisher',
      directive: 'High-speed dry burnish generates friction heat to maximize DOI reflectivity.',
      burnishOk: true
    },
    'Polished concrete|mechanical|restorative': {
      pad: 'Diamond resin discs',
      alt: '400 → 800 → 1500 grit cut',
      machine: 'Planetary grinder / Heavy rotary',
      directive: 'Step-cut wet honing to eliminate traffic scratches; reapply lithium densifier.',
      burnishOk: false,
      wetRequired: true
    },
    'Hardwood oil|raw|daily': {
      pad: 'Microfiber Flat-Mop',
      alt: 'Cotton push-mop',
      machine: 'Manual flat-mop ONLY',
      directive: 'LOCKOUT: Waterborne cleaners cloud oil finish. Use nourishing plant-oil soap.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|raw|scrub': {
      pad: 'White pad (Dry buff)',
      alt: 'Red pad (Ultra-light pressure)',
      machine: '175 RPM swing rotary (Dry)',
      directive: 'Dry-buff scuffs; never wet-scrub raw timber. Water swells grain.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|raw|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber tack mop',
      machine: 'Manual / 175 RPM swing',
      directive: 'Follow wood grain direction; clean micro-bevels without liquid pooling.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Hardwood oil|raw|strip': {
      blocked: true,
      title: 'Never chemical-strip oil-finished hardwood',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers ruin open-grain oiled timber and void NWFA guidance.',
      insteadOf: {
        pad: 'Green pad (prep) then White pad (oil buff)',
        machine: '175 RPM rotary ONLY',
        text: 'Do this instead: deep-clean with intensive wood soap, then buff fresh hardwax / maintenance oil into the grain. Never chemical-strip oil-finished wood.'
      }
    },
    'Hardwood oil|raw|burnish': {
      pad: 'White pad + Oil',
      alt: 'Natural hair buffer pad',
      machine: '175 RPM rotary ONLY',
      directive: 'Work liquid maintenance refresher oil deep into open pores of timber.',
      burnishOk: false
    },
    'Hardwood oil|raw|restorative': {
      pad: 'Green pad (Prep)',
      alt: 'White pad (Oil buff)',
      machine: '175 RPM rotary ONLY',
      directive: 'Deep-clean with wood cleaner; buff fresh hardwax maintenance oil to grain.',
      burnishOk: false
    },
    'Painted wood|linepaint|daily': {
      pad: 'Microfiber Push-Mop',
      alt: 'Terrycloth tack towel',
      machine: 'Manual push-mop ONLY',
      directive: 'LOCKOUT: Auto-scrubbers flood seams and warp athletic gym sports floors.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|linepaint|scrub': {
      pad: 'White pad (Dry buff)',
      alt: 'Red pad (Tack mist)',
      machine: '175 RPM swing rotary ONLY',
      directive: 'Light dry buffing to remove sneaker burn marks; tack with MFMA cleaner.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|linepaint|grout': {
      pad: 'Soft Horsehair Brush',
      alt: 'Microfiber mop',
      machine: 'Manual / Low-speed swing',
      directive: 'Gentle pass along painted lines and bevels only.',
      burnishOk: false,
      autoscrubberOk: false
    },
    'Painted wood|linepaint|strip': {
      blocked: true,
      title: 'Never chemical-strip gym finish',
      directive: 'SUBSTRATE INTEGRITY LOCKOUT: Chemical strippers peel game lines and warp athletic subfloors.',
      insteadOf: {
        pad: 'Screen disc 100-120 grit (dry) / Maroon Prep Pad',
        machine: '175 RPM rotary (Dry with vac)',
        text: 'Do this instead: dry screen or maroon prep under dust containment, vacuum-tack, touch up lines, then recoat with MFMA-approved gym finish.'
      }
    },
    'Painted wood|linepaint|burnish': {
      pad: 'White pad',
      alt: 'Tan buffing pad',
      machine: '175 RPM rotary ONLY',
      directive: '1500+ burnishing burns gym urethane and creates irregular traction coefficients.',
      burnishOk: false
    },
    'Painted wood|linepaint|restorative': {
      pad: 'Maroon Prep Pad',
      alt: 'Screen disc (100-120 grit)',
      machine: '175 RPM rotary (Dry with vac)',
      directive: 'Abrade court; vacuum tack; touch up game lines; coat with MFMA gym finish.',
      burnishOk: false
    }

  };

  function padFinishOptsFor(floor) {
    var f = String(floor || '');
    if (f === 'Natural stone') f = 'Marble';
    return (PAD_FINISH_OPTS[f] || PAD_FINISH_OPTS.VCT || []).slice();
  }

  function padDefaultFinish(floor) {
    var opts = padFinishOptsFor(floor);
    return (opts[0] && opts[0].value) || 'coated';
  }

  function padClampFinish(floor, finish) {
    var opts = padFinishOptsFor(floor);
    var want = String(finish || '');
    var i, o;
    for (i = 0; i < opts.length; i++) {
      if (String(opts[i].value) === want) return want;
    }
    // Common aliases before falling back to default
    var aliases = {
      uncoated: ['factory', 'bare', 'natural', 'densified', 'honed', 'mechanical', 'raw'],
      factory: ['uncoated', 'bare'],
      coated: ['factory', 'penetrating'],
      glazed: ['natural'],
      natural: ['glazed'],
      densified: ['uncoated', 'polished', 'mechanical'],
      mechanical: ['densified', 'polished'],
      polished: ['honed', 'densified'],
      honed: ['polished'],
      textured: ['factory', 'coated'],
      bare: ['factory', 'uncoated', 'natural', 'grit'],
      grit: ['textured', 'factory', 'bare'],
      conductive: ['dissipative', 'coated', 'factory'],
      dissipative: ['coated'],
      silicone: ['bare', 'factory'],
      penetrating: ['coated', 'factory'],
      raw: ['oil', 'factory'],
      oil: ['raw', 'factory'],
      linepaint: ['gym', 'coated'],
      gym: ['linepaint', 'coated']
    };
    var tryList = aliases[want] || [];
    for (i = 0; i < tryList.length; i++) {
      for (o = 0; o < opts.length; o++) {
        if (String(opts[o].value) === tryList[i]) return tryList[i];
      }
    }
    return padDefaultFinish(floor);
  }

  function padFinishLabel(finish, floor) {
    var f = String(finish || '');
    var fl = String(floor || '');
    if (fl === 'Natural stone') fl = 'Marble';
    // Floor-scoped label first so Resinous coated ≠ acrylic VCT sacrificial
    var opts = padFinishOptsFor(fl);
    var i;
    for (i = 0; i < opts.length; i++) {
      if (String(opts[i].value) === f) return opts[i].label;
    }
    if (FINISH_LABELS[f]) return FINISH_LABELS[f];
    var keys = Object.keys(PAD_FINISH_OPTS);
    var j, list;
    for (i = 0; i < keys.length; i++) {
      list = PAD_FINISH_OPTS[keys[i]] || [];
      for (j = 0; j < list.length; j++) {
        if (String(list[j].value) === f) return list[j].label;
      }
    }
    return f || 'Finish';
  }

  /** Override pad_chart use_case when the shared Diamond entry is concrete-only. */
  function padUseCaseForFloor(floor, padName, chartUseCase) {
    var f = String(floor || '');
    var pad = String(padName || '');
    var chart = String(chartUseCase || '').trim();
    if (/diamond/i.test(pad)) {
      if (f === 'Marble' || f === 'Natural stone' || /limestone|travertine/i.test(f)) {
        return 'Calcite stone polishing and mechanical micro-honing';
      }
      if (f === 'Granite') {
        return 'Granite polishing and mechanical micro-honing';
      }
      if (f === 'Terrazzo') {
        return 'Terrazzo polishing and densification';
      }
    }
    return chart || ('Maintenance pad for ' + (f || 'floor'));
  }

  /** Substrate max RPM — wood / rubber / safety never inherit White pad's 1500+ chart ceiling. */
  function padFloorRpmCeiling(floor, machineHint) {
    var f = String(floor || '');
    var m = String(machineHint || '');
    if (f === 'Hardwood' || f === 'Hardwood oil' || f === 'Painted wood') return 175;
    if (f === 'Rubber' || f === 'Safety floor') return 175;
    if (/175\s*RPM\s*ONLY|Never\s+(high[- ]speed\s+)?burnish|Dry buffing only/i.test(m)) return 175;
    if (/\(Dry\)/i.test(m) && /175\s*RPM/i.test(m) && !/175\s*[-–—\/]\s*350|1500|3000/i.test(m)) return 175;
    if (/^175\s*RPM/i.test(m.trim()) && !/175\s*[-–—\/]\s*350|175\s*\/\s*300|1500|3000/i.test(m)) return 175;
    return null;
  }

  /** Clamp pad_chart typical_rpm to substrate / machine ceiling (web + PDF). */
  function padClampTypicalRpm(chartRpm, floor, machineHint) {
    var raw = String(chartRpm || '').trim();
    if (!raw) return '—';
    var ascii = raw.replace(/[–—]/g, '-').replace(/×/g, 'x');
    var ceiling = padFloorRpmCeiling(floor, machineHint);
    if (ceiling == null) return ascii;
    var nums = ascii.match(/\d+/g);
    if (!nums || !nums.length) return ascii + ' (max ' + ceiling + ')';
    var vals = nums.map(function (n) { return parseInt(n, 10); }).filter(function (n) { return isFinite(n); });
    if (!vals.length) return ascii;
    var lo = Math.min.apply(null, vals);
    var hi = Math.max.apply(null, vals);
    if (hi <= ceiling) return ascii;
    if (lo >= ceiling || lo === hi) return String(ceiling) + ' (substrate max)';
    return String(Math.min(lo, ceiling)) + '-' + ceiling + ' (substrate max)';
  }

  /** Matrix path is dry-buff / dry-screen — damp water mist contradicts the prescription. */
  function padPathRequiresDry(row, floor) {
    if (!row) return false;
    var blob = [row.machine, row.pad, row.directive, row.title].join(' ');
    if (/\(Dry\)|Dry buff|Dry-buff|dry screen|dry with vac|never wet|Never wet|Dry buffing only/i.test(blob)) {
      return true;
    }
    if ((floor === 'Hardwood oil' || floor === 'Hardwood' || floor === 'Painted wood') &&
        /water swells|never wet-scrub|open-grain|raw timber/i.test(blob)) {
      return true;
    }
    return false;
  }

  function padMatrixKey(floor, finish, task) {
    return String(floor) + '|' + String(finish) + '|' + String(task);
  }

  function lookupPadMatrix(floor, finish, task) {
    var f = String(floor || '');
    var fin = String(finish || '');
    var t = String(task || '');
    if (f === 'Natural stone') f = 'Marble';

    function get(fl, fi, tk) {
      return PAD_MATRIX[padMatrixKey(fl, fi, tk)] || null;
    }

    var hit = get(f, fin, t);
    if (hit) return hit;

    // Finish aliases
    var finishAliasChains = {
      uncoated: ['factory', 'bare', 'natural', 'densified', 'honed', 'polished', 'mechanical', 'raw'],
      factory: ['uncoated', 'bare', 'coated'],
      coated: ['factory', 'dissipative', 'penetrating'],
      bare: ['factory', 'uncoated', 'natural', 'grit'],
      natural: ['glazed', 'bare', 'uncoated'],
      glazed: ['natural'],
      densified: ['uncoated', 'polished', 'factory', 'mechanical'],
      mechanical: ['densified', 'uncoated', 'polished'],
      polished: ['honed', 'densified', 'uncoated'],
      honed: ['polished', 'uncoated'],
      textured: ['factory', 'coated', 'grit'],
      oil: ['factory', 'coated', 'raw'],
      raw: ['oil', 'factory'],
      gym: ['coated', 'factory', 'linepaint'],
      linepaint: ['gym', 'coated'],
      silicone: ['bare', 'factory', 'natural'],
      penetrating: ['coated', 'factory', 'densified'],
      dissipative: ['coated'],
      conductive: ['dissipative', 'coated', 'factory'],
      grit: ['textured', 'factory', 'bare'],
      modular: ['broadloom'],
      broadloom: ['modular']
    };
    var chain = finishAliasChains[fin] || [];
    var i;
    for (i = 0; i < chain.length; i++) {
      hit = get(f, chain[i], t);
      if (hit) return hit;
    }

    // Task fallbacks: interim → scrub; hone → restorative/scrub; restorative → scrub
    if (t === 'interim' || t === 'restorative' || t === 'hone') {
      var fbTasks = t === 'hone' ? ['restorative', 'scrub', 'burnish'] : (t === 'restorative' ? ['scrub', 'strip'] : ['scrub']);
      var fi;
      for (fi = 0; fi < fbTasks.length; fi++) {
        hit = get(f, fin, fbTasks[fi]);
        if (hit) return hit;
        for (i = 0; i < chain.length; i++) {
          hit = get(f, chain[i], fbTasks[fi]);
          if (hit) return hit;
        }
      }
    }

    return null;
  }


  /** Diamond impregnated pad (DIP) restoration sequences — stone / densified concrete. */
  function padDipSequence(floor, task) {
    var f = String(floor || '');
    var stoneLike = f === 'Marble' || f === 'Granite' || f === 'Terrazzo' || f === 'Natural stone';
    var polishedConc = f === 'Polished concrete';
    if (!stoneLike && !polishedConc) return null;
    if (task === 'daily') {
      return {
        maintenance: 'Diamond pad (3000 grit) — daily clarity / DOI maintenance',
        steps: null
      };
    }
    if (task === 'scrub' || task === 'hone' || task === 'restorative') {
      if (polishedConc || f === 'Terrazzo') {
        return {
          maintenance: task === 'scrub' ? 'Diamond pad (1500g) for heavy soil' : 'Diamond pad (3000 grit) maintenance',
          steps: [
            'Step 1: 400 grit resin diamond (wet) — cut traffic scratches',
            'Step 2: 800 grit resin diamond (wet) — refine cut',
            'Step 3: 1500 grit resin diamond (wet) — pre-polish',
            'Step 4: 3000 grit resin diamond (wet or dry burnish) — restore DOI; re-densify if specified'
          ]
        };
      }
      // Marble / granite
      return {
        maintenance: task === 'scrub' ? 'Diamond pad (1500-3000g) conditioning' : 'Diamond pad (3000g) polish maintenance',
        steps: [
          'Step 1: 400 grit resin diamond (wet) — remove deep traffic scratches',
          'Step 2: 800 grit resin diamond (wet) — hone to uniform matte',
          'Step 3: 1500 grit resin diamond (wet) — pre-polish',
          'Step 4: 3000 grit resin diamond + stone paste (wet friction) — restore gloss; impregnate'
        ]
      };
    }
    if (task === 'burnish' && (polishedConc || f === 'Terrazzo' || f === 'Granite')) {
      return {
        maintenance: 'Diamond pad (3000 grit) high-speed / maintenance burnish',
        steps: null
      };
    }
    return null;
  }

  /**
   * Three-tier pad resolution: optimal | remap | hard_block
   * Redirects hazardous machine choices to a safe mechanical path when one exists.
   */
  function resolvePadProgram(floor, finish, task, speed, lube, pressure) {
    lube = String(lube || 'damp');
    pressure = String(pressure || 'medium');
    speed = String(speed || 'standard');
    var row = lookupPadMatrix(floor, finish, task);
    var dip = padDipSequence(floor, task);
    var lubeRemapNote = '';

    var MACHINE_LABELS = {
      manual: 'Manual (flat-mop / vacuum / tack)',
      standard: '175-350 RPM swing rotary',
      dual: 'Dual-speed rotary (175 / 300 RPM)',
      autoscrubber: 'Walk-behind auto-scrubber (175-350)',
      cylindrical: 'Cylindrical / orbital scrubber (175-300)',
      burnisher: 'High-speed burnisher (1500-3000 RPM)',
      planetary: 'Planetary / heavy rotary (hone & cut)',
      extractor: 'Hot-water extractor (carpet)'
    };
    var speedLabel = MACHINE_LABELS[speed] || speed;

    function isUhs() { return speed === 'burnisher'; }
    function isWetDeck() { return speed === 'autoscrubber' || speed === 'cylindrical'; }
    function isSwingFamily() { return speed === 'standard' || speed === 'dual'; }
    function rowMachineText() { return String((row && row.machine) || ''); }
    function rowWantsManual() {
      return /manual|flat-mop|push-mop|vacuuming only|tack/i.test(rowMachineText() + ' ' + String((row && row.pad) || ''));
    }
    function rowWantsExtractor() {
      return /extract|hot water/i.test(rowMachineText());
    }
    function rowWantsPlanetary() {
      return /planetary|grinder|heavy rotary|400\s*->|hone/i.test(rowMachineText() + ' ' + String((row && row.pad) || ''));
    }

    function withLube(out) {
      out.lube = lube;
      out.lubeRemapNote = lubeRemapNote || '';
      return out;
    }
    function hard(title, text) {
      return withLube({
        tier: 'hard_block',
        title: title,
        advisory: text,
        row: row,
        dip: dip,
        pad: null,
        alt: null,
        machine: null,
        speedLabel: speedLabel,
        insteadOf: (row && row.insteadOf) || null
      });
    }
    function remap(pad, alt, machine, advisory, extra) {
      extra = extra || {};
      return withLube({
        tier: 'remap',
        title: extra.title || 'Safe alternative prescribed',
        advisory: advisory,
        row: row,
        dip: dip,
        pad: pad,
        alt: alt || (row && row.alt) || '—',
        machine: machine,
        speedLabel: speedLabel,
        level: 'warn'
      });
    }
    function optimal(pad, alt, machine, directive, level) {
      return withLube({
        tier: 'optimal',
        title: 'Optimal match',
        advisory: directive || '',
        row: row,
        dip: dip,
        pad: pad,
        alt: alt || '—',
        machine: machine,
        speedLabel: speedLabel,
        level: level || null
      });
    }

    if (!row) {
      return hard(
        'No matrix prescription',
        'No pad prescription for this floor / finish / task combination. Recheck finish status or open Floor Care Program Builder.'
      );
    }

    // Dry-path prescriptions: damp/flood water mist contradicts Dry machine + directive
    if ((!row.blocked || row.safeRemap) && padPathRequiresDry(row, floor) && lube !== 'dry') {
      var lubeWas = lube;
      lube = 'dry';
      if (floor === 'Hardwood oil') {
        lubeRemapNote =
          'Lubrication remapped from ' + lubeWas +
          ' to Dry / refresher-oil mist — water-based damp or flood swells open-grain oil timber.';
      } else if (floor === 'Hardwood' || floor === 'Painted wood') {
        lubeRemapNote =
          'Lubrication remapped from ' + lubeWas +
          ' to Dry — this wood path is dry-buff only; damp water mist risks grain swell / finish blush.';
      } else {
        lubeRemapNote =
          'Lubrication remapped from ' + lubeWas +
          ' to Dry to match the prescribed dry-buff / dry-screen path.';
      }
    }

    // Marble / limestone grout: always remap away from melamine onto cylindrical poly brush
    if ((floor === 'Marble' || floor === 'Natural stone') && task === 'grout' && !row.blocked) {
      return remap(
        row.pad || 'Cylindrical Poly Brush',
        row.alt || 'Soft horsehair brush',
        speed === 'cylindrical' ? (row.machine || 'Cylindrical / orbital scrubber (175-300)') : 'Cylindrical / orbital scrubber (175-300)',
        'MOHS HARDNESS COLLISION: Melamine foam (Mohs 4) micro-scratches polished calcite marble (Mohs 3). Remapped to cylindrical soft-nylon / poly brush with pH 7.0 neutral stone cleaner — pick up slurry immediately.',
        { title: 'Remapped: no melamine on calcite' }
      );
    }

    // Safety grit: flat pads / UHS shred or melt — remap non-cylindrical decks to brush machines
    if (floor === 'Safety floor' && !row.blocked) {
      if (isUhs() || speed === 'planetary') {
        return hard(
          'Burnish lockout on safety flooring',
          'Burnishing melts grit granules, destroys traction, and voids slip ratings.'
        );
      }
      if (speed !== 'cylindrical' && speed !== 'manual' && speed !== 'extractor') {
        return remap(
          row.pad || 'Cylindrical Nylon Brush',
          row.alt || 'Soft poly bristle brush',
          'Cylindrical / orbital scrubber (175-300)',
          'PAD DESTRUCTION RISK: Embedded carborundum grains shred non-woven rotary pads. Remap: cylindrical / orbital scrubber with nylon bristle brushes — never flat pads.',
          { title: 'Remapped: brushes only on safety grit' }
        );
      }
    }

    // --- HARD BLOCK: substrate destruction (no safe path for this task) ---
    if (row.blocked && !row.safeRemap) {
      return hard(row.title || 'Do not proceed', row.directive || 'Blocked pairing.');
    }

    // Blocked task with a documented safe alternative (e.g. LVT burnish → White @ 175)
    if (row.blocked && row.safeRemap) {
      var sr = row.safeRemap;
      // taskInvalid: always remap (wrong task for substrate, not a machine-speed substitute)
      if (row.taskInvalid || isUhs() || speed === 'planetary') {
        return remap(
          sr.pad,
          sr.alt,
          sr.machine,
          sr.advisory || row.directive,
          { title: row.taskInvalid ? (row.title || 'Invalid task for substrate') : 'Remapped: low-speed alternative' }
        );
      }
      return optimal(sr.pad, sr.alt, sr.machine, sr.advisory || row.directive, 'warn');
    }

    // Hot-water extractor — carpet restorative/interim only
    if (speed === 'extractor') {
      if (floor !== 'Carpet') {
        return remap(
          row.pad,
          row.alt,
          row.machine || '175-350 RPM swing / auto-scrubber',
          'Hot-water extractors are for carpet restorative cleaning, not hard floors. Remap: ' +
            (row.machine || 'swing / auto-scrubber') + ' with ' + row.pad + '.',
          { title: 'Remapped: extractor is carpet-only' }
        );
      }
      if (task === 'daily') {
        return remap(
          row.pad,
          row.alt,
          row.machine || 'Manual vacuuming ONLY',
          'Daily carpet care is vacuuming — not hot-water extraction. Remap: dual-motor upright / HEPA vacuum. Reserve extraction for restorative cycles.',
          { title: 'Remapped: vacuum for daily carpet' }
        );
      }
      if (!rowWantsExtractor() && task !== 'restorative' && task !== 'interim' && task !== 'scrub') {
        return remap(
          row.pad,
          row.alt,
          row.machine,
          'This carpet task does not call for hot-water extraction. Remap: ' + (row.machine || 'encapsulation / vacuum') + ' with ' + row.pad + '.',
          { title: 'Remapped: wrong carpet machine' }
        );
      }
    }

    // Planetary / heavy rotary — hone & cut paths
    if (speed === 'planetary') {
      var dipFloor = floor === 'Polished concrete' || floor === 'Terrazzo' || floor === 'Marble' ||
        floor === 'Granite' || floor === 'Natural stone';
      if (!dipFloor && task !== 'hone' && task !== 'restorative') {
        return remap(
          row.pad,
          row.alt,
          row.machine || '175-350 RPM swing',
          'Planetary grinders are for diamond cut / hone restoration — not routine ' + task + ' on ' + floor +
            '. Remap: ' + (row.machine || '175-350 RPM swing') + ' with ' + row.pad + '.',
          { title: 'Remapped: planetary is for cut/hone' }
        );
      }
      if (task === 'daily' || task === 'grout' || task === 'burnish') {
        if (!(dipFloor && task === 'burnish' && row.burnishOk)) {
          return remap(
            row.pad,
            row.alt,
            row.machine || (task === 'burnish' ? '1500-3000 RPM burnisher' : 'Auto-scrubber (175-350 RPM)'),
            'Planetary heavy cut is overkill for ' + task + '. Remap: ' + (row.machine || 'maintenance machine') +
              ' with ' + row.pad + '.',
            { title: 'Remapped: use maintenance machine' }
          );
        }
      }
    }

    // Manual selected but matrix needs powered scrub/strip/burnish
    if (speed === 'manual') {
      if (task === 'strip' || (task === 'burnish' && row.burnishOk) ||
          (task === 'scrub' && !rowWantsManual() && !/mop|microfiber|vacuum|brush$/i.test(String(row.pad || '')))) {
        if (!rowWantsManual()) {
          return remap(
            row.pad,
            row.alt,
            row.machine || '175 RPM swing rotary',
            'Manual flat-mop / vacuum cannot deliver ' + task + ' on ' + floor +
              '. Remap: ' + (row.machine || '175 RPM swing / auto-scrubber') + ' with ' + row.pad + '.',
            { title: 'Remapped: powered machine required' }
          );
        }
      }
    }

    // Wet-deck machines on wood / gym / carpet vacuum programs
    if (isWetDeck() && row.autoscrubberOk === false) {
      if (row.pad && rowWantsManual()) {
        return remap(
          row.pad,
          row.alt,
          row.machine,
          (speed === 'cylindrical' ? 'Cylindrical scrubbers' : 'Auto-scrubbers') +
            ' are prohibited on ' + floor + ' — water forced into seams cups planks or voids warranties. Remap: ' +
            (row.machine || 'manual flat-mop') + ' with ' + row.pad + '. ' + (row.directive || ''),
          { title: 'Remapped: remove wet scrubber' }
        );
      }
      var wetLock = hard(
        'Wet scrubber lockout on this substrate',
        row.directive ||
          ('Walk-behind auto-scrubbers / cylindrical decks flood seams or are wrong for ' + floor +
            '. Use the machine named in the matrix.')
      );
      var woodFamily = floor === 'Hardwood' || floor === 'Hardwood oil' || floor === 'Painted wood';
      wetLock.insteadOf = {
        pad: row.pad || (woodFamily ? 'Microfiber Flat-Mop' : '—'),
        machine: woodFamily ? 'Manual (flat-mop / tack)' : 'None — scrubber prohibited',
        text: woodFamily
          ? ('Do this instead: Manual (flat-mop / tack)' +
            (row.pad ? (' with ' + row.pad) : '') +
            ' — never flood wood seams with an auto-scrubber.')
          : ('Do this instead: pick a legal machine for ' + floor +
            ' from the matrix — wet scrubbers are prohibited here.')
      };
      return wetLock;
    }

    // UHS cannot perform wet scrub / grout / strip / carpet interim
    if (isUhs() && (task === 'grout' || task === 'scrub' || task === 'strip' ||
        task === 'interim' || task === 'restorative' || task === 'hone' || task === 'daily')) {
      return remap(
        row.pad,
        row.alt,
        row.machine || '175-350 RPM swing / auto-scrubber',
        'High-speed burnishers (1500-3000 RPM) cannot execute ' + task +
          ' work. Remap: switch to ' + (row.machine || '175-350 RPM swing or auto-scrubber') +
          ' with ' + row.pad + '. ' + (row.directive || ''),
        { title: 'Remapped: wrong machine for task' }
      );
    }

    // Burnish task + UHS selected but substrate forbids UHS
    if (isUhs() && row.burnishOk !== true) {
      if (task === 'burnish' || /white|buff|diamond/i.test(String(row.pad || ''))) {
        var lowPad = /white|buff/i.test(String(row.pad || '')) ? row.pad : 'White pad (175 RPM buff)';
        return remap(
          lowPad,
          row.alt || 'White pad',
          '175 RPM swing rotary ONLY',
          'High-speed burnishers are not approved on ' + floor +
            '. Remap: low-speed spray buff / mechanical polish at 175 RPM with ' + lowPad +
            '. ' + (row.directive || ''),
          { title: 'Remapped: low-speed alternative' }
        );
      }
      return hard(
        'High-speed burnish lockout',
        row.directive ||
          ('1500-3000 RPM burnishers are not approved on ' + floor + '.')
      );
    }

    // Lubrication: dry abrasive on wet-deck machines
    var needsWet = !!(row.wetRequired || /spp|melamine|maroon/i.test(String(row.pad || '')));
    if (isWetDeck() && lube === 'dry' && needsWet) {
      return remap(
        row.pad,
        row.alt,
        row.machine,
        'Auto-scrubbers / cylindrical decks must run WET with water or neutral solution when using abrasive/SPP/melamine pads. Dry operation melts wear-layers, damages squeegees, and exhausts unfiltered dust. Remap: flooded or damp recovery with ' +
          row.pad + '. Chemical-free dry prep belongs on a rectangular orbital with dust containment — not a wet-deck scrubber.',
        { title: 'Remapped: wet operation required' }
      );
    }
    if (isUhs() && lube === 'flood') {
      return remap(
        row.pad,
        row.alt,
        row.machine || '175 RPM swing',
        'Flooded solution does not belong on a 1500-3000 RPM burnisher. Remap: dry or damp spray-buff only at UHS, or move wet work to 175 RPM swing / auto-scrubber with ' +
          row.pad + '.',
        { title: 'Remapped: burnish is not a wet scrub' }
      );
    }

    // Build directive with machine-fit + lube + pressure notes
    var notes = [];
    if (row.directive) notes.push(row.directive);
    if (lubeRemapNote) notes.push(lubeRemapNote);
    if (speed === 'manual' && rowWantsManual()) {
      notes.push('Machine fit: manual path matches substrate moisture limits.');
    }
    if (speed === 'extractor' && rowWantsExtractor()) {
      notes.push('Machine fit: hot-water extraction on carpet — keep solution under 120 F on synthetics; place air movers.');
    }
    if (speed === 'planetary' && (task === 'hone' || task === 'restorative' || rowWantsPlanetary())) {
      notes.push('Machine fit: planetary / heavy rotary for diamond cut — follow DIP grit sequence; wet cut and recover slurry.');
    }
    if (speed === 'cylindrical' && /brush|cylindrical|grit|safety|quarry|ceramic/i.test(rowMachineText() + String(row.pad || ''))) {
      notes.push('Machine fit: cylindrical / orbital deck reaches texture and grout better than flat pads.');
    }
    if (speed === 'dual') {
      notes.push('Machine fit: dual-speed — scrub @ 175 RPM, light polish @ ~300 RPM where finish allows (never treat 300 as UHS burnish).');
    }
    if (isWetDeck() && needsWet && lube !== 'dry') {
      notes.push('Run wet-deck WET (water or neutral) — never dry with abrasive/SPP pads.');
    }
    if (lube === 'dry' && /burnish|buff|white|screen/i.test(String(row.pad || '') + task)) {
      notes.push('Lubrication: dry burnish / dry buff / dry screen path — confirm finish rating before UHS.');
    }
    if (lube === 'damp') {
      notes.push('Lubrication: damp spray-buff / light mist.');
    }
    if (lube === 'flood' && row.autoscrubberOk !== false) {
      notes.push('Lubrication: flooded rotary / auto-scrub recovery — squeegee and wet-vac completely.');
    }

    var softPad = /melamine|white|diamond|foam|3000/i.test(String(row.pad || ''));
    if (pressure === 'high' && softPad) {
      notes.push('Head pressure HIGH: reduce downforce on soft foam, White polish, or high-grit diamond pads — excess pressure scratches clarity and loads the pad with finish.');
    } else if (pressure === 'low' && /black|green|blue|grit|carbide/i.test(String(row.pad || ''))) {
      notes.push('Head pressure LOW: abrasive scrub/strip pads may need medium downforce to cut soil — confirm you are not polishing over embedded grit.');
    }

    var level = row.level || (pressure === 'high' && softPad ? 'warn' : null);
    return optimal(row.pad, row.alt, row.machine, notes.join(' '), level);
  }


  /* ---- 15. pad-selector ---- */
  reg('pad-selector', {
    title: 'Floor Pad Selector',
    blurb: 'Substrate × finish × task matrix with three-tier resolution — optimal match, remapped safe alternative, or hard block — plus DIP sequences and wet/pressure levers.',
    primaryLabel: 'Recommended pad',
    d4: {
      basicSection: 'Floor, task & machine',
      advancedSection: 'Lubrication & head pressure'
    },
    fields: [
      { id: 'floor_type', label: 'Floor type', type: 'select', default: 'VCT', options: [
        { value: 'VCT', label: 'VCT' },
        { value: 'LVT', label: 'LVT / sheet vinyl' },
        { value: 'Rubber', label: 'Rubber sport / mat' },
        { value: 'Ceramic tile', label: 'Ceramic / porcelain' },
        { value: 'Quarry tile', label: 'Quarry tile (kitchen)' },
        { value: 'Marble', label: 'Marble / limestone' },
        { value: 'Granite', label: 'Granite' },
        { value: 'Terrazzo', label: 'Terrazzo' },
        { value: 'Sealed concrete', label: 'Sealed concrete' },
        { value: 'Polished concrete', label: 'Polished concrete' },
        { value: 'Hardwood', label: 'Hardwood (finished)' },
        { value: 'Hardwood oil', label: 'Hardwood (oil finish)' },
        { value: 'Painted wood', label: 'Painted wood (gym / stage)' },
        { value: 'Epoxy', label: 'Epoxy / urethane' },
        { value: 'Resinous', label: 'Resinous (MMA / urethane)' },
        { value: 'ESD', label: 'ESD / anti-static' },
        { value: 'Safety floor', label: 'Safety flooring (grit)' },
        { value: 'Carpet', label: 'Carpet (commercial)' }
      ]},
      { id: 'task', label: 'Task', type: 'select', default: 'scrub', options: [
        { value: 'daily', label: 'Daily cleaning' },
        { value: 'scrub', label: 'Scrub / heavy soil' },
        { value: 'grout', label: 'Grout / textured clean' },
        { value: 'strip', label: 'Strip finish' },
        { value: 'burnish', label: 'Burnish / polish' },
        { value: 'hone', label: 'Honing / diamond cut' },
        { value: 'restorative', label: 'Restorative maintenance' },
        { value: 'interim', label: 'Interim cleaning' }
      ]},
      { id: 'machine_speed', label: 'Machine type / RPM', type: 'select', default: 'standard', fullWidth: true, options: [
        { value: 'manual', label: 'Manual (flat-mop / vacuum / tack)' },
        { value: 'standard', label: '175-350 RPM swing rotary' },
        { value: 'dual', label: 'Dual-speed rotary (175 / 300 RPM)' },
        { value: 'autoscrubber', label: 'Walk-behind auto-scrubber (175-350)' },
        { value: 'cylindrical', label: 'Cylindrical / orbital scrubber (175-300)' },
        { value: 'burnisher', label: 'High-speed burnisher (1500-3000 RPM)' },
        { value: 'planetary', label: 'Planetary / heavy rotary (hone & cut)' },
        { value: 'extractor', label: 'Hot-water extractor (carpet)' }
      ]},
      { id: 'finish_status', label: 'Finish status', type: 'select', default: padDefaultFinish('VCT'), fullWidth: true, options: padFinishOptsFor('VCT') },
      {
        id: 'lubrication',
        label: 'Lubrication status',
        type: 'select',
        default: 'damp',
        advanced: true,
        fullWidth: true,
        options: [
          { value: 'dry', label: 'Dry (burnish / dry buff / dry screen)' },
          { value: 'damp', label: 'Damp spray-buff / light mist' },
          { value: 'flood', label: 'Flooded rotary / auto-scrub wet' }
        ]
      },
      {
        id: 'head_pressure',
        label: 'Head pressure / downforce',
        type: 'select',
        default: 'medium',
        advanced: true,
        fullWidth: true,
        options: [
          { value: 'low', label: 'Low (clarity / polish / diamond finish)' },
          { value: 'medium', label: 'Medium (standard scrub)' },
          { value: 'high', label: 'High (aggressive cut — use with caution)' }
        ]
      }
    ],
    calculate: function (inputs) {
      var chart = D.pad_chart || [];
      var floor = inputs.floor_type || 'VCT';
      var task = inputs.task || 'daily';
      var speed = inputs.machine_speed || 'standard';
      var finish = padClampFinish(floor, inputs.finish_status || padDefaultFinish(floor));
      var lube = inputs.lubrication || 'damp';
      var pressure = inputs.head_pressure || 'medium';

      var finishLabel = padFinishLabel(finish, floor);
      var taskLabelMap = {
        daily: 'Daily cleaning',
        scrub: 'Scrub / heavy soil',
        grout: 'Grout / textured clean',
        strip: 'Strip finish',
        burnish: 'Burnish / polish',
        hone: 'Honing / diamond cut',
        restorative: 'Restorative maintenance',
        interim: 'Interim cleaning'
      };
      var taskLabel = taskLabelMap[task] || String(task);
      var pressureLabel = pressure === 'high' ? 'High' : (pressure === 'low' ? 'Low' : 'Medium');

      function findPad(name) {
        var want = String(name || '');
        var base = want.replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim();
        return chart.find(function (p) {
          return p.color === want || p.color === base ||
            (p.color && p.color.indexOf(want.split(/[\/\s(]/)[0]) === 0) ||
            (p.color && p.color.indexOf(base.split(/[\/\s]/)[0]) === 0);
        }) || null;
      }
      function fmtAgg(s) {
        return String(s || '')
          .replace(/\((\d+(?:\.\d+)?)\s*\/\s*(\d+)\)/g, '$1 of $2')
          .replace(/[–—]/g, '-')
          .replace(/×/g, 'x');
      }
      function fmtRpm(s) {
        return String(s || '').replace(/[–—]/g, '-').replace(/×/g, 'x');
      }
      function padKeyFor(colorName) {
        return /melamine/i.test(colorName) ? 'white'
          : /maroon|spp/i.test(colorName) ? 'brown'
          : /diamond/i.test(colorName) ? 'diamond'
          : /microfiber|mop|brush|horsehair|nylon|cylindrical|vacuum|extraction|screen|encapsul/i.test(colorName) ? 'neutral'
          : /tan|burnish|hog|aqua/i.test(colorName) ? 'tan'
          : /white/i.test(colorName) ? 'white'
          : /black/i.test(colorName) ? 'black'
          : /brown/i.test(colorName) ? 'brown'
          : /green/i.test(colorName) ? 'green'
          : /blue/i.test(colorName) ? 'blue'
          : /red/i.test(colorName) ? 'red'
          : 'neutral';
      }
      /** Card / pill label: "Green pad" → "Green"; keep specialty names intact. */
      function padShortLabel(name) {
        var s = String(name || '').split(' / ')[0].replace(/\s*\(.*?\)\s*$/, '').trim();
        if (/^(white|red|blue|green|black|brown|tan|aqua)\s+pads?$/i.test(s)) {
          return s.replace(/\s+pads?$/i, '').replace(/^\w/, function (c) { return c.toUpperCase(); });
        }
        if (/^diamond\s+pad\b/i.test(s)) {
          return 'Diamond';
        }
        return s || String(name || '—');
      }

      var resolved = resolvePadProgram(floor, finish, task, speed, lube, pressure);
      var effectiveLube = resolved.lube || lube;
      var lubeLabel = effectiveLube === 'dry'
        ? (floor === 'Hardwood oil' ? 'Dry / refresher-oil mist' : 'Dry')
        : (effectiveLube === 'flood' ? 'Flooded wet' : 'Damp spray-buff');
      if (resolved.lubeRemapNote && effectiveLube === 'dry' && floor === 'Hardwood oil') {
        lubeLabel = 'Dry / refresher-oil mist';
      }

      if (resolved.tier === 'hard_block') {
        var instead = resolved.insteadOf || null;
        var insteadText = instead && instead.text ? String(instead.text) : '';
        var woodFamilyHb = floor === 'Hardwood' || floor === 'Hardwood oil' || floor === 'Painted wood';
        // Never echo the illegal selected machine in the SAFE MACHINE summary card
        var safeMachineCard = (instead && instead.machine)
          ? String(instead.machine)
          : (woodFamilyHb ? 'Manual (flat-mop / tack)' : 'Prohibited (lockout)');
        var hardAlertText = String(resolved.advisory || resolved.title || '').trim();
        if (insteadText) {
          hardAlertText = hardAlertText
            ? (hardAlertText + (/[.!?]$/.test(hardAlertText) ? ' ' : '. ') + insteadText)
            : insteadText;
        }
        var hardRows = [
          { label: 'Resolution tier', value: 'Hard block — action destroys or voids this substrate' },
          { label: 'Safe machine path', value: safeMachineCard },
          { label: 'Machine selected (prohibited)', value: resolved.speedLabel },
          { label: 'Finish status', value: finishLabel }
        ];
        if (instead && instead.pad) {
          hardRows.splice(2, 0, { label: 'Safe pad path', value: instead.pad });
        }
        return {
          valid: true,
          primary: 'Do not proceed',
          secondary: resolved.title,
          secondaryLabel: 'Hard block',
          // Alert owns the lockout copy — no gray so-what duplex
          soWhat: '',
          conflictReason: hardAlertText || resolved.title,
          remapRemedy: '',
          statusPill: { label: 'Hard block', level: 'bad' },
          alertBanner: {
            level: 'bad',
            title: resolved.title || 'Hard block',
            text: hardAlertText || resolved.title
          },
          alertBanners: [{
            level: 'bad',
            title: resolved.title || 'Hard block',
            text: hardAlertText || resolved.title
          }],
          safetyWarning: '',
          padKey: 'neutral',
          handoffHint: insteadText
            ? 'Next: build a floor program around the safe scrub / daily path'
            : 'Next: pick a legal task for this substrate, then build the floor program',
          metrics: [
            { label: 'Resolution', value: 'Hard block', hero: true, tone: 'bad' },
            { label: 'Floor · task', value: floor + ' · ' + taskLabel },
            { label: 'Safe machine', value: safeMachineCard }
          ],
          bands: [
            { label: 'Floor', value: floor },
            { label: 'Task', value: taskLabel },
            { label: 'Status', value: 'Hard block', target: true }
          ],
          rows: hardRows
        };
      }

      var rec = resolved.pad;
      var match = findPad(rec) || findPad(String(rec || '').split(/[\/\s(]/)[0]);
      var displayPad = String(rec || (match && match.color) || '—');
      var padFunction = padUseCaseForFloor(floor, displayPad, match && match.use_case);
      var isRemap = resolved.tier === 'remap';
      var note = resolved.advisory || '';
      // Split conflict vs remedy so web so-what + alert (and PDF) never print the same paragraph twice
      var remedyAction = '';
      var headlineMessage = note;
      var doIdx = note.search(/Do this instead:/i);
      var remapIdx = note.search(/\bRemap:\s*/i);
      if (doIdx >= 0) {
        headlineMessage = note.slice(0, doIdx).replace(/\s+$/, '');
        remedyAction = note.slice(doIdx).replace(/^Do this instead:\s*/i, '').replace(/^\s+/, '');
      } else if (remapIdx >= 0) {
        headlineMessage = note.slice(0, remapIdx).replace(/\s+$/, '');
        remedyAction = note.slice(remapIdx).replace(/^Remap:\s*/i, '').replace(/^\s+/, '');
      } else if (isRemap) {
        // Single-paragraph advisory → alert owns it; so-what stays empty (no UI/PDF duplex)
        headlineMessage = note || (resolved.title || 'Safe alternative prescribed');
        remedyAction = '';
      }
      // Conflict body only — title lives on the alert / status pill (never prefix into conflictReason)
      var conflictReason = isRemap ? (headlineMessage || '') : '';
      var pillName = padShortLabel(displayPad);
      var altShort = padShortLabel(resolved.alt || '—');
      var rows = [
        { label: 'Resolution tier', value: isRemap ? 'Remapped safe alternative' : 'Optimal match' },
        { label: 'Primary pad', value: pillName },
        { label: 'Alternative / specialty', value: altShort },
        { label: 'Safe machine & max RPM', value: resolved.machine || resolved.speedLabel },
        { label: 'Machine selected', value: resolved.speedLabel },
        { label: 'Finish status', value: finishLabel },
        { label: 'Lubrication', value: lubeLabel },
        { label: 'Head pressure', value: pressureLabel }
      ];
      if (match || padFunction) {
        var machineHint = resolved.machine || resolved.speedLabel || '';
        rows.push(
          { label: 'Pad function', value: padFunction },
          { label: 'Aggressiveness', value: match ? fmtAgg(match.aggressiveness) : '—' },
          {
            label: 'Typical RPM',
            value: match
              ? padClampTypicalRpm(match.typical_rpm, floor, machineHint)
              : '—'
          }
        );
      }
      if (resolved.dip && resolved.dip.maintenance) {
        rows.push({ label: 'DIP maintenance pad', value: resolved.dip.maintenance });
      }
      if (resolved.dip && resolved.dip.steps && resolved.dip.steps.length) {
        // ASCII " -> " delimiter — Helvetica has no →; avoids PDF "?" artifacts between steps
        var dipSeq = resolved.dip.steps.map(function (step) {
          return String(step || '')
            .replace(/[–—]/g, '-')
            .replace(/\s*→\s*/g, ' -> ')
            .replace(/\s+/g, ' ')
            .trim();
        }).join(' -> ');
        rows.push({ label: 'DIP restoration sequence', value: dipSeq });
      }
      if (note && !isRemap) {
        rows.unshift({ label: 'Operational directive', value: note });
      }

      var alertBanners = [];
      if (resolved.lubeRemapNote) {
        alertBanners.push({
          level: 'warn',
          title: 'Lubrication remapped to Dry',
          text: resolved.lubeRemapNote
        });
      }
      if (isRemap) {
        // When split: conflict → soWhat, remedy → alert. When unsplit: alert only.
        if (remedyAction) {
          alertBanners.push({
            level: 'warn',
            title: resolved.title || 'Safe alternative prescribed',
            text: 'Do this instead: ' + remedyAction
          });
        } else {
          alertBanners.push({
            level: 'warn',
            title: resolved.title || 'Safe alternative prescribed',
            text: headlineMessage || note
          });
        }
      } else if (note && (resolved.level === 'warn' || /pressure HIGH|must run WET/i.test(note))) {
        alertBanners.push({ level: 'warn', title: 'Operational directive', text: note });
      }

      var metrics = [
        { label: 'Primary pad', value: pillName, hero: true, accent: true },
        { label: 'Alternative', value: altShort },
        { label: 'Safe machine', value: resolved.machine || resolved.speedLabel }
      ];
      if (resolved.dip && resolved.dip.steps && resolved.dip.steps.length) {
        metrics = [
          { label: 'Primary pad', value: pillName, hero: true, accent: true },
          { label: 'DIP maintenance', value: resolved.dip.maintenance || displayPad },
          { label: 'Safe machine', value: resolved.machine || resolved.speedLabel }
        ];
      }

      var remapSoWhat = '';
      var remapRemedy = '';
      if (isRemap) {
        // UI: conflict under cards; remedy in amber alert. PDF merges both once.
        if (remedyAction) {
          remapSoWhat = headlineMessage || '';
          remapRemedy = 'Do this instead: ' + remedyAction;
        }
      }

      return {
        valid: true,
        primary: pillName,
        secondary: isRemap ? 'Remapped safe alternative' : padFunction,
        secondaryLabel: isRemap ? 'Resolution' : 'Pad function',
        soWhat: isRemap
          ? remapSoWhat
          : (note || ('Use ' + displayPad + ' for ' + taskLabel.toLowerCase() + ' on ' + floor + '.')),
        conflictReason: conflictReason,
        remapRemedy: remapRemedy,
        statusPill: {
          label: isRemap ? 'Remapped' : pillName,
          level: isRemap ? 'warn' : (resolved.level || 'ok')
        },
        alertBanner: alertBanners.length
          ? alertBanners[alertBanners.length - 1]
          : null,
        alertBanners: alertBanners,
        lubeEffective: effectiveLube,
        lubeLabel: lubeLabel,
        lubeRemapNote: resolved.lubeRemapNote || '',
        padKey: padKeyFor(displayPad),
        padColor: displayPad,
        safetyWarning: '',
        handoffHint: isRemap
          ? 'Next: build a floor program around this remapped pad path'
          : undefined,
        metrics: metrics,
        bands: [
          { label: 'Floor', value: floor },
          { label: 'Task', value: taskLabel },
          { label: 'Pad', value: pillName, target: true }
        ],
        rows: rows
      };
    }
  });


  /* ---- 16. ppe-selector ---- */
  reg('ppe-selector', {
    title: 'PPE Selector',
    blurb: 'Eye, hand, body, and respiratory PPE by chemistry class, task, and product form.',
    primaryLabel: 'Eyes / face',
    fields: [
      // Short labels + product form: 3-row stack so closed selects never clip mid-word
      { id: 'chemistry', label: 'Chemistry class', type: 'select', default: 'Quat',
        options: chemOptsDilution(), fullWidth: true },
      { id: 'task', label: 'Cleaning task', type: 'select', default: 'mopping',
        options: ppeTaskKeyOpts(), fullWidth: true },
      { id: 'product_form', label: 'Product form / concentration', type: 'select', default: 'rtu',
        options: [
          { value: 'rtu', label: 'Ready-to-use (RTU / diluted)' },
          { value: 'concentrate', label: 'Concentrate (mixing / pouring)' }
        ], fullWidth: true }
    ],
    calculate: function (inputs) {
      return S.ppeSelect(inputs);
    }
  });

  /* ---- 17. restroom-time-calculator ---- */
  reg('restroom-time-calculator', {
    title: 'Restroom Cleaning Time Calculator',
    blurb: 'ISSA 612 fixture-based minutes per service visit with service level and frequency.',
    primaryLabel: 'Minutes per visit',
    fields: [
      { id: 'toilets', label: 'Toilets', type: 'number', default: 2 },
      { id: 'urinals', label: 'Urinals', type: 'number', default: 2 },
      { id: 'sinks', label: 'Sinks', type: 'number', default: 2 },
      { id: 'mirrors', label: 'Mirrors', type: 'number', default: 2 },
      { id: 'service_level', label: 'Service level', type: 'select', default: 'standard', options: [
        { value: 'light', label: 'Light (0.7x)' },
        { value: 'standard', label: 'Standard (1.0x)' },
        { value: 'deep', label: 'Deep clean (1.5x)' }
      ]},
      { id: 'visits_per_week', label: 'Visits per week', type: 'number', default: 5 },
      { id: 'soap_dispensers', label: 'Soap dispensers', type: 'number', default: 2, advanced: true },
      { id: 'paper_towel', label: 'Paper towel dispensers', type: 'number', default: 2, advanced: true },
      { id: 'floor_sqft', label: 'Floor area (sqft)', type: 'number', default: 100, advanced: true },
      { id: 'trash', label: 'Include trash service', type: 'checkbox', default: true, advanced: true }
    ],
    calculate: function (inputs) {
      // ISSA 612 Cleaning Times — standard commercial restroom rates
      var FALLBACK = {
        Toilet: 2.5, Urinal: 2.0, Sink: 1.5, Mirror: 0.75,
        Soap: 0.5, Paper: 0.5, Trash: 1.5, Floor: 1.5, Setup: 2.5
      };
      var rft = D.restroom_fixture_times || [];
      function rateFor(label) {
        var row;
        if (label === 'Toilet') {
          // Prefer full-service toilet row; do not match "Toilet paper…"
          row = rft.find(function (r) { return /^Toilet \(/.test(r.fixture) || r.fixture === 'Toilet'; });
        } else if (label === 'Setup') {
          row = rft.find(function (r) {
            return r.fixture.indexOf('Restroom overall') === 0 || r.fixture.indexOf('Setup') !== -1;
          });
        } else {
          row = rft.find(function (r) { return r.fixture.indexOf(label) === 0; });
        }
        var n = row ? Number(row.minutes_per_unit) : NaN;
        return (isFinite(n) && n >= 0) ? n : (FALLBACK[label] || 0);
      }
      function minFor(label, count) {
        return rateFor(label) * num(count, 0);
      }
      var total = minFor('Toilet', inputs.toilets) + minFor('Urinal', inputs.urinals) +
        minFor('Sink', inputs.sinks) + minFor('Mirror', inputs.mirrors);
      total += minFor('Soap', inputs.soap_dispensers) + minFor('Paper', inputs.paper_towel);
      var floorMin = (num(inputs.floor_sqft, 0) / 100) * rateFor('Floor');
      total += floorMin;
      // Trash empty + reline is one restroom task (ISSA 612), not per-stall
      if (inputs.trash) total += rateFor('Trash');
      // Cart / wet-floor sign / restock verify — modest fixed visit overhead
      total += rateFor('Setup');
      if (total <= 0) return { valid: false, errors: ['Enter at least one fixture count.'] };
      // Deep clean / high detail = 1.5x per ISSA high-detail column
      var levelMult = { light: 0.7, standard: 1.0, deep: 1.5 }[inputs.service_level] || 1;
      total *= levelMult;
      var floorScaled = floorMin * levelMult;
      var vpw = num(inputs.visits_per_week, 5);
      var weeklyMin = total * vpw;
      // Industry calendar: 52 weeks / 12 months = 4.3333... (not 4.33)
      var WEEKS_PER_MONTH = 52 / 12;
      var monthlyMin = weeklyMin * WEEKS_PER_MONTH;
      var monthlyMinRounded = Math.round(monthlyMin);
      var weeklyHr = weeklyMin / 60;
      var monthlyHr = monthlyMinRounded / 60;
      var levelLabels = {
        light: 'Light (0.7x)',
        standard: 'Standard (1.0x)',
        deep: 'Deep clean (1.5x)'
      };
      var levelLabel = levelLabels[inputs.service_level] ||
        ('Standard (' + Number(levelMult).toFixed(1) + 'x)');
      return {
        valid: true,
        primary: total.toFixed(1) + ' min',
        secondary: weeklyHr.toFixed(2) + ' hr',
        secondaryLabel: 'Weekly time',
        metrics: [
          { label: 'Minutes per visit', value: total.toFixed(1) + ' min', accent: true, hero: true },
          { label: 'Weekly time', value: weeklyHr.toFixed(2) + ' hr' },
          { label: 'Monthly labor', value: monthlyHr.toFixed(1) + ' hr' }
        ],
        soWhat: 'Plan **' + Math.round(total) + ' minutes** per restroom visit (**' +
          weeklyHr.toFixed(2) + ' hr/week** at ' + vpw + ' visits), fold this into building FTE, don’t leave it as a buffer.',
        rows: [
          { label: 'Service level', value: levelLabel },
          { label: 'Minutes per visit', value: total.toFixed(1) + ' min' },
          { label: 'Hours per visit', value: (total / 60).toFixed(2) + ' hr' },
          { label: 'Weekly (' + vpw + ' visits)', value: weeklyMin.toFixed(1) + ' min (' + weeklyHr.toFixed(2) + ' hr)' },
          { label: 'Monthly (x 4.3333 wk)', value: monthlyMinRounded + ' min (' + monthlyHr.toFixed(1) + ' hr)' },
          { label: 'Floor time', value: floorScaled.toFixed(1) + ' min' }
        ]
      };
    }
  });

  /* ---- 18. issa-447-lookup ---- */
  reg('issa-447-lookup', {
    title: 'Production Rate Lookup',
    blurb: 'APPA Level 2 guide rates (within ISSA 612 ranges) by task — not a licensed ISSA extract. Adjust for congestion, then validate with a time study.',
    primaryLabel: 'Adjusted rate',
    fields: [
      // Short labels + full-width stack so closed selects never clip mid-word
      { id: 'task_type', label: 'Task type', type: 'select', default: 'Autoscrubber — 26-inch (large open areas)',
        options: taskTypeOpts().length ? taskTypeOpts() : [
          { value: 'Autoscrubber — 26-inch (large open areas)', label: 'Autoscrubber 26-inch' }
        ], fullWidth: true },
      { id: 'congestion', label: 'Facility layout / congestion', type: 'select', default: 'open',
        options: [
          { value: 'open', label: 'Open space (1.0x)' },
          { value: 'moderate', label: 'Moderate office (0.8x)' },
          { value: 'tight', label: 'Tight / congested (0.6x)' }
        ], fullWidth: true },
      { id: 'sqft', label: 'Sqft to clean (optional)', type: 'number', default: '', placeholder: 'e.g. 10000',
        fullWidth: true }
    ],
    calculate: function (inputs) {
      var rates = D.production_rates || [];
      var row = rates.find(function (r) { return r.task_type === inputs.task_type; });
      if (!row || !row.sq_ft_per_hour) return { valid: false, errors: ['Select a task with a sqft/hr rate.'] };
      var congKey = String(inputs.congestion || 'open');
      var congMult = { open: 1.0, moderate: 0.8, tight: 0.6 }[congKey] || 1.0;
      var congLabel = {
        open: 'Open space (1.0x)',
        moderate: 'Moderate office (0.8x)',
        tight: 'Tight / congested (0.6x)'
      }[congKey] || 'Open space (1.0x)';
      var congCard = {
        open: '1.00x (Open Space / Unobstructed)',
        moderate: '0.80x (Moderate Office)',
        tight: '0.60x (Tight / Congested)'
      }[congKey] || '1.00x (Open Space / Unobstructed)';
      var base = Number(row.sq_ft_per_hour);
      var adjusted = Math.round(base * congMult);
      var sqft = num(inputs.sqft, 0);
      var hours = sqft > 0 ? sqft / adjusted : null;
      var rangeLo = null;
      var rangeHi = null;
      var rangeMatch = String(row.notes || '').match(/range\s+([\d,]+)\s*[-–—]\s*([\d,]+)/i);
      if (rangeMatch) {
        rangeLo = Number(String(rangeMatch[1]).replace(/,/g, ''));
        rangeHi = Number(String(rangeMatch[2]).replace(/,/g, ''));
      }
      var rangeTxt = (isFinite(rangeLo) && isFinite(rangeHi))
        ? ('ISSA range: ' + rangeLo.toLocaleString() + '-' + rangeHi.toLocaleString())
        : 'ISSA 612 band (validate on site)';
      var card3Label = hours != null ? 'Estimated hours' : 'Adjusted rate';
      var card3Value = hours != null
        ? (hours.toFixed(2) + ' hr')
        : (adjusted.toLocaleString() + ' sqft/hr');
      var card3Sub = hours != null
        ? (sqft.toLocaleString() + ' sqft @ ' + adjusted.toLocaleString() + ' sqft/hr')
        : rangeTxt;
      var rows = [
        { label: 'Task', value: row.task_type },
        { label: 'Base rate (APPA L2)', value: base.toLocaleString() + ' sqft/hr' },
        { label: 'Congestion', value: congLabel },
        { label: 'Adjusted rate', value: adjusted.toLocaleString() + ' sqft/hr' }
      ];
      if (hours != null) {
        rows.push({ label: 'Sqft to clean', value: sqft.toLocaleString() + ' sqft' });
        rows.push({ label: 'Estimated hours', value: hours.toFixed(2) + ' hr' });
      }
      rows.push({ label: 'Notes', value: row.notes || '-' });
      rows.push({ label: 'Source', value: row.source || 'APPA Level 2 (within ISSA 612 range)' });
      return {
        valid: true,
        primary: adjusted.toLocaleString() + ' sqft/hr',
        secondary: hours != null ? hours.toFixed(2) + ' hr' : null,
        secondaryLabel: hours != null ? 'Estimated hours' : null,
        metrics: [
          { label: 'Base rate (APPA L2)', value: base.toLocaleString() + ' sqft/hr', accent: true },
          { label: 'Congestion impact', value: congCard },
          { label: card3Label, value: card3Value, sub: card3Sub, hero: true, accent: true }
        ],
        mixNote: 'APPA Level 2 guide rates within ISSA 612 commercial production ranges. Congestion factors (1.0 / 0.8 / 0.6) are planning multipliers — confirm with a building time study before bidding.',
        soWhat: hours != null
          ? ('Plan **' + hours.toFixed(2) + ' hr** for ' + sqft.toLocaleString() + ' sqft at the congestion-adjusted rate, then roll into building FTE.')
          : ('Use **' + adjusted.toLocaleString() + ' sqft/hr** as the congestion-adjusted input to building-level FTE, not as the whole bid.'),
        rows: rows
      };
    }
  });

  /* ---- 19–39: Manage, Profit, Compliance tools ---- */

  reg('appa-inspection-report', {
    title: 'APPA Inspection Report',
    blurb: 'Room scores vs contracted APPA level with overall grade.',
    primaryLabel: 'Overall score',
    fields: [
      { id: 'client_name', label: 'Client / facility name', type: 'text', default: '', placeholder: 'Client Facility' },
      { id: 'appa_level', label: 'Contracted APPA level', type: 'select', default: '2', options: [
        { value: '1', label: 'Level 1' }, { value: '2', label: 'Level 2' }, { value: '3', label: 'Level 3' },
        { value: '4', label: 'Level 4' }, { value: '5', label: 'Level 5' }
      ]},
      { id: 'score_lobby', label: 'Lobby score (1–5)', type: 'number', default: 2, min: 1, max: 5 },
      { id: 'score_office', label: 'Office areas score', type: 'number', default: 2, min: 1, max: 5 },
      { id: 'score_restroom', label: 'Restrooms score', type: 'number', default: 2, min: 1, max: 5 },
      { id: 'score_break', label: 'Break room score', type: 'number', default: 2, min: 1, max: 5 }
    ],
    calculate: function (inputs) {
      var scores = [inputs.score_lobby, inputs.score_office, inputs.score_restroom, inputs.score_break].map(function (s) { return num(s, 2); });
      var avg = scores.reduce(function (a, b) { return a + b; }, 0) / scores.length;
      var contracted = num(inputs.appa_level, 2);
      var rawName = String(inputs.client_name || '').trim();
      // Match PDF header sanitize — never leave "Client Facility" placeholder in METRIC rows
      var facility = (!rawName || /^client\s+facility$/i.test(rawName))
        ? 'Commercial Facility'
        : rawName;
      var anyFive = scores.some(function (s) { return s >= 5; });
      var critical = anyFive || avg > 3.0;
      var belowContract = avg > contracted;
      var variance = avg - contracted; // positive = dirtier than SLA (deficient on inverted APPA scale)
      var flag;
      var pillLevel;
      var compliance;
      var guidance;
      if (critical) {
        flag = 'Critical Deficiency';
        pillLevel = 'bad';
        compliance = belowContract ? 'Below Contract Standard' : 'Action Required';
        guidance = 'Critical APPA deficiency — rebuild hours and re-inspect problem zones before the next walkthrough';
      } else if (belowContract) {
        flag = 'Below Contract';
        pillLevel = 'bad';
        compliance = 'Below Contract Standard';
        guidance = 'Below contracted level, rebuild hours before the next walkthrough';
      } else if (avg <= 2.2) {
        flag = 'High Standard';
        pillLevel = 'ok';
        compliance = 'Meets Standard';
        guidance = 'Scores meet the contracted level, lock FTE to that appearance';
      } else {
        // Meets numeric SLA but appearance is Casual Inattention / dingy (2.3–3.0)
        flag = 'At Risk / Inattention';
        pillLevel = 'warn';
        compliance = 'Meets Reduced Scope (Review Deficiencies)';
        guidance = 'Meets the contracted number, but Level 3 zones need a deficiency plan before they drift to 4/5';
      }
      var varianceLabel = Math.abs(variance) < 0.05
        ? 'On Target'
        : (variance > 0
          ? ('+' + variance.toFixed(1) + ' (Deficient)')
          : (variance.toFixed(1) + ' (Exceeding)'));
      var varianceTone = Math.abs(variance) < 0.05 ? 'ok' : (variance > 0 ? 'bad' : 'ok');
      return {
        valid: true,
        primary: avg.toFixed(1),
        flag: flag,
        statusPill: {
          level: pillLevel,
          label: flag
        },
        handoffHint: guidance,
        soWhat: critical || belowContract
          ? 'Treat Level 4/5 zones as scope evidence, not a soft average you can ignore.'
          : 'Use gaps as a scope conversation, not a surprise invoice fight.',
        metrics: [
          { label: 'Inspection score', value: 'Level ' + avg.toFixed(1), accent: true, hero: true },
          { label: 'Contract SLA', value: 'Level ' + contracted },
          { label: 'SLA variance', value: varianceLabel, tone: varianceTone }
        ],
        mixNote: 'APPA Custodial Operational Development scale (1 = Orderly Spotlessness, 5 = Unkempt Neglect). Lower is cleaner. Any Level 5 zone or average above 3.0 is Critical Deficiency.',
        rows: [
          { label: 'Facility', value: facility },
          { label: 'Lobby', value: 'Level ' + scores[0] },
          { label: 'Office', value: 'Level ' + scores[1] },
          { label: 'Restrooms', value: 'Level ' + scores[2] },
          { label: 'Break room', value: 'Level ' + scores[3] },
          { label: 'Contracted', value: 'Level ' + contracted },
          { label: 'Compliance', value: compliance }
        ],
        narrative: 'Inspection for ' + facility + '. Average Level ' + avg.toFixed(1) +
          ' vs contracted Level ' + contracted + '. Status: ' + flag + '.'
      };
    }
  });

  reg('client-onboarding-checklist', {
    title: 'Client Onboarding Checklist',
    kind: 'generator',
    blurb: 'Generate onboarding tasks for a new commercial account.',
    primaryLabel: 'Checklist items',
    actionLabel: 'Generate',
    fields: [
      { id: 'client_name', label: 'Client name', type: 'text', default: '' },
      { id: 'account_type', label: 'Account type', type: 'select', default: 'office', options: benchmarkVerticalOpts() },
      { id: 'sqft', label: 'Square footage', type: 'number', default: 50000 },
      { id: 'start_date', label: 'First service date', type: 'text', default: '' },
      { id: 'medical_site', label: 'Medical / HIPAA area', type: 'checkbox', default: false, advanced: true }
    ],
    calculate: function (inputs) {
      var steps = [
        { phase: 'Contract', task: 'Execute signed agreement and attach scope of work' },
        { phase: 'Insurance', task: 'Collect COI meeting GL/auto/WC minimums' },
        { phase: 'Walkthrough', task: 'Site walkthrough, lock floor plan and key access' },
        { phase: 'Supplies', task: 'Stock supplies; label secondary containers' },
        { phase: 'Crew', task: 'Assign crew lead; publish QA inspection cadence' },
        { phase: 'QA', task: 'First-week APPA baseline walkthrough' }
      ];
      var acctKey = String(inputs.account_type || 'office').toLowerCase();
      // Industrial / plant: LOTO + HazCom before Day 1
      if (acctKey === 'industrial') {
        steps.push({
          phase: 'LOTO',
          task: 'LOTO awareness briefing for plant areas (OSHA 1910.147)'
        });
        steps.push({
          phase: 'HazCom',
          task: 'Place site SDS binder; complete HazCom orientation (OSHA 1910.1200)'
        });
      }
      if (inputs.medical_site) {
        steps.push({ phase: 'Compliance', task: 'BBP training for clinical-area staff (OSHA 1910.1030)' });
      }
      var acctLabel = (S.SEED_BENCHMARKS[acctKey] && S.SEED_BENCHMARKS[acctKey].label) || acctKey;
      var sq = num(inputs.sqft, 0);
      var sqLabel = sq ? Number(sq).toLocaleString() + ' sq ft' : 'n/a sq ft';
      var startRaw = String(inputs.start_date || '').trim();
      var start = startRaw || 'Pending';
      var isMedical = !!inputs.medical_site;
      return {
        valid: true,
        primary: steps.length + ' Action Items',
        // 3-card exec summary (web + PDF) — never solitary PRIMARY RESULT + dense Detail string
        metrics: [
          {
            label: 'Onboarding protocol',
            value: steps.length + ' Action Items',
            accent: true,
            hero: true
          },
          {
            label: 'Facility profile',
            value: acctLabel,
            sub: sqLabel
          },
          {
            label: 'First service date',
            value: start,
            sub: isMedical ? 'Includes Medical / HIPAA' : 'Standard Commercial'
          }
        ],
        soWhat: 'Close every open item before go-live, especially keys, access, and scope.',
        statusPill: { label: 'Onboarding ready', level: 'ok' },
        rows: steps.map(function (s, i) {
          return {
            // ASCII "Item N: Phase" — never middot/pipe (PDF Helvetica turns · into |)
            label: 'Item ' + (i + 1) + ': ' + s.phase,
            value: s.task,
            ok: true
          };
        }),
        narrative: 'Work top to bottom before first service. Not legal advice, adapt to your playbook and carrier requirements.'
      };
    }
  });

  reg('account-profitability-auditor', {
    title: 'Account Profitability Auditor',
    blurb: 'Split COGS gross margin from net operating margin (overhead + risk below the line).',
    primaryLabel: 'Gross margin',
    fields: [
      { id: 'monthly_revenue', label: 'Monthly revenue ($)', type: 'number', default: 4200 },
      { id: 'clocked_hours', label: 'Clocked hours', type: 'number', default: 48 },
      { id: 'loaded_wage', label: 'Loaded wage ($/hr)', type: 'number', default: 24 },
      { id: 'supply_pct', label: 'Supplies (% of labor)', type: 'number', default: 8 },
      { id: 'equip_depreciation', label: 'Equipment depreciation ($/mo)', type: 'number', default: 25, advanced: true },
      { id: 'overhead_alloc', label: 'Overhead allocation ($)', type: 'number', default: 504, advanced: true },
      { id: 'risk_premium', label: 'Risk premium ($)', type: 'number', default: 74, advanced: true },
      { id: 'margin_threshold', label: 'Net margin threshold (%)', type: 'number', default: 20, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.accountProfitability(inputs);
      if (r && r.valid) {
        var threshNum = (r.threshold != null && !isNaN(r.threshold))
          ? Number(r.threshold)
          : num(inputs.margin_threshold, 20);
        var threshLabel = threshNum.toFixed(1) + '%';
        var netLabel = r.secondary || fmtPct(r.netMarginPct);
        var profitLabel = fmt$(r.netProfit);
        r.metrics = [
          {
            label: 'Gross margin',
            value: r.primary,
            sub: fmt$(r.grossProfit) + ' profit',
            accent: true,
            hero: true
          },
          {
            label: 'Net profit (monthly)',
            value: profitLabel,
            sub: 'Bottom-line cash flow'
          },
          {
            label: 'Net operating margin',
            value: netLabel,
            sub: 'Threshold: ' + threshLabel
          }
        ];
        if (r.flag === 'Healthy') {
          r.soWhat = 'Strong profitability: **' + netLabel + '** net operating margin exceeds the **' +
            threshLabel + '** hurdle rate (**' + profitLabel + '**/mo profit). Guard against unbilled scope creep and unlogged labor hours.';
        } else {
          r.soWhat = 'Margin compression alert: **' + netLabel + '** net margin fails the **' +
            threshLabel + '** hurdle rate. Re-audit clocked hours or initiate contract rate adjustment.';
        }
      }
      return r;
    }
  });

  reg('day-porter-roi', {
    title: 'Day Porter vs Night Crew ROI', blurb: 'Compare day porter vs night crew monthly cost.', primaryLabel: 'Day porter monthly',
    fields: [
      { id: 'dp_wage', label: 'Day porter wage ($/hr)', type: 'number', default: 19 },
      { id: 'dp_shift', label: 'Day porter hours/day', type: 'number', default: 8 },
      { id: 'dp_porters', label: 'Day porters on shift', type: 'number', default: 1 },
      { id: 'nc_wage', label: 'Night crew wage ($/hr)', type: 'number', default: 17.27 },
      { id: 'nc_hours', label: 'Night crew hours/day', type: 'number', default: 6 },
      { id: 'burden_pct', label: 'Payroll burden (%)', type: 'number', default: 22 },
      { id: 'nc_shift_diff', label: 'Night shift differential (%)', type: 'number', default: 0, advanced: true },
      { id: 'days_per_month', label: 'Days per month', type: 'number', default: 22, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.dayPorterRoi(inputs);
      if (!r.valid) return r;
      /* delta = day_porter_monthly - night_crew_monthly; negative means day is cheaper */
      var dpHrsDay = num(inputs.dp_shift, 8) * num(inputs.dp_porters, 1);
      var ncHrsDay = num(inputs.nc_hours, 6);
      var ncDiff = num(inputs.nc_shift_diff, 0);
      var absDelta = Math.abs(r.delta);
      var maxMo = Math.max(r.dp_monthly, r.nc_monthly) || 1;
      var savePct = ((absDelta / maxMo) * 100).toFixed(1);
      var nightSaves = r.delta > 0;
      var recLine = nightSaves
        ? ('Night crew delivers a ' + fmt$(absDelta) +
          '/mo operational savings. Retain day porter only if immediate daytime spill response and continuous executive suite policing are contractual SLAs.')
        : ('Day porter delivers a ' + fmt$(absDelta) +
          '/mo operational savings. Prefer night crew only if unoccupied deep-clean production outweighs daytime response SLAs.');
      r.soWhat = '**' + (nightSaves ? 'Night crew' : 'Day porter') +
        '** is the lower-cost model here (**' +
        fmt$(r.dp_monthly) + '/mo** day-porter vs **' + fmt$(r.nc_monthly) +
        '/mo** night), pick the model that still meets the service promise you sold.';
      r.metrics = [
        {
          label: 'Day porter monthly',
          value: fmt$(r.dp_monthly),
          sub: dpHrsDay.toFixed(1) + ' hrs/day loaded',
          accent: true,
          hero: true
        },
        {
          label: 'Night crew monthly',
          value: fmt$(r.nc_monthly),
          sub: ncHrsDay.toFixed(1) + ' hrs/day loaded' +
            (ncDiff ? (' (+' + ncDiff + '% diff)') : '')
        },
        {
          label: 'Monthly delta',
          value: fmt$(absDelta),
          sub: (nightSaves ? 'Night model saves ' : 'Day model saves ') + savePct + '%',
          tone: 'ok'
        }
      ];
      // Full sentence only — web template already prefixes "Recommended:" (never stutter)
      return Object.assign({}, r, { recommended: recLine });
    }
  });

  reg('tco-calculator', {
    title: '5-Year TCO Calculator', blurb: 'Equipment total cost of ownership over 5 years.', primaryLabel: 'Net 5-yr TCO',
    fields: [
      { id: 'purchase_price', label: 'Purchase price ($)', type: 'number', default: 12000 },
      { id: 'equipment_type', label: 'Equipment type', type: 'select', default: 'walk_behind_scrubber', options: [
        { value: 'walk_behind_scrubber', label: 'Walk-behind scrubber' }, { value: 'ride_on_scrubber', label: 'Ride-on scrubber' },
        { value: 'burnisher', label: 'Burnisher' }, { value: 'backpack_vacuum', label: 'Backpack vacuum' }
      ]},
      { id: 'annual_hours', label: 'Annual operating hours', type: 'number', default: 800 },
      { id: 'wage_rate', label: 'Operator wage ($/hr)', type: 'number', default: 24 },
      { id: 'acquisition_method', label: 'Acquisition', type: 'select', default: 'financed', options: [
        { value: 'cash', label: 'Cash' }, { value: 'financed', label: 'Financed' }, { value: 'lease', label: 'Lease' }
      ], advanced: true },
      { id: 'interest_rate', label: 'Finance interest rate (%)', type: 'number', default: 7.5, advanced: true,
        visibleWhen: { id: 'acquisition_method', eq: 'financed' } },
      { id: 'loan_term_months', label: 'Loan term (months)', type: 'number', default: 60, advanced: true,
        visibleWhen: { id: 'acquisition_method', eq: 'financed' } },
      { id: 'monthly_lease', label: 'Monthly lease ($)', type: 'number', default: 0, advanced: true,
        visibleWhen: { id: 'acquisition_method', eq: 'lease' } }
    ],
    calculate: function (inputs) {
      var r = S.tcoCalc(inputs);
      if (r.valid && !r.primary) r.primary = fmt$Dollars(r.net_tco);
      if (r.valid) {
        var price = num(inputs.purchase_price, r.purchase_price || 0);
        var hours = num(inputs.annual_hours, r.annual_hours || 0);
        var runHrs = Math.round(hours * 5);
        var capexShare = (r.net_tco > 0 && price > 0)
          ? ((price / r.net_tco) * 100).toFixed(1) + '% of 5-yr lifecycle'
          : 'Capex share n/a';
        r.soWhat = 'Over 5 years this machine runs about **' + fmt$Dollars(r.net_tco) +
          '** all-in, purchase price is only the tip; compare OpEx before you buy.';
        r.metrics = [
          {
            label: 'Net 5-yr TCO',
            value: fmt$Dollars(r.net_tco),
            sub: fmt$Dollars(r.net_tco / 5) + ' / year all-in',
            accent: true,
            hero: true
          },
          {
            label: 'Cost per operating hr',
            value: fmt$(r.cost_per_hour) + ' / hr',
            sub: runHrs.toLocaleString('en-US') + ' total run hours'
          },
          {
            label: 'Purchase price (Capex)',
            value: fmt$Dollars(price),
            sub: capexShare
          }
        ];
      }
      return r;
    }
  });

  reg('equipment-roi-calculator', {
    title: 'Equipment ROI Calculator', blurb: 'Labor savings, payback, and 5-year ROI.', primaryLabel: 'Payback',
    fields: [
      { id: 'purchase_price', label: 'Purchase price ($)', type: 'number', default: 12000 },
      { id: 'equipment_type', label: 'Equipment type', type: 'select', default: 'walk_behind_scrubber', options: [
        { value: 'walk_behind_scrubber', label: 'Walk-behind scrubber' }, { value: 'ride_on_scrubber', label: 'Ride-on' },
        { value: 'autonomous_scrubber', label: 'Autonomous scrubber' }, { value: 'burnisher', label: 'Burnisher' }
      ]},
      { id: 'sqft_per_day', label: 'Sqft cleaned per day', type: 'number', default: 20000 },
      { id: 'loaded_labor_rate', label: 'Loaded labor rate ($/hr)', type: 'number', default: 24 },
      { id: 'working_days_per_year', label: 'Working days per year', type: 'number', default: 260, advanced: true },
      { id: 'annual_chemical_spend', label: 'Annual chemical spend ($)', type: 'number', default: 0, advanced: true },
      { id: 'chemical_savings_pct', label: 'Chemical savings (%)', type: 'number', default: 0, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.equipmentRoi(inputs);
      if (r && r.valid) {
        var payback = r.primary || (r.payback_years != null ? String(r.payback_years) : '—');
        var pbYrs = Number(r.payback_years);
        var monthsSub = isFinite(pbYrs)
          ? (pbYrs * 12).toFixed(1) + ' months to break-even'
          : 'Break-even n/a';
        var disc = (r.discount_rate != null ? Number(r.discount_rate) : 8);
        var npvSub = 'NPV: ' + fmt$Dollars(r.npv) + ' @ ' + disc + '%';
        r.soWhat = 'Payback lands around **' + payback +
          '** at these hours, iron only pays when OpEx can fund the machine.';
        // Unified 3-up at top — never stack primary/secondary + bands
        r.bands = [];
        r.metrics = [
          {
            label: 'Payback period',
            value: payback,
            sub: monthsSub,
            accent: true,
            hero: true
          },
          {
            label: 'Annual net benefit',
            value: fmt$(r.annual_net),
            sub: 'Labor + chem less maint'
          },
          {
            label: '5-year simple ROI',
            value: fmtPct(r.roi_5yr),
            sub: npvSub
          }
        ];
      }
      return r;
    }
  });

  reg('job-costing-calculator', {
    title: 'Job Costing Calculator', blurb: 'Direct costs plus margin to bid price.', primaryLabel: 'Bid price',
    fields: [
      { id: 'total_labor_hrs', label: 'Total labor hours', type: 'number', default: 8 },
      { id: 'loaded_labor_rate', label: 'Loaded labor rate ($/hr)', type: 'number', default: 24 },
      { id: 'overhead_pct', label: 'Overhead (%)', type: 'number', default: 20 },
      { id: 'target_margin', label: 'Target margin (%)', type: 'number', default: 22 },
      { id: 'supplies_cost', label: 'Supplies cost ($)', type: 'number', default: 0, advanced: true },
      { id: 'travel_cost', label: 'Travel cost ($)', type: 'number', default: 0, advanced: true },
      { id: 'equipment_cost', label: 'Equipment cost ($)', type: 'number', default: 0, advanced: true },
      { id: 'subcontractor_cost', label: 'Subcontractor cost ($)', type: 'number', default: 0, advanced: true },
      { id: 'sqft_total', label: 'Total sqft', type: 'number', default: 0, min: 0, advanced: true, info: 'Rate/sqft shows when total sqft is greater than 0.' }
    ],
    calculate: function (inputs) {
      var r = S.jobCosting(inputs);
      if (r && r.valid) {
        var bidNum = num(r.bid_price, 0);
        var hrs = num(r.labor_hrs, num(inputs.total_labor_hrs, 8));
        var margin = num(r.target_margin, num(inputs.target_margin, 22));
        var gross = num(r.gross_profit, 0);
        var rateSqft = r.rate_per_sqft;
        var effHr = hrs > 0 ? bidNum / hrs : null;
        var bid = r.primary || (bidNum ? fmt$(bidNum) : null);
        r.soWhat = 'Cover labor, OH, and margin with a floor bid of **' + (bid || '–') +
          '**, missing overhead is how winning accounts lose money.';
        r.metrics = [
          {
            label: 'Recommended bid floor',
            value: fmt$(bidNum),
            sub: 'Direct costs + OH + margin',
            accent: true,
            hero: true
          },
          {
            label: 'Gross profit target',
            value: fmt$(gross),
            sub: margin.toFixed(1) + '% contract margin',
            tone: 'ok'
          },
          {
            label: 'Effective bill rate',
            value: effHr != null ? (fmt$(effHr) + ' / hr') : '–',
            sub: rateSqft != null
              ? (fmt$(rateSqft) + '/sqft')
              : (hrs + ' total hours')
          }
        ];
      }
      return r;
    }
  });

  reg('churn-cost-calculator', {
    title: 'Churn Cost Calculator', blurb: 'True cost to lose and replace an account.', primaryLabel: 'Cost per churn',
    fields: [
      { id: 'monthly_contract_value', label: 'Monthly contract value ($)', type: 'number', default: 1850 },
      { id: 'gross_margin_pct', label: 'Gross margin (%)', type: 'number', default: 25 },
      { id: 'months_to_replace', label: 'Months to replace revenue', type: 'number', default: 2 },
      { id: 'marketing_spend_monthly', label: 'Marketing spend ($/mo)', type: 'number', default: 0, advanced: true },
      { id: 'new_clients_per_month', label: 'New clients per month', type: 'number', default: 0, advanced: true },
      { id: 'ramp_months', label: 'Ramp-up months', type: 'number', default: 2, advanced: true },
      { id: 'mgmt_hours', label: 'Management hours per churn', type: 'number', default: 6, advanced: true },
      { id: 'expected_annual_churns', label: 'Expected annual churns', type: 'number', default: 3, advanced: true }
    ],
    calculate: function (inputs) {
      var r = S.churnCost(inputs);
      if (r && r.valid) {
        var per = num(r.cost_per_churn != null ? r.cost_per_churn : r.total, 0);
        var annual = num(r.annual, 0);
        var retain = num(r.retention_budget, per * 0.5);
        var churns = num(r.annual_churns, num(inputs.expected_annual_churns, 3));
        var cost = r.primary || fmt$(per);
        r.soWhat = 'Losing this **' + fmt$(num(inputs.monthly_contract_value, 1850)) +
          '/mo** account costs about **' + cost + '** to replace, fund retention if it is cheaper than churn.';
        // Unified 3-up at top — never stack primary/secondary + bands
        r.secondary = '';
        r.secondaryLabel = '';
        r.bands = [];
        r.metrics = [
          {
            label: 'Cost per churn',
            value: fmt$(per),
            sub: 'Margin + CAC + ramp + mgmt',
            accent: true,
            hero: true
          },
          {
            label: 'Annual churn cost',
            value: fmt$(annual),
            sub: 'Based on ' + churns + ' churns/yr'
          },
          {
            label: 'Max retention budget',
            value: fmt$(retain),
            sub: '50% replacement ceiling',
            tone: 'ok'
          }
        ];
      }
      return r;
    }
  });

  reg('ebitda-estimator', {
    title: 'EBITDA Estimator', blurb: 'Adjusted EBITDA and enterprise value range.', primaryLabel: 'Mid EV estimate',
    fields: [
      { id: 'annual_revenue', label: 'Annual revenue ($)', type: 'number', default: 1500000 },
      { id: 'direct_labor_cost', label: 'Direct labor ($)', type: 'number', default: 780000 },
      { id: 'supplies_subcontractors', label: 'Supplies & subs ($)', type: 'number', default: 120000 },
      { id: 'total_overhead', label: 'Total overhead ($)', type: 'number', default: 210000 },
      { id: 'owner_addbacks', label: 'Owner add-backs ($)', type: 'number', default: 0, advanced: true, fullWidth: true,
        hint: 'Above-market owner pay, personal vehicle, one-time legal, and other non-recurring add-backs for Adjusted EBITDA / SDE.' }
    ],
    calculate: function (inputs) {
      var r = S.ebitdaCalc(inputs);
      if (r && r.valid) {
        var fmtK = S.fmt$K || fmt$Dollars;
        var fmtCM = S.fmt$CompactM || fmtK;
        var lowM = Number(r.mult_low);
        var midM = Number(r.mult_mid);
        var highM = Number(r.mult_high);
        var multLabel = function (m) {
          return (Math.round(Number(m) * 100) / 100).toFixed(1) + 'x';
        };
        r.soWhat = 'Use the **' + fmtCM(r.ev_low) + ' – ' + fmtCM(r.ev_high) +
          '** range to prioritize margin cleanup before a sale conversation.';
        r.metrics = [
          {
            label: 'Adjusted EBITDA',
            value: fmt$Dollars(r.adjusted_ebitda),
            sub: (Number(r.ebitda_margin) || 0).toFixed(1) + '% normalized margin',
            accent: true
          },
          {
            label: 'Mid EV estimate',
            value: fmtK(r.ev_mid),
            sub: 'Based on ' + multLabel(midM) + ' median multiple',
            accent: true,
            hero: true
          },
          {
            label: 'Valuation bracket',
            value: fmtCM(r.ev_low) + ' – ' + fmtCM(r.ev_high),
            sub: multLabel(lowM) + ' (Low) to ' + multLabel(highM) + ' (High)'
          }
        ];
      }
      return r;
    }
  });

  reg('robot-roi-matcher', {
    title: 'Robot ROI Matcher', blurb: 'Autonomous scrubber payback vs manual labor.', primaryLabel: 'Payback',
    robots: ROBOTS,
    fields: [
      { id: 'robot_model', label: 'Robot model', type: 'select', default: 'Tennant T7AMR', fullWidth: true, options: ROBOTS.map(function (r) {
        return { value: r.name, label: r.name + ' (~' + fmt$(r.price) + ')' };
      }) },
      { id: 'robot_cost', label: 'Robot purchase price ($)', type: 'number', default: 82500 },
      { id: 'cleanable_sqft', label: 'Cleanable sqft per shift', type: 'number', default: 30000 },
      { id: 'loaded_labor_rate', label: 'Loaded labor rate ($/hr)', type: 'number', default: 24 },
      { id: 'shifts_per_week', label: 'Shifts per week', type: 'number', default: 5, advanced: true },
      { id: 'manual_rate', label: 'Manual scrub rate (sqft/hr)', type: 'number', default: 2500, advanced: true },
      { id: 'utilization_pct', label: 'Effective utilization (%)', type: 'number', default: 100, advanced: true,
        hint: 'Share of scheduled shifts the robot actually runs (downtime, charging, blocked floors).' },
      { id: 'weeks_per_year', label: 'Working weeks per year', type: 'number', default: 52, advanced: true }
    ],
    calculate: function (inputs) {
      var model = ROBOTS.find(function (r) { return r.name === inputs.robot_model; }) || ROBOTS[0];
      var cost = num(inputs.robot_cost, model.price);
      if (!cost || cost < 1000) return { valid: false, errors: ['Enter robot purchase price.'] };
      var robotRate = model.rate;
      var manualRate = num(inputs.manual_rate, 2500);
      var sqft = num(inputs.cleanable_sqft, 30000);
      if (!manualRate || manualRate <= 0) return { valid: false, errors: ['Manual scrub rate must be greater than zero.'] };
      if (!robotRate || robotRate <= 0) return { valid: false, errors: ['Robot rate missing for this model.'] };
      if (manualRate >= robotRate) {
        return { valid: false, errors: ['Manual rate must be below robot rate (' + robotRate.toLocaleString() + ' sqft/hr) for savings.'] };
      }
      var hrsSaved = sqft / manualRate - sqft / robotRate;
      if (hrsSaved <= 0) return { valid: false, errors: ['Robot must save positive hours vs manual.'] };

      var shiftsWeek = num(inputs.shifts_per_week, 5);
      var weeks = num(inputs.weeks_per_year, 52);
      var util = clamp(num(inputs.utilization_pct, 100), 1, 100) / 100;
      var wage = num(inputs.loaded_labor_rate, 24);
      var shiftsYear = shiftsWeek * weeks * util;
      var laborSave = hrsSaved * shiftsYear * wage;
      var maintPct = model.maint || 0.15;
      var maint = cost * maintPct;
      var net = laborSave - maint;
      var payback = net > 0 ? cost / net : Infinity;
      var paybackLabel = isFinite(payback) ? payback.toFixed(1) + ' yr' : 'N/A';
      var monthsSub = isFinite(payback)
        ? (payback * 12).toFixed(1) + ' months to break-even'
        : 'Break-even n/a';
      var maintPctLabel = (maintPct * 100).toFixed(0);

      return {
        valid: true,
        primary: paybackLabel,
        secondary: '',
        secondaryLabel: '',
        payback_years: payback,
        net_annual: net,
        // Unified 3-up at top — never stack primary/secondary + bands
        bands: [],
        soWhat: 'Only proceed if payback clears and the floor plan is robot-friendly. Robots remove open-floor hours, not supervision.',
        metrics: [
          {
            label: 'Capital Payback',
            value: paybackLabel,
            sub: monthsSub,
            accent: true,
            hero: true
          },
          {
            label: 'Gross Labor Savings',
            value: fmt$(laborSave),
            sub: hrsSaved.toFixed(2) + ' hrs/shift displaced'
          },
          {
            label: 'Net Annual Benefit',
            value: fmt$(net),
            sub: 'Less ' + maintPctLabel + '% software/maint reserve'
          }
        ],
        rows: [
          { label: 'Model', value: model.name },
          { label: 'Catalog list price', value: fmt$(model.price) },
          { label: 'Purchase price used', value: fmt$(cost) },
          { label: 'Robot rate', value: robotRate.toLocaleString() + ' sqft/hr' },
          { label: 'Manual rate', value: manualRate.toLocaleString() + ' sqft/hr' },
          { label: 'Hours saved / shift', value: hrsSaved.toFixed(2) + ' hr' },
          { label: 'Shifts / year (after utilization)', value: shiftsYear.toFixed(0) },
          { label: 'Gross annual labor savings', value: fmt$(laborSave) },
          { label: 'Maint. reserve (' + maintPctLabel + '%)', value: fmt$(maint) },
          { label: 'Net annual benefit', value: fmt$(net) },
          { label: 'Payback', value: paybackLabel }
        ]
      };
    }
  });

  reg('equipment-financing-comparator', {
    title: 'Equipment Financing Comparator', blurb: 'Loan vs lease monthly comparison.', primaryLabel: 'Best monthly',
    fields: [
      { id: 'price', label: 'Equipment price ($)', type: 'number', default: 35000 },
      { id: 'loan_apr', label: 'Loan APR (%)', type: 'number', default: 7.5, step: 0.1 },
      { id: 'loan_term_months', label: 'Loan term (months)', type: 'number', default: 60 },
      { id: 'lease_monthly', label: 'Lease monthly ($)', type: 'number', default: 650 },
      { id: 'lease_term_months', label: 'Lease term (months)', type: 'number', default: 60, advanced: true }
    ],
    calculate: function (inputs) {
      var price = num(inputs.price);
      if (!price || price < 1000) return { valid: false, errors: ['Enter equipment price (min $1,000).'] };
      var apr = num(inputs.loan_apr, 7.5);
      if (apr < 0) return { valid: false, errors: ['Loan APR cannot be negative.'] };
      var loanTerm = Math.max(1, Math.round(num(inputs.loan_term_months, 60)));
      var leaseTerm = Math.max(1, Math.round(num(inputs.lease_term_months, 60)));
      var leaseMo = Math.round(num(inputs.lease_monthly, 650) * 100) / 100;
      if (!leaseMo || leaseMo <= 0) return { valid: false, errors: ['Enter lease monthly payment.'] };
      // Round payment to cents so monthly × term matches displayed total.
      var loanMo = Math.round(loanPayment(price, apr, loanTerm) * 100) / 100;
      var loanTotal = Math.round(loanMo * loanTerm * 100) / 100;
      var leaseTotal = Math.round(leaseMo * leaseTerm * 100) / 100;
      var bestMo = Math.min(loanMo, leaseMo);
      var recMo = loanMo <= leaseMo ? 'Loan' : 'Lease';
      var recTotal = loanTotal <= leaseTotal ? 'Loan' : 'Lease';
      var saveMo = Math.round(Math.abs(loanMo - leaseMo) * 100) / 100;
      var cashEdge = Math.round(Math.abs(loanTotal - leaseTotal) * 100) / 100;
      // Full sentence only — web template already prefixes "Recommended:" (never "Lease: Lease…")
      var recLine = recMo === 'Lease'
        ? ('Leasing delivers a ' + fmt$(saveMo) + '/mo working capital advantage (' + fmt$(cashEdge) +
          ' total cash edge). Choose the loan only if retaining full machine equity and salvage value at Month ' +
          loanTerm + ' is required.')
        : ('Loan purchase delivers a ' + fmt$(saveMo) + '/mo payment edge (' + fmt$(cashEdge) +
          ' total cash edge) and retains machine equity at term end. Choose the lease only if preserving monthly working capital outweighs ownership.');
      if (recTotal !== recMo) {
        recLine += ' Over the terms shown, ' + recTotal + ' still wins on total cash paid.';
      } else if (loanTerm !== leaseTerm) {
        recLine += ' Totals use each option\'s own term (' + loanTerm + ' vs ' + leaseTerm + ' mos).';
      }
      return {
        valid: true,
        primary: fmt$(bestMo) + '/mo',
        // Unified 3-up at top — never stack primary/secondary + bands
        secondary: '',
        secondaryLabel: '',
        recommended: recLine,
        reason: '',
        soWhat: 'Pick the path that fits monthly cash, then confirm payback still works. Cash flow kills more buys than interest rate.',
        bands: [],
        metrics: [
          {
            label: 'Optimal cash path',
            value: fmt$(bestMo) + '/mo',
            sub: recMo === 'Lease' ? 'Lease structure' : 'Loan purchase',
            accent: true,
            hero: true
          },
          {
            label: 'Loan payment',
            value: fmt$(loanMo) + '/mo',
            sub: apr.toFixed(1) + '% APR · ' + loanTerm + ' mos'
          },
          {
            label: 'Monthly cash edge',
            value: '+' + fmt$(saveMo) + '/mo',
            sub: recMo + ' saves ' + fmt$(cashEdge) + ' total',
            tone: 'ok'
          }
        ],
        rows: [
          { label: 'Loan monthly', value: fmt$(loanMo) },
          { label: 'Lease monthly', value: fmt$(leaseMo) },
          { label: 'Monthly savings (' + recMo + ')', value: fmt$(saveMo) },
          { label: 'Loan total (' + loanTerm + ' mos)', value: fmt$(loanTotal) },
          { label: 'Lease total (' + leaseTerm + ' mos)', value: fmt$(leaseTotal) },
          { label: 'Total cash edge', value: recTotal + ' by ' + fmt$(cashEdge) }
        ]
      };
    }
  });

  reg('franchise-comparison-matrix', {
    title: 'Franchise Comparison Matrix', blurb: 'Compare franchise fee, royalty, and Item 19 scenarios.', primaryLabel: 'Best year-1 fit',
    fields: [
      { id: 'franchise_fee', label: 'Franchise fee budget ($)', type: 'number', default: 10000 },
      { id: 'royalty_pct', label: 'Max royalty (%)', type: 'number', default: 10, step: 0.1 },
      { id: 'projected_revenue', label: 'Projected gross revenue ($/yr)', type: 'number', default: 75000, advanced: true, fullWidth: true }
    ],
    calculate: function (inputs) {
      var rev = num(inputs.projected_revenue, 75000);
      if (!rev || rev <= 0) return { valid: false, errors: ['Enter projected gross revenue ($/yr).'] };
      var feeBudget = num(inputs.franchise_fee, 10000);
      var maxRoyPct = num(inputs.royalty_pct, 10);
      if (feeBudget < 0 || maxRoyPct < 0) return { valid: false, errors: ['Budgets cannot be negative.'] };
      var maxRoy = maxRoyPct / 100;

      function yr1(f) { return f.fee + rev * (f.royalty + f.ad); }
      function fits(f) { return f.fee <= feeBudget && f.royalty <= maxRoy; }

      var matches = FRANCHISES.filter(fits).slice().sort(function (a, b) { return yr1(a) - yr1(b); });
      var list = matches.length
        ? matches
        : FRANCHISES.slice().sort(function (a, b) { return yr1(a) - yr1(b); });

      var rows = list.map(function (f, i) {
        var pct = (f.royalty + f.ad) * 100;
        var inBudget = fits(f);
        return {
          label: f.name,
          value: inBudget ? 'Fits' : 'Over budget',
          target: !!(matches.length && i === 0),
          meta: [
            { k: 'Initial fee', v: fmt$(f.fee) },
            { k: 'Royalty + ad', v: pct.toFixed(0) + '%' },
            { k: 'Year-1 cost', v: fmt$(yr1(f)) },
            { k: 'Item 19 range', v: fmt$(f.item19_low) + ' - ' + fmt$(f.item19_high) }
          ]
        };
      });

      var best = list[0];
      var bestYr1 = yr1(best);
      var bestRoyPct = ((best.royalty + best.ad) * 100).toFixed(0);
      var fitCount = matches.length;
      var revK = Math.round(rev / 1000);
      var narrative = fitCount
        ? fitCount + ' brand(s) fit your fee/royalty caps. Sorted by lowest year-1 cost at your revenue. Item 19 = gross revenue, not profit, verify current FDD.'
        : 'No brand fit your fee/royalty caps; showing all sorted by year-1 cost. Item 19 = gross revenue, not profit, verify current FDD.';

      var pdfFranchiseRows = list.map(function (f, i) {
        var pct = (f.royalty + f.ad) * 100;
        var inBudget = fits(f);
        return {
          brand: f.name,
          status: inBudget ? 'Fits' : 'Over budget',
          fee: fmt$(f.fee),
          royalty: pct.toFixed(0) + '%',
          // Spaced ASCII hyphen — never Unicode en-dash (Helvetica "?" artifact)
          item19: fmt$(f.item19_low) + ' - ' + fmt$(f.item19_high),
          year1: fmt$(yr1(f)),
          recommended: !!(fitCount && i === 0 && inBudget)
        };
      });

      return {
        valid: true,
        primary: best.name,
        secondary: '',
        secondaryLabel: '',
        // Pill = fit count (not brand name, hero already shows the winner).
        statusPill: {
          label: fitCount ? (fitCount + ' fit') : 'None fit',
          level: fitCount ? 'ok' : 'warn'
        },
        reason: fitCount ? 'Lowest year-1 cost among brands that fit your caps.' : null,
        narrative: narrative,
        soWhat: 'Favor the year-1 fit you can fund, then stress real revenue after royalties. Royalty is forever; Item 19 is not your P&L.',
        // Unified 3-up at top — never stack primary/secondary + bands
        bands: [],
        metrics: [
          {
            label: 'Best Year-1 Fit',
            value: best.name,
            sub: fitCount
              ? (fitCount + ' brand(s) match budget caps')
              : '0 brand(s) match budget caps',
            accent: true,
            hero: true
          },
          {
            label: 'Initial Franchise Fee',
            value: fmt$(best.fee),
            sub: 'Licensing & initial package'
          },
          {
            label: 'Year-1 All-In Cost',
            value: fmt$(bestYr1),
            sub: 'Fee + ' + bestRoyPct + '% royalty on $' + revK + 'k rev'
          }
        ],
        pdfFranchiseRows: pdfFranchiseRows,
        rows: rows
      };
    }
  });

  reg('pfas-state-lookup', {
    title: 'PFAS State Lookup', blurb: 'PFAS cleaning-product ban status by state.', primaryLabel: 'Status',
    fields: [{ id: 'state', label: 'State', type: 'select', default: 'MN', options: stateOpts() }],
    calculate: function (inputs) { return S.pfasLookup(inputs.state); }
  });

  reg('voc-compliance', {
    title: 'VOC Compliance Lookup', blurb: 'Compare product VOC to state limits by category.', primaryLabel: 'Compliance',
    fields: [
      { id: 'state', label: 'Jurisdiction', type: 'select', default: 'California', options: vocStateOpts().length ? vocStateOpts() : [{ value: 'California', label: 'California' }] },
      { id: 'category', label: 'Product category', type: 'select', default: '', fullWidth: true, options: vocCategoryOpts() },
      { id: 'voc_unit', label: 'VOC input unit', type: 'select', default: 'pct', options: [
        { value: 'pct', label: 'Percent by weight' },
        { value: 'gL', label: 'Grams per liter (g/L)' }
      ]},
      { id: 'product_voc_pct', label: 'Product VOC value', type: 'number', default: 2 }
    ],
    calculate: function (inputs) {
      var cat = (D.voc_limits && D.voc_limits.limits_by_category || []).find(function (c) { return c.category === inputs.category; });
      if (!cat) return { valid: false, errors: ['Select a product category.'] };
      var jurisdiction = inputs.state || '—';
      var st = String(jurisdiction).toLowerCase();
      var limitPct = st.indexOf('california') >= 0 ? cat.carb_pct
        : st.indexOf('new york') >= 0 ? cat.ny_2022_pct
        : cat.otc_other_pct;
      var voc = num(inputs.product_voc_pct, 0);
      var useGl = inputs.voc_unit === 'gL';
      // Dataset is wt% today; explicit g/L columns are optional. Aqueous approx: 1 wt% ≈ 10 g/L.
      var explicitGl = st.indexOf('california') >= 0
        ? (cat.carb_gl || cat.limit_gl)
        : (cat.otc_gl || cat.limit_gl || cat.ny_gl);
      var limitGl = explicitGl != null ? explicitGl : (limitPct != null ? limitPct * 10 : null);
      var limit = useGl ? limitGl : limitPct;
      if (limit == null || !isFinite(limit)) {
        return { valid: false, errors: ['No VOC limit for this jurisdiction/category.'] };
      }
      var compliant = voc <= limit;
      var approxNote = useGl && explicitGl == null
        ? ' g/L limit approximated from wt% x 10 (aqueous).'
        : '';
      var citation = cat.citation || 'CARB / OTC Model Rule';
      var limDisp = useGl
        ? (Number(limit).toFixed(1) + ' g/L')
        : (Number(limit).toFixed(1) + '%');
      var vocDisp = useGl
        ? (Number(voc).toFixed(1) + ' g/L')
        : (Number(voc).toFixed(1) + '%');
      var delta = voc - limit;
      var deltaDisp = (delta > 0 ? '+' : '') + Number(delta).toFixed(1) + (useGl ? ' g/L' : '%');
      var statusLabel = compliant ? 'Compliant' : 'Over Limit';

      return {
        valid: true,
        primary: statusLabel,
        secondary: '',
        secondaryLabel: '',
        // Keep flag for handoff Healthy/At-risk copy — never duplex a loose status pill
        flag: compliant ? 'Healthy' : 'At-risk',
        hideStatusPill: true,
        statusPill: null,
        soWhat: compliant
          ? 'Within the state limit, still confirm the SDS and label for this category. The label can still fail the state VOC category.'
          : 'Non-compliant SKUs need a substitute before the next order. The label can still fail the state VOC category.',
        // Unified 3-up at top — never solitary PRIMARY RESULT + loose Over limit pill
        bands: [],
        metrics: [
          {
            label: 'Compliance Status',
            value: statusLabel,
            sub: compliant ? 'Meets state threshold' : 'Sales prohibited in state',
            accent: true,
            hero: true,
            tone: compliant ? 'ok' : 'bad'
          },
          {
            label: 'Jurisdiction Limit',
            value: limDisp,
            sub: citation
          },
          {
            label: 'Formulation Delta',
            value: deltaDisp,
            sub: compliant ? 'Margin within cap' : 'Exceeds statutory cap',
            tone: compliant ? 'ok' : 'bad'
          }
        ],
        rows: [
          { label: 'Jurisdiction', value: jurisdiction },
          { label: 'Input unit', value: useGl ? 'g/L' : 'Percent by weight' },
          { label: 'Limit', value: limDisp + (approxNote ? ' (approx)' : '') },
          { label: 'Your product', value: vocDisp },
          { label: 'Category', value: cat.category },
          { label: 'Citation', value: citation }
        ],
        narrative: compliant
          ? ('Within ' + jurisdiction + ' limit for ' + cat.category + '.' + approxNote)
          : ('Over ' + jurisdiction + ' limit for ' + cat.category + '.' + approxNote)
      };
    }
  });

  reg('sales-tax-calculator', {
    title: 'Sales Tax Calculator', blurb: 'Illustrative state + local tax estimate on janitorial invoices (not legal advice).', primaryLabel: 'Estimated Sales Tax',
    fields: [
      { id: 'state', label: 'State', type: 'select', default: 'TX', options: stateOpts() },
      { id: 'subtotal', label: 'Invoice subtotal ($)', type: 'number', default: 2500 },
      { id: 'local_rate', label: 'Local add-on (%)', type: 'number', default: 0, step: 0.01, advanced: true }
    ],
    calculate: function (inputs) {
      var abbr = String(inputs.state || 'TX').toUpperCase();
      var known = !!STATE_TAX[abbr];
      var st = STATE_TAX[abbr] || STATE_TAX.OTHER;
      var sub = num(inputs.subtotal);
      if (!sub || sub < 0) return { valid: false, errors: ['Enter invoice subtotal.'] };
      var localPct = num(inputs.local_rate, 0);
      if (localPct < 0) return { valid: false, errors: ['Local add-on cannot be negative.'] };
      var local = localPct / 100;
      // When illustrative taxability is exempt / no state tax, local add-on is ignored (user can still see it).
      var stateRate = st.taxable ? st.rate : 0;
      var localApplied = st.taxable ? local : 0;
      var eff = stateRate + localApplied;
      var stateTax = Math.round(sub * stateRate * 100) / 100;
      var localTax = Math.round(sub * localApplied * 100) / 100;
      var tax = Math.round((stateTax + localTax) * 100) / 100;
      var total = Math.round((sub + tax) * 100) / 100;
      var rows = [
        { label: 'Taxable? (illustrative)', value: st.taxable ? 'Often taxable' : 'Often exempt / no state tax' },
        { label: 'State rate', value: fmtPct(stateRate * 100, 2) + (known ? '' : ' (generic fallback)') },
        { label: 'Local add-on', value: st.taxable ? fmtPct(localPct, 2) : 'Not applied (exempt model)' },
        { label: 'Combined rate', value: fmtPct(eff * 100, 2) },
        { label: 'Tax amount', value: fmt$(tax) },
        { label: 'Invoice total', value: fmt$(total) },
        { label: 'Reference', value: st.statute }
      ];
      return {
        valid: true,
        primary: fmt$(tax),
        secondary: '',
        secondaryLabel: '',
        // Unified 3-up at top — never stack primary/secondary + State/Local/Tax bands
        bands: [],
        soWhat: 'Use the estimate to set invoice line structure, then verify nexus rules. Wrong service vs supply split gets expensive at audit time.',
        metrics: [
          {
            label: 'Estimated Sales Tax',
            value: fmt$(tax),
            sub: st.taxable
              ? (fmt$(stateTax) + ' State + ' + fmt$(localTax) + ' Local')
              : 'Exempt / no state tax model',
            accent: true,
            hero: true
          },
          {
            label: 'Combined Tax Rate',
            value: fmtPct(eff * 100, 2),
            sub: st.taxable
              ? (fmtPct(stateRate * 100, 2) + ' State + ' + fmtPct(localPct, 2) + ' Local')
              : 'Local add-on not applied'
          },
          {
            label: 'Total Invoiced Gross',
            value: fmt$(total),
            sub: 'Subtotal + tax remittance'
          }
        ],
        rows: rows,
        narrative: 'Janitorial taxability is fact-specific (state, locality, and what is on the invoice). Confirm with a tax advisor or state DOR, this is a coarse estimate only.'
      };
    }
  });

  reg('epa-list-n-matcher', {
    title: 'EPA List N Matcher', blurb: 'Sample List N-style disinfectant examples by pathogen, verify on EPA.gov.', primaryLabel: 'Sample matches',
    fields: [
      { id: 'pathogen', label: 'Target pathogen', type: 'select', default: 'SARS-CoV-2', options: [
        { value: 'SARS-CoV-2', label: 'SARS-CoV-2' }, { value: 'Norovirus', label: 'Norovirus' },
        { value: 'C. difficile', label: 'C. difficile' }, { value: 'Influenza A', label: 'Influenza A' }, { value: 'MRSA', label: 'MRSA' }
      ]}
    ],
    calculate: function (inputs) {
      var pathogen = String(inputs.pathogen || '').trim();
      var matches = LIST_N.filter(function (p) { return p.pathogen === pathogen; });
      if (!matches.length) return { valid: false, errors: ['No sample matches for pathogen.'] };

      var classLabel = /c\.?\s*diff/i.test(pathogen) ? 'Bacterial endospore (hardest)'
        : /noro/i.test(pathogen) ? 'Non-enveloped virus'
        : /mrsa|vre|staph/i.test(pathogen) ? 'Gram-positive bacteria'
        : /influenza|sars|covid/i.test(pathogen) ? 'Enveloped virus'
        : 'Clinical pathogen target';

      var minContact = matches.reduce(function (min, m) {
        var t = Number(m.contact_min);
        return isFinite(t) ? Math.min(min, t) : min;
      }, Infinity);
      if (!isFinite(minContact)) minContact = 0;
      var minDisp = (Math.round(minContact * 10) / 10).toFixed(1) + ' min';
      var matchCount = matches.length;
      var matchLabel = matchCount === 1 ? '1 Product' : (matchCount + ' Products');

      var pdfEpaMatchRows = matches.map(function (m) {
        return {
          product: m.product,
          epa: m.epa,
          chemistry: m.ingredient,
          dwell: String(m.contact_min) + ' min'
        };
      });

      return {
        valid: true,
        primary: matchLabel,
        secondary: '',
        secondaryLabel: '',
        soWhat: 'Shortlist candidates, then confirm EPA reg. no. and contact time on EPA.gov. Skip labeled dwell and the kill claim dies with it.',
        // Unified 3-up — never solitary SAMPLE MATCHES / PRIMARY RESULT card
        bands: [],
        metrics: [
          {
            label: 'Target Pathogen',
            value: pathogen,
            sub: classLabel,
            accent: true,
            hero: true
          },
          {
            label: 'Verified Matches',
            value: matchLabel,
            sub: 'EPA-registered formulations'
          },
          {
            label: 'Min Contact Time',
            value: minDisp,
            sub: 'Mandatory surface wet dwell'
          }
        ],
        pdfEpaMatchRows: pdfEpaMatchRows,
        // Web list keeps compact rows; PDF uses structured 4-col matrix
        rows: matches.map(function (m) {
          return {
            label: m.product,
            value: m.epa + ' | ' + m.ingredient + ' | ' + m.contact_min + ' min'
          };
        }),
        narrative: 'Demo sample only (' + LIST_N.length + ' rows). EPA List N is a living database, confirm EPA Reg. No. and label directions at epa.gov before use.'
      };
    }
  });

  reg('sds-finder', {
    title: 'SDS Finder', blurb: 'Sample SDS catalog search, always pull the current PDF from the manufacturer.', primaryLabel: 'Hazard Classification',
    actionLabel: 'Search',
    fields: [{
      id: 'product_name',
      label: 'Product',
      type: 'select',
      default: 'Virex II 256',
      fullWidth: true,
      options: SDS_STUB.map(function (p) {
        return { value: p.product_name, label: p.product_name + ' (' + p.manufacturer + ')' };
      })
    }],
    calculate: function (inputs) {
      var q = (inputs.product_name || '').trim().toLowerCase();
      if (!q) return { valid: false, errors: ['Choose a product.'] };
      var matches = SDS_STUB.filter(function (p) { return p.product_name.toLowerCase().indexOf(q) >= 0; });
      var rows = [];
      matches.forEach(function (m) {
        rows.push(
          { label: 'Product', value: m.product_name },
          { label: 'Manufacturer', value: m.manufacturer },
          { label: 'Hazard class', value: m.hazard },
          { label: 'SDS URL', value: m.sds_url || 'n/a' }
        );
      });
      var top = matches[0] || null;
      var profile = resolveSdsProfile(top);
      return {
        valid: true,
        primary: profile.classLabel,
        secondary: '',
        secondaryLabel: '',
        // Unified 3-up — never solitary "1 sample match(es)" PRIMARY RESULT
        bands: [],
        soWhat: 'Open the SDS for PPE, first aid, and VOC, then stock the cart accordingly. Yesterday\'s SDS is how crews get the wrong PPE.',
        metrics: [
          {
            label: 'Hazard Classification',
            value: profile.classLabel,
            sub: profile.classSub,
            accent: true,
            hero: true,
            tone: profile.classTone
          },
          {
            label: 'Active Chemistry',
            value: profile.chemLabel,
            sub: profile.chemSub
          },
          {
            label: 'Mandatory PPE Level',
            value: profile.ppeLabel,
            sub: profile.ppeSub
          }
        ],
        rows: rows,
        narrative: matches.length
          ? 'Sample catalog (' + SDS_STUB.length + ' products). Links may be manufacturer homepages, download the current SDS PDF before use.'
          : 'No sample match, request the current SDS PDF from your distributor or manufacturer.'
      };
    }
  });

  reg('insurance-comparison', {
    title: 'Insurance Comparison', blurb: 'Compare GL quotes and WC mod.', primaryLabel: 'Lower total',
    fields: [
      { id: 'gl_premium_a', label: 'GL premium A ($/yr)', type: 'number', default: 4200 },
      { id: 'gl_premium_b', label: 'GL premium B ($/yr)', type: 'number', default: 3800 },
      // text (not number): browsers strip trailing zeros on type=number — EMR must show "1.00"
      { id: 'wc_mod', label: 'WC experience mod', type: 'text', default: '1.00', placeholder: '1.00' },
      { id: 'wc_base_premium', label: 'WC base premium ($/yr)', type: 'number', default: 8500, advanced: true }
    ],
    calculate: function (inputs) {
      var mod = num(inputs.wc_mod, 1);
      var wcBase = num(inputs.wc_base_premium, 8500);
      var wc = wcBase * mod;
      var glA = num(inputs.gl_premium_a, 0);
      var glB = num(inputs.gl_premium_b, 0);
      var totalA = glA + wc;
      var totalB = glB + wc;
      var bWins = totalB < totalA;
      var aWins = totalA < totalB;
      var winner = bWins ? 'Quote B' : (aWins ? 'Quote A' : 'Quote A / B (tie)');
      var lower = Math.min(totalA, totalB);
      var delta = Math.abs(totalA - totalB);
      var modDisp = (isFinite(mod) ? mod : 0).toFixed(2);
      var modNote = mod <= 1 ? 'Credit/Neutral Mod' : 'Debit Surcharge';
      var monthlySave = delta / 12;

      return {
        valid: true,
        primary: fmt$(lower) + ' / yr',
        secondary: '',
        secondaryLabel: '',
        recommended: winner.indexOf('tie') >= 0 ? 'Quotes tie on total outlay' : winner,
        soWhat: 'Pick the lower total that still meets contract minimums. Cheap premium with a bad mod is not cheap.',
        // Unified 3-up — never solitary LOWER TOTAL / PRIMARY RESULT card
        bands: [],
        metrics: [
          {
            label: 'Optimal Package',
            value: fmt$(lower) + ' / yr',
            sub: winner + ' · Lowest Total Outlay',
            accent: true,
            hero: true
          },
          {
            label: 'Annual Spread',
            value: delta > 0 ? (fmt$(-delta) + ' / yr') : (fmt$(0) + ' / yr'),
            sub: delta > 0
              ? ('Saves ' + fmt$(monthlySave) + '/mo in cash flow')
              : 'No premium spread between quotes'
          },
          {
            label: 'WC Adjusted Premium',
            value: fmt$(wc) + ' / yr',
            sub: modDisp + ' EMR · ' + modNote
          }
        ],
        rows: [
          { label: 'Total A', value: fmt$(totalA) },
          { label: 'Total B', value: fmt$(totalB) },
          { label: 'WC (mod applied)', value: fmt$(wc) }
        ]
      };
    }
  });

  reg('osha-300-300a-log', {
    title: 'OSHA 300 / 300A Log', blurb: 'TRIR and DART from recordable cases.', primaryLabel: 'TRIR',
    fields: [
      { id: 'year', label: 'Log year', type: 'number', default: 2026 },
      { id: 'total_hours', label: 'Total hours worked', type: 'number', default: 416000 },
      { id: 'recordable_cases', label: 'Recordable cases', type: 'number', default: 3 },
      { id: 'dart_cases', label: 'DAW + restricted cases', type: 'number', default: 1 }
    ],
    calculate: function (inputs) {
      var hours = num(inputs.total_hours), cases = num(inputs.recordable_cases, 0), dartCases = num(inputs.dart_cases, 0);
      if (!hours) return { valid: false, errors: ['Total hours required.'] };
      var year = Math.round(num(inputs.year, 2026)) || 2026;
      var benchmark = 3.2;
      var trir = (cases * 200000) / hours;
      var dartRate = (dartCases * 200000) / hours;
      var isRateHealthy = trir <= benchmark;
      var peerPct = benchmark > 0
        ? Math.round((Math.abs(benchmark - trir) / benchmark) * 100)
        : 0;
      var directiveCopy = isRateHealthy
        ? 'TRIR and DART outperform industry benchmarks. Maintain current toolbox talks and safety protocols to protect workers\' comp mod.'
        : 'High TRIR/DART exceeds custodial averages — audit slip/fall hazards, chemical handling, and retraining before policy renewal.';
      return {
        valid: true,
        primary: trir.toFixed(2),
        secondary: '',
        secondaryLabel: '',
        // Keep flag for handoff Healthy/At-risk copy — status lives on Card 3 only
        flag: isRateHealthy ? 'Healthy' : 'At-risk',
        hideStatusPill: true,
        statusPill: null,
        soWhat: directiveCopy,
        bands: [],
        metrics: [
          {
            label: 'Recordable Rate (TRIR)',
            value: trir.toFixed(2),
            sub: 'NAICS 561720 peer avg: ' + benchmark.toFixed(1),
            accent: true,
            hero: true
          },
          {
            label: 'DART Incident Rate',
            value: dartRate.toFixed(2),
            sub: dartCases + ' lost / restricted case(s)'
          },
          {
            label: 'Safety Standing',
            value: isRateHealthy ? 'Healthy' : 'Elevated Risk',
            sub: isRateHealthy
              ? (peerPct + '% below peer average')
              : (peerPct + '% above peer average'),
            tone: isRateHealthy ? 'ok' : 'bad'
          }
        ],
        rows: [
          { label: 'Log year', value: String(year) },
          { label: 'TRIR', value: trir.toFixed(2) },
          { label: 'DART', value: dartRate.toFixed(2) },
          { label: 'Benchmark NAICS 561720', value: '3.2' }
        ],
        narrative: 'OSHA ' + year + ' log. TRIR = (cases x 200,000) / hours. DART = (dart_cases x 200,000) / hours.'
      };
    }
  });

  reg('tax-deduction-finder', {
    title: 'Tax Deduction Finder',
    blurb: 'Deductions by entity type and revenue.',
    primaryLabel: 'Deductions',
    actionLabel: 'Generate',
    fields: [
      { id: 'entity_type', label: 'Entity type', type: 'select', default: 'llc', options: [
        { value: 'sole_prop', label: 'Sole proprietorship' }, { value: 'llc', label: 'LLC' },
        { value: 's_corp', label: 'S-Corp' }, { value: 'c_corp', label: 'C-Corp' }
      ]},
      { id: 'annual_revenue', label: 'Annual revenue ($)', type: 'number', default: 750000 }
    ],
    calculate: function (inputs) {
      var et = String(inputs.entity_type || 'llc');
      var list = TAX_DEDUCTIONS[et] || TAX_DEDUCTIONS.llc;
      var entityCards = {
        sole_prop: { value: 'Sole Proprietor', sub: 'Standard schedule C' },
        llc: { value: 'LLC (Pass-Through)', sub: 'Standard schedule C / 1065' },
        s_corp: { value: 'S-Corporation', sub: 'Corporate pass-through status' },
        c_corp: { value: 'C-Corporation', sub: 'Separate corporate taxpayer' }
      };
      var card = entityCards[et] || entityCards.llc;
      var rev = num(inputs.annual_revenue, 0);
      var count = list.length;
      var countLabel = count === 1 ? '1 Category' : (count + ' Categories');

      var pdfTaxDeductRows = list.map(function (d) {
        return {
          category: d.name,
          irc: d.irc,
          limit: d.limit,
          rule: d.rule || 'Confirm ordinary and necessary treatment with your CPA.'
        };
      });

      return {
        valid: true,
        primary: countLabel,
        secondary: '',
        secondaryLabel: '',
        hideStatusPill: true,
        statusPill: null,
        soWhat: 'Bring the shortlist to your accountant with receipts and entity type. Missed write-offs are silent margin leaks.',
        // Unified 3-up — never asymmetrical 2-card DEDUCTIONS / DETAIL header
        bands: [],
        metrics: [
          {
            label: 'Entity Structure',
            value: card.value,
            sub: card.sub,
            accent: true,
            hero: true
          },
          {
            label: 'Eligible Write-Offs',
            value: countLabel,
            sub: 'Active IRC provisions identified'
          },
          {
            label: 'Annual Revenue Base',
            value: rev > 0 ? (fmt$(rev) + ' / yr') : '—',
            sub: 'Commercial gross billings base'
          }
        ],
        pdfTaxDeductRows: pdfTaxDeductRows,
        // Web keeps Code / 2026 limit cards; PDF uses structured 4-col matrix
        rows: list.map(function (d) {
          return {
            label: d.name,
            meta: [
              { k: 'Code', v: d.irc },
              { k: '2026 limit', v: d.limit }
            ]
          };
        }),
        narrative: 'Confirm with a CPA before filing, state conformity and income limits apply. Limits shown for tax year 2026 (as of Aug 2026 IRS guidance).'
      };
    }
  });

  reg('union-contract-lookup', {
    title: 'Union Contract Lookup',
    blurb: 'Locality wage scale + fringe → loaded bill rate.',
    primaryLabel: 'Target bill rate',
    actionLabel: 'Lookup',
    d4: {
      basicSection: 'Scale lookup',
      advancedSection: 'Burden, overhead & margin'
    },
    unionData: UNION_DATA,
    scaData: SCA_SAMPLES,
    marketData: MARKET_SAMPLES,
    fields: [
      { id: 'state', label: 'State', type: 'select', default: 'NY', options: wageFloorCoveredStateOpts() },
      {
        id: 'mode',
        label: 'Mode',
        type: 'select',
        default: 'cba',
        options: [
          { value: 'cba', label: 'CBA Union' },
          { value: 'sca', label: 'SCA Federal' },
          { value: 'market', label: 'Market / Living Wage' }
        ]
      },
      { id: 'locality', label: 'Locality', type: 'select', default: 'New York City', options: wageFloorLocalitiesForMode('cba', 'NY') },
      {
        id: 'cba_level',
        label: 'Wage level',
        type: 'select',
        default: 'top',
        options: [
          { value: 'entry', label: 'Entry' },
          { value: 'top', label: 'Top' },
          { value: 'supervisor', label: 'Supervisor' },
          { value: 'sca', label: 'SCA floor' },
          { value: 'median', label: 'Market median' },
          { value: 'p25', label: 'Market 25th' },
          { value: 'living', label: 'Living wage' }
        ]
      },
      {
        id: 'shift_mult',
        label: 'Shift premium',
        type: 'select',
        default: '1',
        options: [
          { value: '1', label: 'Straight time (1.0×)' },
          { value: '1.5', label: 'Time-and-a-half (1.5×)' },
          { value: '2', label: 'Double time (2.0×)' }
        ]
      },
      { id: 'benefits_pct', label: 'Extra benefits (%)', type: 'number', default: 2, advanced: true, hint: 'Keep low when fringe $/hr already covers H&W / pension.' },
      { id: 'wc_pct', label: 'Workers’ comp override (%)', type: 'number', default: '', advanced: true, hint: 'Blank = state seed WC %. Override with your mod class rate.' },
      { id: 'overhead_pct', label: 'Overhead (%)', type: 'number', default: 12, advanced: true },
      { id: 'target_margin', label: 'Target profit margin (%)', type: 'number', default: 35, advanced: true }
    ],
    calculate: function (inputs) {
      var state = String(inputs.state || '').toUpperCase();
      var modeReq = String(inputs.mode || 'cba').toLowerCase();
      var loc = (inputs.locality || '').trim();
      var syncFields = null;
      var autoNote = '';
      var mode = modeReq;

      function hasRows(m) {
        return wageFloorRowsForMode(m, state).length > 0;
      }

      if (mode === 'cba' && !hasRows('cba')) {
        if (hasRows('sca')) {
          mode = 'sca';
          autoNote = 'No CBA sample for this state — using SCA Federal floor.';
          syncFields = { mode: { value: 'sca' } };
        } else if (hasRows('market')) {
          mode = 'market';
          autoNote = 'No CBA sample for this state — using Market / Living Wage floor.';
          syncFields = { mode: { value: 'market' } };
        }
      }

      var stateRows = wageFloorRowsForMode(mode, state);
      if (!stateRows.length) {
        var covered = wageFloorCoveredLabels(modeReq);
        var hint = covered.length
          ? (' Try ' + covered.slice(0, 3).join(', ') +
            (covered.length > 3 ? ', or another covered state' : '') + '.')
          : '';
        return {
          valid: false,
          errors: ['No wage-floor sample for this state in ' + modeReq.toUpperCase() + ' mode.' + hint]
        };
      }

      if (!loc) {
        return { valid: false, errors: ['Select a locality with sample data before looking up.'] };
      }

      var rows = stateRows.filter(function (u) { return u.locality === loc; });
      if (!rows.length) rows = stateRows.slice(0, 1);
      var row = rows[0];

      var wage = 0;
      var fringe = 0;
      var sourceLabel = '';
      var level = String(inputs.cba_level || 'top').toLowerCase();
      var detailRows = [];

      if (mode === 'cba') {
        if (level === 'entry') wage = num(row.entry);
        else if (level === 'supervisor') wage = num(row.supervisor, row.top);
        else wage = num(row.top);
        fringe = num(row.fringe, 0);
        sourceLabel = row.union + ' · ' + (row.term || 'CBA sample');
        detailRows = [
          { label: 'Entry wage', value: fmt$(row.entry) + '/hr' },
          { label: 'Top wage', value: fmt$(row.top) + '/hr' },
          { label: 'Supervisor', value: fmt$(row.supervisor) + '/hr' },
          { label: 'Union / term', value: sourceLabel }
        ];
      } else if (mode === 'sca') {
        wage = num(row.sca_wage);
        fringe = num(row.hw_fringe, 0);
        sourceLabel = (row.wd_note || 'SCA sample') + ' · as of ' + (row.as_of || 'n/a');
        detailRows = [
          { label: 'WD note', value: sourceLabel }
        ];
        if (level !== 'sca' && level !== 'top' && level !== 'entry') {
          /* keep SCA floor regardless of CBA-oriented level pick */
        }
      } else {
        var p25 = num(row.p25);
        var median = num(row.median);
        var living = num(row.living_wage, median);
        var stateMin = num(row.state_min, 7.25);
        if (level === 'p25') wage = p25;
        else if (level === 'living') wage = living;
        else if (level === 'entry') wage = Math.max(p25, stateMin);
        else wage = median;
        fringe = 0;
        sourceLabel = 'BLS-style sample · ' + (row.as_of || 'n/a');
        detailRows = [
          { label: '25th percentile', value: fmt$(p25) + '/hr' },
          { label: 'Median', value: fmt$(median) + '/hr' },
          { label: 'Living wage', value: fmt$(living) + '/hr' },
          { label: 'State minimum', value: fmt$(stateMin) + '/hr' },
          { label: 'Source', value: sourceLabel }
        ];
      }

      if (!wage || wage < 7.25) {
        return { valid: false, errors: ['Wage floor sample is incomplete for this locality.'] };
      }

      var shiftMult = num(inputs.shift_mult, 1);
      var benefitsDefault = fringe > 0 ? 2 : 8;
      var br = S.billRateCalc({
        base_wage: wage,
        state: state,
        target_margin: inputs.target_margin,
        benefits_pct: inputs.benefits_pct !== undefined && inputs.benefits_pct !== ''
          ? inputs.benefits_pct
          : benefitsDefault,
        overhead_pct: inputs.overhead_pct,
        wc_pct: inputs.wc_pct,
        fringe_per_hr: fringe,
        shift_mult: shiftMult,
        skip_direct_costs: true,
        supplies_per_hr: 0,
        travel_per_hr: 0,
        equipment_per_hr: 0
      });
      if (!br.valid) return br;

      var modeLabel = mode === 'cba' ? 'CBA Union' : mode === 'sca' ? 'SCA Federal' : 'Market / Living Wage';
      var marginPct = num(inputs.target_margin, 35);
      var overheadPct = num(inputs.overhead_pct, 12);
      var levelDisp = level === 'entry' ? 'Entry'
        : level === 'supervisor' ? 'Supervisor'
        : level === 'sca' ? 'SCA floor'
        : level === 'p25' ? '25th percentile'
        : level === 'living' ? 'Living wage'
        : (mode === 'sca' ? 'SCA floor' : 'Top');
      var wageFloorSub = mode === 'cba'
        ? (String(row.union || 'CBA') + ' ' + levelDisp + ' Scale · ' + row.locality)
        : (modeLabel + ' · ' + row.locality);
      var fringeDisp = fringe > 0 ? fmt$(fringe) : '$0.00';
      var soWhatCopy = 'Use ' + fmt$(br.bill_rate) + '/hr as the compliant bill-rate floor from this sample scale, then verify the live CBA or SCA WD before you bid.';

      return {
        valid: true,
        primary: fmt$(br.bill_rate) + '/hr',
        secondary: '',
        secondaryLabel: '',
        syncFields: syncFields,
        // Mode badge only when auto-switched — never loose CBA Union pill under soWhat
        hideStatusPill: !autoNote,
        statusPill: autoNote
          ? { label: 'Auto-switched mode', level: 'warn', text: autoNote }
          : null,
        soWhat: soWhatCopy,
        bands: [],
        metrics: [
          {
            label: 'Target Bill Rate',
            value: fmt$(br.bill_rate) + '/hr',
            sub: Math.round(marginPct) + '% target margin · ' + Math.round(overheadPct) + '% overhead',
            hero: true,
            accent: true
          },
          {
            label: 'Base Wage Floor',
            value: fmt$(wage) + '/hr',
            sub: wageFloorSub
          },
          {
            label: 'Loaded Labor Cost',
            value: fmt$(br.loaded_wage) + '/hr',
            sub: 'Includes ' + fringeDisp + '/hr fringe + payroll taxes'
          }
        ],
        rows: detailRows.concat([
          { label: 'Fringe rate (H&W / Pension)', value: fringe > 0 ? (fmt$(fringe) + '/hr') : 'n/a' },
          { label: 'Total loaded labor cost', value: fmt$(br.loaded_wage) + '/hr' },
          { label: 'Shift premium', value: shiftMult.toFixed(1) + 'x' },
          { label: 'Locality', value: row.locality }
        ]),
        narrative: 'Sample floors for estimating only — verify current CBA language, SCA WD on SAM.gov, and local living-wage ordinances before bidding.',
        narrativeLabel: 'Note'
      };
    }
  });

  // Exposed for Floor Program parent→child sync (core form wiring) — MUST be before boot()
  global.OporaPadSelector = {
    finishOpts: padFinishOptsFor,
    defaultFinish: padDefaultFinish,
    clampFinish: padClampFinish,
    finishLabel: padFinishLabel,
    lookup: lookupPadMatrix,
    resolve: resolvePadProgram,
    dipSequence: padDipSequence,
    matrix: PAD_MATRIX
  };

  global.OporaFloorProgram = {
    profile: floorProfile,
    finishOpts: function (idx) { return finishOptsForProfile(floorProfile(idx)); },
    defaultFinish: function (idx) { return floorProfile(idx).defaultFinish; },
    clampFinish: function (idx, finish) { return clampFloorFinish(floorProfile(idx), finish); },
    clampEquipment: function (idx, equip) { return clampFloorEquipment(floorProfile(idx), equip); },
    equipmentWarning: function (idx, equip, shortName) {
      return floorEquipmentWarning(floorProfile(idx), equip, shortName);
    },
    database: FLOOR_DATABASE
  };

  if (global.OporaCalc && typeof global.OporaCalc.boot === 'function') {
    global.OporaCalc.boot();
  }

})(window);
